(function (angular) {
	'use strict';

	angular.module('kundenkarte-backend', [
		'ui.router',
		'ngSanitize',
		'ngCookies',
		'ngAnimate',
		'ui.bootstrap',
		'pascalprecht.translate',
		'restangular',
		'toaster',
		'angular-table',
		'ngFileUpload',
		'ngSanitize',
		'textAngular',
		'uiSwitch',
		'ui.bootstrap.datetimepicker',
		'as.sortable',
		'mwFormBuilder',
		'chart.js',
		'checklist-model',
		'xeditable',
		'ui.checkbox',
		'angular.filter',
		'btorfs.multiselect',

		'app.config',
		'app.run',
		'app.factory',
		'app.filter',
		'help',
		'pagination',
		'customers',
		'media',
		'content',
		'externallink',
		'contentgroup',
		'user',
		'mandant',
		'dashboard',
		'settings',
		'news',
		'admin',
		'shop',
		'vouchers',
		'chat',
		'events',
		'stores',
		'surveys',
		'derbybikes',
		'contests',
		'brands',
		'statistics',
		'website',
		'qr',
		'raffle',
	]);

	angular.module('ng-sortable', ['as.sortable']);
})(angular);

var globalConfig = {
	api: {
		// eslint-disable-next-line
		url: window.location.host.split('.')[0] === 'verwaltung' ? 'https://api-v2.' + window.location.host.split('.')[1] + '.kundenkarte-app.de' : 'https://api-v2.kundenkarte-app.de',
		// eslint-disable-next-line
		mediaUrl: window.location.host.split('.')[0] === 'verwaltung' ? 'https://media.' + window.location.host.split('.')[1] + '.kundenkarte-app.de' : 'https://media-v2.kundenkarte-app.de',
	},
	toastTimeout: 3000,
	defaults: {
		perPage: 25,
		viewType: 'table',
	},
	version: {
		current: '2.26.0-002',
		last: '0.0.0',
	},
};

(function (angular) {
	'use strict';
	var uiDatetimePickerConfig = {
		dateFormat: 'yyyy-MM-dd HH:mm',
		defaultTime: '00:00:00',
		html5Types: {
			date: 'yyyy-MM-dd',
			'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
			month: 'yyyy-MM',
		},
		initialPicker: 'date',
		reOpenDefault: false,
		enableDate: true,
		enableTime: true,
		buttonBar: {
			show: true,
			now: {
				show: true,
				text: 'Jetzt',
				cls: 'btn-sm btn-default',
			},
			today: {
				show: true,
				text: 'Heute',
				cls: 'btn-sm btn-default',
			},
			clear: {
				show: true,
				text: 'Leeren',
				cls: 'btn-sm btn-default',
			},
			date: {
				show: true,
				text: 'Datum',
				cls: 'btn-sm btn-default',
			},
			time: {
				show: true,
				text: 'Uhrzeit',
				cls: 'btn-sm btn-default',
			},
			close: {
				show: true,
				text: 'X',
				cls: 'btn-sm btn-default',
			},
			cancel: {
				show: false,
				text: 'Abbrechen',
				cls: 'btn-sm btn-default',
			},
		},
		closeOnDateSelection: true,
		closeOnTimeNow: true,
		appendToBody: false,
		altInputFormats: [],
		ngModelOptions: {},
		saveAs: false,
		readAs: false,
	};

	angular.module('app.config', []).config(configState).config(configTranslation).config(RestangularProvider).config(ChartJsProvider).constant('uiDatetimePickerConfig', uiDatetimePickerConfig);

	configState.$inject = ['$stateProvider', '$urlRouterProvider', '$locationProvider'];

	function configState($stateProvider, $urlRouterProvider, $locationProvider) {
		$stateProvider
			.state('start', {
				url: '',
				abstract: true,
				templateUrl: 'static/templates/start.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'LoggedoutController',
				controllerAs: 'vm',
			})

			.state('start.login', {
				url: '/login',
				views: {
					content: {
						templateUrl: 'static/templates/login.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('start.resetpassword', {
				url: '/resetpassword',
				views: {
					content: {
						templateUrl: 'static/templates/resetpassword.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('start.forgotpassword', {
				url: '/forgotpassword/:id/:code',
				views: {
					content: {
						templateUrl: 'static/templates/newpassword.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			.state('app', {
				url: '/app',
				abstract: true,
				templateUrl: 'static/templates/loggedin.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'LoggedinController',
				controllerAs: 'lvm',
			})
			.state('app.dashboard', {
				url: '/dashboard',
				views: {
					content: {
						templateUrl: 'static/templates/dashboard/start.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Help
			.state('app.help', {
				url: '/help',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/help/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.help.overview', {
				url: '/overview',
				views: {
					helpContent: {
						templateUrl: 'static/templates/help/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.help.changelog', {
				url: '/changelog',
				views: {
					helpContent: {
						templateUrl: 'static/templates/help/changelog.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### SETTINGS
			.state('app.settings', {
				url: '/settings',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/settings/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.settings.menu', {
				url: '/menu',
				views: {
					settingsContent: {
						templateUrl: 'static/templates/settings/menu.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.settings.legal', {
				url: '/legal',
				views: {
					settingsContent: {
						templateUrl: 'static/templates/settings/legal.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.settings.email', {
				url: '/email',
				views: {
					settingsContent: {
						templateUrl: 'static/templates/settings/email.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.settings.notify', {
				url: '/notify',
				views: {
					settingsContent: {
						templateUrl: 'static/templates/settings/notify.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### CUSTOMERS
			.state('app.customers', {
				url: '/customers',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/customers/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.customers.overview', {
				url: '/overview',
				views: {
					customersContent: {
						templateUrl: 'static/templates/customers/start.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.customers.detail', {
				url: '/detail/:id',
				views: {
					customersContent: {
						templateUrl: 'static/templates/customers/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.customers.customergroups', {
				url: '/groups',
				views: {
					customersContent: {
						templateUrl: 'static/templates/customers/groupslist.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.customers.customergroups-add', {
				url: '/groups/add',
				views: {
					customersContent: {
						templateUrl: 'static/templates/customers/groupsadd.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### MEDIA
			.state('app.media', {
				url: '/media',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/media/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.media.images', {
				url: '/images?page&perpage&folder',
				views: {
					mediaContent: {
						templateUrl: 'static/templates/media/images.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '24',
						squash: true,
					},
					folder: {
						value: '0',
						squash: true,
					},
				},
			})
			.state('app.media.files', {
				url: '/files?page&perpage&folder',
				views: {
					mediaContent: {
						templateUrl: 'static/templates/media/files.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '24',
						squash: true,
					},
					folder: {
						value: '0',
						squash: true,
					},
				},
			})
			.state('app.media.upload', {
				url: '/upload',
				views: {
					mediaContent: {
						templateUrl: 'static/templates/media/upload.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.media.upload-folder', {
				url: '/upload/:folder',
				views: {
					mediaContent: {
						templateUrl: 'static/templates/media/upload.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Content
			.state('app.content', {
				url: '/content',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/content/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.content.overview', {
				url: '/overview',
				views: {
					contentContent: {
						templateUrl: 'static/templates/content/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.content.edit', {
				url: '/edit/:id',
				views: {
					contentContent: {
						templateUrl: 'static/templates/content/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### ContentGroup
			.state('app.contentgroup', {
				url: '/contentgroup',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/contentgroup/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.contentgroup.overview', {
				url: '/overview',
				views: {
					contentGroupContent: {
						templateUrl: 'static/templates/contentgroup/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.contentgroup.edit', {
				url: '/edit/:id',
				views: {
					contentGroupContent: {
						templateUrl: 'static/templates/contentgroup/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.contentgroup.editcontent', {
				url: '/edit/:pgid/content/:id',
				views: {
					contentGroupContent: {
						templateUrl: 'static/templates/contentgroup/editcontent.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Website
			.state('app.website', {
				url: '/website',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/website/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.website.overview', {
				url: '/overview',
				views: {
					websiteContent: {
						templateUrl: 'static/templates/website/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### User
			.state('app.user', {
				url: '/user',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/user/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.user.overview', {
				url: '/overview?page&perpage',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.user.detail', {
				url: '/detail/:id',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.user.groups', {
				url: '/groups?page&perpage',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/groups.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.user.roles', {
				url: '/roles?page&perpage',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/roles.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.user.groups-detail', {
				url: '/groups/:id',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/groups-detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.user.edit', {
				url: '/edit',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.user.maintenance', {
				url: '/maintenance?page&perpage',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/maintenance.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.user.logout', {
				url: '/logout',
				views: {
					userContent: {
						templateUrl: 'static/templates/user/logout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### News
			.state('app.news', {
				url: '/news',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/news/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.news.overview', {
				url: '/overview?page&perpage',
				views: {
					newsContent: {
						templateUrl: 'static/templates/news/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.news.archive', {
				url: '/archive?page&perpage',
				views: {
					newsContent: {
						templateUrl: 'static/templates/news/archive.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.news.add', {
				url: '/add',
				views: {
					newsContent: {
						templateUrl: 'static/templates/news/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.news.edit', {
				url: '/edit/:id',
				views: {
					newsContent: {
						templateUrl: 'static/templates/news/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.news.groups', {
				url: '/groups?page&perpage',
				views: {
					newsContent: {
						templateUrl: 'static/templates/news/groups.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})

			// #### VOUCHERS
			.state('app.vouchers', {
				url: '/vouchers',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/vouchers/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.vouchers.overview', {
				url: '/overview?page&perpage',
				views: {
					vouchersContent: {
						templateUrl: 'static/templates/vouchers/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.vouchers.archive', {
				url: '/archive?page&perpage',
				views: {
					vouchersContent: {
						templateUrl: 'static/templates/vouchers/archive.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.vouchers.add', {
				url: '/add',
				views: {
					vouchersContent: {
						templateUrl: 'static/templates/vouchers/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.vouchers.edit', {
				url: '/edit/:id',
				views: {
					vouchersContent: {
						templateUrl: 'static/templates/vouchers/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Shop
			.state('app.shop', {
				url: '/shop',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/shop/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.shop.overview', {
				url: '/overview?page&perpage',
				views: {
					shopContent: {
						templateUrl: 'static/templates/shop/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.shop.add', {
				url: '/add',
				views: {
					shopContent: {
						templateUrl: 'static/templates/shop/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.shop.edit', {
				url: '/edit/:id',
				views: {
					shopContent: {
						templateUrl: 'static/templates/shop/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.shop.cart', {
				url: '/cart',
				views: {
					shopContent: {
						templateUrl: 'static/templates/shop/cart.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.shop.cart-detail', {
				url: '/cart/:id',
				views: {
					shopContent: {
						templateUrl: 'static/templates/shop/cart-detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Events
			.state('app.events', {
				url: '/events',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/events/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.events.overview', {
				url: '/overview?page&perpage',
				views: {
					eventsContent: {
						templateUrl: 'static/templates/events/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.events.archive', {
				url: '/archive?page&perpage',
				views: {
					eventsContent: {
						templateUrl: 'static/templates/events/archive.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.events.groups', {
				url: '/groups',
				views: {
					eventsContent: {
						templateUrl: 'static/templates/events/groups.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.events.add', {
				url: '/add',
				views: {
					eventsContent: {
						templateUrl: 'static/templates/events/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.events.edit', {
				url: '/edit/:id',
				views: {
					eventsContent: {
						templateUrl: 'static/templates/events/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Stores
			.state('app.stores', {
				url: '/stores',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/stores/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.stores.overview', {
				url: '/overview?page&perpage&category',
				views: {
					storesContent: {
						templateUrl: 'static/templates/stores/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
					category: {
						value: '',
						splash: true,
					},
				},
			})
			.state('app.stores.add', {
				url: '/add',
				views: {
					storesContent: {
						templateUrl: 'static/templates/stores/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.stores.edit', {
				url: '/edit/:id',
				views: {
					storesContent: {
						templateUrl: 'static/templates/stores/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.stores.categories', {
				url: '/categories?page&perpage',
				views: {
					storesContent: {
						templateUrl: 'static/templates/stores/categories.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})

			// #### Surveys
			.state('app.surveys', {
				url: '/surveys',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/surveys/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.surveys.overview', {
				url: '/overview?page&perpage',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '99999',
						squash: true,
					},
				},
			})
			.state('app.surveys.templates', {
				url: '/templates?page&perpage',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/templates.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '99999',
						squash: true,
					},
				},
			})
			.state('app.surveys.archive', {
				url: '/archive?page&perpage',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/archive.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '99999',
						squash: true,
					},
				},
			})
			.state('app.surveys.draft', {
				url: '/draft?page&perpage',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/draft.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '99999',
						squash: true,
					},
				},
			})
			.state('app.surveys.add', {
				url: '/add?template',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					template: {
						value: '0',
						squash: true,
					},
				},
			})
			.state('app.surveys.edit', {
				url: '/edit/:id',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.surveys.detail', {
				url: '/detail/:id',
				views: {
					surveysContent: {
						templateUrl: 'static/templates/surveys/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Chat
			.state('app.chat', {
				url: '/chat',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/chat/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.chat.overview', {
				url: '/overview',
				views: {
					chatContent: {
						templateUrl: 'static/templates/chat/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.chat.start', {
				url: '/start/:userId',
				views: {
					chatContent: {
						templateUrl: 'static/templates/chat/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.chat.detail', {
				url: '/detail/:id',
				views: {
					chatContent: {
						templateUrl: 'static/templates/chat/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Derby
			.state('app.derbybikes', {
				url: '/derbybikes',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/derbybikes/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.derbybikes.overview', {
				url: '/overview?page&perpage',
				views: {
					derbyContent: {
						templateUrl: 'static/templates/derbybikes/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: '25',
						squash: true,
					},
				},
			})
			.state('app.derbybikes.link', {
				url: '/link',
				views: {
					derbyContent: {
						templateUrl: 'static/templates/derbybikes/link.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.derbybikes.add', {
				url: '/add',
				views: {
					derbyContent: {
						templateUrl: 'static/templates/derbybikes/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.derbybikes.import', {
				url: '/import',
				views: {
					derbyContent: {
						templateUrl: 'static/templates/derbybikes/import.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.derbybikes.detail', {
				url: '/detail/:id',
				views: {
					derbyContent: {
						templateUrl: 'static/templates/derbybikes/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Contests
			.state('app.contests', {
				url: '/contests',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/contests/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.contests.overview', {
				url: '/overview',
				views: {
					contestsContent: {
						templateUrl: 'static/templates/contests/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.contests.add', {
				url: '/add',
				views: {
					contestsContent: {
						templateUrl: 'static/templates/contests/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.contests.edit', {
				url: '/edit/:id',
				views: {
					contestsContent: {
						templateUrl: 'static/templates/contests/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.contests.detail', {
				url: '/detail/:id',
				views: {
					contestsContent: {
						templateUrl: 'static/templates/contests/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Brands
			.state('app.brands', {
				url: '/brands',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/brands/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.brands.overview', {
				url: '/overview?page&perpage&category&letter',
				views: {
					brandsContent: {
						templateUrl: 'static/templates/brands/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
					letter: {
						value: '',
						splash: true,
					},
					category: {
						value: '',
						splash: true,
					},
				},
			})
			.state('app.brands.add', {
				url: '/add',
				views: {
					brandsContent: {
						templateUrl: 'static/templates/brands/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.brands.edit', {
				url: '/edit/:id',
				views: {
					brandsContent: {
						templateUrl: 'static/templates/brands/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.brands.categories', {
				url: '/categories?page&perpage',
				views: {
					brandsContent: {
						templateUrl: 'static/templates/brands/categories.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.brands.attributes', {
				url: '/attributes?page&perpage',
				views: {
					brandsContent: {
						templateUrl: 'static/templates/brands/attributes.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})

			// #### QR
			.state('app.qr', {
				url: '/qr',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/qr/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.qr.overview', {
				url: '/overview',
				views: {
					qrContent: {
						templateUrl: 'static/templates/qr/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
				params: {
					page: {
						value: '1',
						squash: true,
					},
					perpage: {
						value: globalConfig.defaults.perPage.toString(),
						squash: true,
					},
				},
			})
			.state('app.qr.add', {
				url: '/add',
				views: {
					qrContent: {
						templateUrl: 'static/templates/qr/new.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.qr.edit', {
				url: '/edit/:id',
				views: {
					qrContent: {
						templateUrl: 'static/templates/qr/edit.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.qr.detail', {
				url: '/detail/:id',
				views: {
					qrContent: {
						templateUrl: 'static/templates/qr/detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Statistics
			.state('app.statistics', {
				url: '/statistics',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/statistics/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.statistics.overview', {
				url: '/overview',
				views: {
					statisticsContent: {
						templateUrl: 'static/templates/statistics/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})

			// #### Admin
			.state('app.admin', {
				url: '/admin',
				abstract: true,
				views: {
					content: {
						templateUrl: 'static/templates/admin/layout.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.admin.overview', {
				url: '/overview',
				views: {
					adminContent: {
						templateUrl: 'static/templates/admin/overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.admin.groups', {
				url: '/groups',
				views: {
					adminContent: {
						templateUrl: 'static/templates/admin/groups-overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.admin.groups-detail', {
				url: '/groups/:id',
				views: {
					adminContent: {
						templateUrl: 'static/templates/admin/groups-detail.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			})
			.state('app.admin.roles', {
				url: '/roles',
				views: {
					adminContent: {
						templateUrl: 'static/templates/admin/roles-overview.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					},
				},
			});

		$urlRouterProvider.otherwise('login');
		$locationProvider.html5Mode(true);
	}

	configTranslation.$inject = ['$translateProvider'];

	function configTranslation($translateProvider) {
		$translateProvider
			.useStaticFilesLoader({
				prefix: 'static/lang/locale-',
				suffix: '.json?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			})
			.preferredLanguage('de')
			.useSanitizeValueStrategy(null);
		//.useSanitizeValueStrategy('sanitize');
	}

	RestangularProvider.$inject = ['RestangularProvider'];

	function RestangularProvider(RestangularProvider) {
		RestangularProvider.setBaseUrl(globalConfig.api.url);

		RestangularProvider.addResponseInterceptor(function (data, operation, what, url, response) {
			var extractedData;

			if (operation === 'getList' && url !== 'https://api.checklyhq.com/v1/dashboards/1958/incidents') {
				extractedData = data.result;

				if (data.status !== false) {
					extractedData.pagination = {
						total: response.headers('Total-Count'),
						pages: response.headers('Total-Pages'),
					};
				}
			} else {
				extractedData = data;
			}

			return extractedData;
		});
	}

	ChartJsProvider.$inject = ['ChartJsProvider'];
	function ChartJsProvider(ChartJsProvider) {
		// Configure all charts
		ChartJsProvider.setOptions({
			chartColors: ['#2980b9', '#FF8A80'],
			responsive: true,
		});
		// Configure all line charts
		ChartJsProvider.setOptions('line', {
			showLines: true,
		});
	}
})(angular);

/* global globalConfig */

(function(angular) {
	'use strict';

	angular.module('app.run', [])
		.run(runApp)
		.run(configRestangular)
		.run(configEditable);

	runApp.$inject = ['$user', '$cookies', '$state', '$timeout', '$location'];
	function runApp($user, $cookies, $state, $timeout, $location) {
		var userCookie = $cookies.getObject('user');
		if(angular.isDefined(userCookie)) {
			$user.cookieLogin(userCookie).then(
				null,
				function() {
					$timeout(function() {
						$state.go('start.login');
					});
				}
			);
		} else {
			$timeout(function() {
				$user.setReady();
				var path = $location.path();

				if(path.indexOf('login') < 0){
					if(path.indexOf('resetpassword') < 0){
						if(path.indexOf('forgotpassword') < 0){
							$state.go('start.login');
						}
					}
				}
			});
		}

		var viewTypeCookie = $cookies.getObject('viewtype');
		if(angular.isDefined(viewTypeCookie)) {
			globalConfig.defaults.viewType = viewTypeCookie;
		} else {
			$cookies.putObject('viewtype', 'table');
		}

		var lastVersionCookie = $cookies.getObject('lastversion');
		if(angular.isDefined(lastVersionCookie)) {
			globalConfig.version.last = lastVersionCookie;
		} else {
			$cookies.putObject('lastversion', '0.0.0');
		}
	}

	configRestangular.$inject = ['Restangular', '$state'];
	function configRestangular(Restangular, $state) {
		Restangular.setErrorInterceptor(function(response) {
			if(response.data.error.code === 2003) {
				$state.go('start.login');
				return false;
			}

			return true;
		});
	}

	configEditable.$inject = ['editableOptions', 'editableThemes'];
	function configEditable(editableOptions, editableThemes) {
		editableThemes.bs3.inputClass = 'input-sm';
		editableThemes.bs3.buttonsClass = 'btn-sm';
		editableOptions.theme = 'bs3';
	}


})(angular);

/* global pleaseWait */

(function (angular) {
	'use strict';

	angular.module('app.factory', [])
		.factory('Page', pageFactory)
		.factory('$loading', loading);

	function pageFactory() {
		var prefix = 'Bindungsplattform: ',
			title = prefix + ' ',
			bodyClasses = ['layout-full', 'start', 'gray'];

		return {
			title: getTitle,
			setTitle: setTitle,
			getBodyClasses: getBodyClasses,
			addBodyClasses: addBodyClasses,
			setBodyClasses: setBodyClasses
		};

		function getTitle() {
			return title;
		}

		function setBodyClasses(classes) {
			bodyClasses = classes;
		}

		function addBodyClasses(bclass) {
			bodyClasses.push(bclass);
		}

		function getBodyClasses() {
			return bodyClasses;
		}

		function setTitle(newTitle) {
			title = prefix + ' ' + newTitle;
		}
	}

	function loading() {
		var activeLoading = false;
		return {
			start: start,
			finish: finish
		};

		function start(message) {
			if(activeLoading === false) {
				var loadingMessage = message || 'Bitte warten...';

				activeLoading = pleaseWait({
					logo: '',
					backgroundColor: '#2980b9',
					loadingHtml: '<div class="loading-spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div><div class="loading-message">' + loadingMessage + '</div>'
				});
			}

			return true;
		}

		function finish() {
			if(activeLoading !== false) {
				activeLoading.finish();
				activeLoading = false;
			}
			return true;
		}
	}

})(angular);

/* global  _ */

(function (angular) {
	'use strict';

	angular.module('app.filter', []).filter('crop', cropFilter).filter('metadataAnswer', metadataAnswerFilter).filter('listToMatrix', listToMatrixFilter).filter('startFrom', startFrom);

	function cropFilter() {
		return function (input, limit, respectWordBoundaries, suffix) {
			if (input === null || angular.isUndefined(input) || limit === null || angular.isUndefined(limit) || limit === '') {
				return input;
			}
			if (angular.isUndefined(respectWordBoundaries)) {
				respectWordBoundaries = true;
			}
			if (angular.isUndefined(suffix)) {
				suffix = '...';
			}

			if (input.length <= limit) {
				return input;
			}

			limit = limit - suffix.length;

			var trimmedString = input.substr(0, limit);
			if (respectWordBoundaries) {
				return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(' '))) + suffix;
			}
			return trimmedString + suffix;
		};
	}

	function listToMatrixFilter() {
		function listToMatrix(list, elementsPerSubArray) {
			var matrix = [],
				i,
				k;

			for (i = 0, k = -1; i < list.length; i++) {
				if (i % elementsPerSubArray === 0) {
					k++;
					matrix[k] = [];
				}

				matrix[k].push(list[i]);
			}

			return matrix;
		}

		return function (list, elementsPerSubArray) {
			return listToMatrix(list, elementsPerSubArray);
		};
	}

	metadataAnswerFilter.$inject = [];
	function metadataAnswerFilter() {
		return function (input, field, select, output) {
			if (input === null || angular.isUndefined(input) || field === null || angular.isUndefined(field) || field === '' || select === null || angular.isUndefined(select) || select === '') {
				return input;
			}

			var tmpSelect = {};
			tmpSelect[field] = select;

			var tmpResult = _.find(input, tmpSelect);

			if (angular.isDefined(tmpResult)) {
				return tmpResult[output];
			} else {
				return input;
			}
		};
	}

	startFrom.$inject = [];
	function startFrom() {
		return function (input, start) {
			start = +start;
			return input.slice(start);
		};
	}
})(angular);

(function (angular) {
	'use strict';

	angular.module('settings', ['settings.factory', 'settings.controller']);
})(angular);

(function (angular) {
	'use strict';

	angular.module('settings.controller', []).controller('SettingsMenuController', MenuCtrl).controller('SettingsLegalController', LegalCtrl).controller('SettingsNotifyController', NotifyCtrl).controller('SettingsEmailController', EmailCtrl);

	MenuCtrl.$inject = ['$settings', '$loading', 'toaster'];
	function MenuCtrl($settings, $loading, toaster) {
		var vm = this;

		vm.menuItems = [];

		load();

		vm.save = function (key, value) {
			$loading.start();
			$settings.saveLegal(key, value).then(function () {
				$loading.finish();
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gespeichert!',
					body: 'Einstellung wurde erfolgreich gespeichert.',
					timeout: 5000,
					showCloseButton: true,
				});
			});
		};

		function load() {
			$settings.loadMenu().then(function (menuItems) {
				vm.menuItems = menuItems.items;
			});
		}
	}

	LegalCtrl.$inject = ['$settings', '$loading', 'toaster'];
	function LegalCtrl($settings, $loading, toaster) {
		var vm = this;
		vm.show = {
			imprint: false,
			agb: false,
			dataProtection: false,
		};

		vm.legalImprint = '';
		vm.legalAGB = '';
		vm.legalDataprotection = '';
		vm.url = '';

		vm.save = function (key, value) {
			$loading.start();
			$settings.saveLegal(key, value).then(function () {
				$loading.finish();
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gespeichert!',
					body: 'Einstellung wurde erfolgreich gespeichert.',
					timeout: 5000,
					showCloseButton: true,
				});
				load();
			});
		};

		load();

		function load() {
			$settings.legalImprit().then(function (imprint) {
				vm.legalImprint = imprint.value;
			});

			$settings.legalAGB().then(function (agb) {
				vm.legalAGB = agb.value;
			});

			$settings.legalDataprotection().then(function (dataProtection) {
				vm.legalDataprotection = dataProtection.value;
			});

			$settings.mandantUrl().then(function (url) {
				vm.url = url.value;
			});
		}
	}

	NotifyCtrl.$inject = ['$settings', '$mandant', '$loading', 'toaster'];
	function NotifyCtrl($settings, $mandant, $loading, toaster) {
		var vm = this;

		vm.notifyMailAddress = '';
		vm.notifyNewUser = false;
		vm.notifyNewEmail = false;
		vm.notifyDeleteUser = false;
		vm.notifyMaintenance = false;

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.update = function (key, value) {
			$loading.start();
			$settings.saveConfig(key, value).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich gespeichert!',
						body: 'Einstellung wurde erfolgreich gespeichert.',
						timeout: 5000,
						showCloseButton: true,
					});
					load();
				},
				function () {
					$loading.finish();
				}
			);
		};

		load();

		function load() {
			$settings.loadConfig('notify_mail_adress').then(function (notifyMailAddress) {
				vm.notifyMailAddress = notifyMailAddress.value;
			});

			$settings.loadConfig('notify_new_user').then(function (notifyNewUser) {
				vm.notifyNewUser = notifyNewUser.value;
			});

			$settings.loadConfig('notify_new_chat').then(function (notifyNewChat) {
				vm.notifyNewChat = notifyNewChat.value;
			});

			$settings.loadConfig('notify_delete_user').then(function (notifyDeleteUser) {
				vm.notifyDeleteUser = notifyDeleteUser.value;
			});

			$settings.loadConfig('notify_maintenance').then(function (notifyMaintenance) {
				vm.notifyMaintenance = notifyMaintenance.value;
			});
		}
	}

	EmailCtrl.$inject = ['$settings', '$loading', '$window', 'toaster'];
	function EmailCtrl($settings, $loading, $window, toaster) {
		var vm = this;
		vm.show = {
			greetings: false,
			address: false,
			addresstext: false,
		};
		vm.emails = [];
		vm.mailGreeting = '';
		vm.mailAddress = '';
		vm.mailAddressText = '';

		vm.save = function (key, value) {
			$loading.start();
			$settings.saveLegal(key, value).then(function () {
				$loading.finish();
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gespeichert!',
					body: 'Einstellung wurde erfolgreich gespeichert.',
					timeout: 5000,
					showCloseButton: true,
				});
				load();
			});
		};

		vm.saveEmail = function (email) {
			$loading.start();
			$settings.saveEmail(email).then(function () {
				$loading.finish();
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gespeichert!',
					body: 'E-Mail Text wurde erfolgreich gespeichert.',
					timeout: 5000,
					showCloseButton: true,
				});
				load();
			});
		};

		vm.sendTest = function (emailType) {
			var emailAddress = $window.prompt('An welche E-Mailadresse soll die Test-Email gesendet werden?', '');
			if (emailAddress !== null) {
				$loading.start();
				$settings.sendTestEmail(emailType, emailAddress).then(function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich versendet!',
						body: 'Test-Email wurde erfolgreich versendet.',
						timeout: 5000,
						showCloseButton: true,
					});
				});
			}
		};

		load();

		function load() {
			$settings.loadEmails().then(function (emails) {
				vm.emails = emails;
			});

			$settings.emailGretting().then(function (mailgreeting) {
				vm.mailGreeting = mailgreeting.value;
			});

			$settings.emailAddress().then(function (mailAddress) {
				vm.mailAddress = mailAddress.value;
			});

			$settings.emailAddressText().then(function (mailAddressText) {
				vm.mailAddressText = mailAddressText.value;
			});
		}
	}
})(angular);

(function (angular) {
	'use strict';

	angular.module('settings.factory', []).factory('$settings', SettingsFactory);

	SettingsFactory.$inject = ['$q', '$api', '$log'];
	function SettingsFactory($q, $api, $log) {
		return {
			loadConfig: loadConfig,
			saveConfig: saveConfig,

			loadMenu: loadMenu,

			emailGretting: emailGretting,
			emailAddress: emailAddress,
			emailAddressText: emailAddressText,

			legalImprit: legalImprit,
			legalAGB: legalAGB,
			legalDataprotection: legalDataprotection,

			mandantUrl: mandantUrl,

			saveLegal: saveLegal,
			sendTestEmail: sendTestEmail,
			saveEmail: saveEmail,
			loadEmails: loadEmails,
		};

		function loadConfig(key) {
			var q = $q.defer();

			$api
				.withToken()
				.all('mandants')
				.one('configs', key)
				.get()
				.then(
					function (config) {
						if (config.result.value === 'true' || config.result.value === 'false') {
							config.result.value = config.result.value === 'true';
						}

						q.resolve(config.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function saveConfig(key, value) {
			var q = $q.defer();

			if (typeof value == 'boolean') {
				value = value ? 'true' : 'false';
			}

			$api
				.withToken()
				.all('mandants')
				.one('configs', key)
				.customPUT({ value: value })
				.then(
					function (config) {
						q.resolve(config.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function loadMenu() {
			var q = $q.defer();

			$api
				.withToken()
				.one('menu', 0)
				.customGET('', {})
				.then(
					function (menu) {
						q.resolve(menu.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function legalImprit() {
			return loadConfig('imprint');
		}

		function emailGretting() {
			return loadConfig('mail_greeting');
		}

		function emailAddress() {
			return loadConfig('mail_address');
		}

		function emailAddressText() {
			return loadConfig('mail_address_text');
		}

		function legalAGB() {
			return loadConfig('agb_text');
		}

		function legalDataprotection() {
			return loadConfig('data_protection_regulation_text');
		}

		function mandantUrl() {
			return loadConfig('domain');
		}

		function saveLegal(key, value) {
			return saveConfig(key, value);
		}

		function sendTestEmail(emailType, emailAddress) {
			var q = $q.defer();

			$api
				.withToken()
				.all('mandants')
				.one('email', emailType)
				.all('test')
				.customPOST({ email: emailAddress })
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function saveEmail(email) {
			var q = $q.defer(),
				emailPut = {
					title: email.title,
					preheader: email.preheader,
					text: email.text,
					body: email.body,
				};

			$api
				.withToken()
				.all('mandants')
				.one('email', email.type)
				.customPUT(emailPut)
				.then(
					function (email) {
						q.resolve(email);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function loadEmails() {
			var q = $q.defer();

			$api
				.withToken()
				.all('mandants')
				.all('emails')
				.customGETLIST('', {})
				.then(
					function (emails) {
						q.resolve(emails);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('user', ['user.factory', 'user.controller', 'user.directive', 'user.filter']);

})(angular);

/* global detect */

(function (angular) {
	'use strict';

	angular.module('user.factory', []).factory('$user', UserFactory).factory('$api', RestangularAPI);

	RestangularAPI.$inject = ['Restangular', '$user', '$log'];

	function RestangularAPI(Restangular, $user, $log) {
		var user = $user.get();

		return {
			withToken: withToken,
			withoutToken: withoutToken,
		};

		function refreshUser() {
			user = $user.get();
		}

		function withToken() {
			refreshUser();
			if (angular.isDefined(user.token) && user.token !== '') {
				return Restangular.withConfig(function (RestangularConfigurer) {
					RestangularConfigurer.setDefaultHeaders({
						'API-Token': user.token,
						'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
						Authorization: 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU=',
						Accept: 'application/json, text/javascript',
						'Content-Type': 'application/json; charset=utf-8',
					});
				});
			} else {
				
				
				return withoutToken();
			}
		}

		function withoutToken() {
			return Restangular.withConfig(function (RestangularConfigurer) {
				RestangularConfigurer.setDefaultHeaders({
					'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
					Authorization: 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU=',
					Accept: 'application/json, text/javascript',
					'Content-Type': 'application/json; charset=utf-8',
				});
			});
		}
	}

	UserFactory.$inject = ['Restangular', '$q', '$cookies', '$log', '$rootScope'];

	function UserFactory(Restangular, $q, $cookies, $log, $rootScope) {
		var user = { ready: false, loggedin: false, token: null },
			cbFuncs = [],
			RestangularAPI = Restangular.withConfig(function (RestangularConfigurer) {
				RestangularConfigurer.setDefaultHeaders({
					'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
					Authorization: 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU=',
					Accept: 'application/json, text/javascript',
					'Content-Type': 'application/json; charset=utf-8',
				});
			}),
			// eslint-disable-next-line no-unused-vars
			userService = RestangularAPI.all('users'),
			RestangularWT = RestangularAPI,
			userWTService = RestangularWT.all('users'),
			userRoles = [];

		return {
			get: get,
			login: login,
			cookieLogin: cookieLogin,
			logout: logout,
			isLoggedin: isLoggedin,
			ready: ready,
			setReady: setReady,
			isReady: isReady,
			changeMandant: changeMandant,
			changePassword: changePassword,
			resetPassword: resetPassword,

			getUsers: getUsers,
			getUser: getUser,
			getUserMetadata: getUserMetadata,
			updateUserMetadata: updateUserMetadata,

			getCardTypes: getCardTypes,
			addNewCard: addNewCard,
			deleteCard: deleteCard,

			getInterests: getInterests,

			getGroupsList: getGroupsList,
			getRolesList: getRolesList,
			getGroup: getGroup,
			addGroup: addGroup,
			importGroup: importGroup,
			removeGroup: removeGroup,
			forceRemoveGroup: forceRemoveGroup,
			removeFromGroup: removeFromGroup,
			addToGroup: addToGroup,

			getRoles: getRoles,
			clearRoles: clearRoles,
			addRole: addRole,
			removeRole: removeRole,
			removeRolesFromGroup: removeRolesFromGroup,
			addRolesToGroup: addRolesToGroup,

			resendEmail: resendEmail,
			resetPasswordEmail: resetPasswordEmail,

			resyncReceipts: resyncReceipts,
			resyncUser: resyncUser,
			changeNumber: changeNumber,
			getUserLogs: getUserLogs,

			exportUsers: exportUsers,

			generateRandomPassword: generateRandomPassword,
			addUser: addUser,
			deleteUser: deleteUser,
			checkCode: checkCode,

			getList: getList,
			getMaintenanceList: getMaintenanceList,
			maintenanceAction: maintenanceAction,
		};

		function activateRestangularWT() {
			RestangularWT = Restangular.withConfig(function (RestangularConfigurer) {
				RestangularConfigurer.setDefaultHeaders({
					'API-Token': user.token,
					'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
					Authorization: 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU=',
					Accept: 'application/json, text/javascript',
					'Content-Type': 'application/json; charset=utf-8',
				});
			});
			userWTService = RestangularWT.all('users');
		}

		function deActivateRestangularWT() {
			RestangularWT = RestangularAPI;
			userWTService = RestangularWT.all('users');
		}

		function isReady(cb) {
			if (user.ready === true) {
				cb();
			} else {
				cbFuncs.push(cb);
			}
		}

		function get() {
			return user;
		}

		function isLoggedin() {
			return user.loggedin;
		}

		function ready() {
			return user.ready;
		}

		function setReady() {
			
			user.ready = true;
			for (var x = 0; x < cbFuncs.length; x++) {
				cbFuncs[x]();
			}
			cbFuncs = [];
		}

		/*
		function activateSupport() {
			RestangularWT.all('users')
				.all('supporthash')
				.customGET()
				.then(function (result) {
					FrontChat('identity', {
						email: user.email,
						name: user.first_name + ' ' + user.last_name,
						userHash: result.result,
						customFields: {
							mandantId: user.mandant.id,
							mandantName: user.mandant.name,
						},
					});
					//FrontChat('show');
				});
		}
		*/

		function login(username, password) {
			var ua = detect.parse(navigator.userAgent),
				browser = ua.browser.name,
				os = ua.os.name,
				q = $q.defer();

			RestangularAPI.all('login_backend')
				.post({
					username: username,
					password: password,
					browser: browser,
					os: os,
					uuid: '123456789',
				})
				.then(
					function (result) {
						var tmpUser = result.result;
						user = {
							ready: true,
							loggedin: true,
							id: tmpUser.id,
							email: tmpUser.email,
							level: tmpUser.level,
							token: tmpUser.device.token,
							active_mandant: tmpUser.device.mandant_id,
							mandants: tmpUser.mandants,
							device: tmpUser.device,
							first_name: tmpUser.first_name,
							last_name: tmpUser.last_name,
						};

						var expireDate = new Date();
						expireDate.setDate(expireDate.getDate() + 7);
						$cookies.putObject(
							'user',
							{
								id: user.id,
								device_id: user.device.id,
								token: user.token,
							},
							{ expires: expireDate }
						);

						activateRestangularWT();

						userWTService
							.one('devices', user.device.id)
							.customGET('', { with: 'mandant' })
							.then(function (device) {
								user.device = device.result;
								user.mandant = { id: device.result.mandant.id, name: device.result.mandant.name };
								//activateSupport();

								q.resolve();
							});
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function cookieLogin(cookie) {
			var q = $q.defer();

			user = {
				token: cookie.token,
				id: cookie.id,
				device_id: cookie.device_id,
			};

			activateRestangularWT();

			RestangularWT.one('users', user.id)
				.get()
				.then(
					function (result) {
						var tmpUser = result.result;

						userWTService
							.one('devices', user.device_id)
							.customGET('', { with: 'mandant' })
							.then(function (result) {
								var tmpDevice = result.result;

								user = {
									ready: true,
									loggedin: true,
									id: tmpUser.id,
									email: tmpUser.email,
									level: tmpUser.level,
									token: user.token,
									active_mandant: tmpDevice.mandant_id,
									mandants: tmpUser.mandants,
									device: tmpDevice,
									first_name: tmpUser.first_name,
									last_name: tmpUser.last_name,
								};

								var expireDate = new Date();
								expireDate.setDate(expireDate.getDate() + 7);
								$cookies.putObject(
									'user',
									{
										id: user.id,
										device_id: user.device.id,
										token: user.token,
									},
									{ expires: expireDate }
								);

								user.mandant = { id: tmpDevice.mandant.id, name: tmpDevice.mandant.name };
								//activateSupport();

								setReady();
								q.resolve();
							});
					},
					function (error) {
						
						$cookies.remove('user');
						q.reject();
					}
				);

			return q.promise;
		}

		function logout() {
			var q = $q.defer();

			userWTService
				.all('logout')
				.post()
				.then(function () {
					deActivateRestangularWT();
					//FrontChat('shutdown', { clearSession: true });
					$cookies.remove('user');
					clearRoles();
					user = { ready: true, loggedin: false, token: null };
					q.resolve();
				});

			return q.promise;
		}

		function changeMandant(id) {
			var q = $q.defer();

			userWTService
				.one('devices', user.device.id)
				.customPUT({ mandant_id: id })
				.then(
					function (result) {
						var tmpDevice = result.result;
						user.active_mandant = tmpDevice.mandant_id;
						$rootScope.$broadcast('mandantChanged');
						q.resolve();
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function changePassword(password, user_id) {
			var q = $q.defer();

			if (angular.isDefined(user_id) && user_id > 0 && user_id !== null) {
				RestangularAPI.one('users', user_id)
					.all('changepassword')
					.customPUT({
						password_old: password.old,
						password_new: password.new,
					})
					.then(
						function () {
							q.resolve();
						},
						function (error) {
							
							q.reject();
						}
					);
			} else {
				RestangularWT.one('users', user.id)
					.all('changepassword')
					.customPUT({
						password_old: password.old,
						password_new: password.new,
					})
					.then(
						function () {
							q.resolve();
						},
						function (error) {
							
							q.reject();
						}
					);
			}

			return q.promise;
		}

		function resetPassword(username) {
			var q = $q.defer();

			RestangularAPI.all('resetpassword')
				.post({ email: username })
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getList(page, perpage, search, fields, active, maintenance, sortField, sortDirection) {
			var q = $q.defer(),
				userList = {};

			

			if (perpage) {
				userList.perpage = perpage;
			} else {
				userList.perpage = 20;
			}

			if (page) {
				userList.page = page;
			} else {
				userList.page = 1;
			}

			if (angular.isDefined(active)) {
				userList.active = active;
			}

			if (angular.isArray(search)) {
				angular.forEach(search, function (tmpSearch) {
					if (tmpSearch.field === 'active' || tmpSearch.field === 'level') {
						userList[tmpSearch.field] = tmpSearch.text;
					} else if (tmpSearch.field === 'number') {
						userList['numbers:number'] = tmpSearch.text;
					} else {
						userList[tmpSearch.field] = 'LIKE(%' + tmpSearch.text + '%)';
					}
				});
			}

			if (angular.isArray(fields) && fields.length > 0) {
				userList.fields = fields.join(',');
			}

			if (sortField && sortDirection) {
				userList.sort = (sortDirection === 'asc' ? '+' : '-') + sortField;
			}

			RestangularWT.all('users')
				.customGETLIST('', userList)
				.then(
					function (tmpUsers) {
						q.resolve(tmpUsers);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getMaintenanceList(page, perpage) {
			var q = $q.defer(),
				userList = {};

			if (perpage) {
				userList.perpage = perpage;
			} else {
				userList.perpage = 20;
			}

			if (page) {
				userList.page = page;
			} else {
				userList.page = 1;
			}

			RestangularWT.all('maintenance')
				.customGETLIST('', userList)
				.then(
					function (tmpUsers) {
						q.resolve(tmpUsers);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getUsers() {
			var q = $q.defer();

			RestangularWT.all('users')
				.getList()
				.then(
					function (users) {
						q.resolve(users);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getUser(userId) {
			var q = $q.defer(),
				userGet = {
					with: 'groups',
				};

			RestangularWT.one('users', userId)
				.customGET('', userGet)
				.then(
					function (user) {
						q.resolve(user.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getUserMetadata(userId) {
			var q = $q.defer();

			RestangularWT.one('users', userId)
				.all('metadata')
				.getList()
				.then(
					function (metadata) {
						q.resolve(metadata);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function updateUserMetadata(userId, metadata) {
			var q = $q.defer();

			RestangularWT.one('users', userId)
				.all('metadata')
				.customPUT({ metadata: metadata })
				.then(
					function (metadata) {
						q.resolve(metadata);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getCardTypes() {
			var q = $q.defer(),
				cardList = {};

			RestangularWT.all('numbers')
				.all('types')
				.customGETLIST('', cardList)
				.then(
					function (tmpCardTypes) {
						q.resolve(tmpCardTypes);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function addNewCard(card) {
			var q = $q.defer(),
				tmpCard = {
					user_id: card.user_id,
					number: card.number,
					number_type_id: card.card_type,
					has_card: card.has_card,
				};

			RestangularWT.all('numbers')
				.post(tmpCard)
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function deleteCard(card_id) {
			var q = $q.defer();

			RestangularWT.one('numbers', card_id)
				.remove()
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getInterests() {
			var q = $q.defer(),
				interestsList = {};

			RestangularWT.all('interests')
				.customGETLIST('', interestsList)
				.then(
					function (tmpInterests) {
						q.resolve(tmpInterests);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getGroupsList(page, perpage, fields) {
			var q = $q.defer(),
				groupList = { visible: 1 };

			if (perpage) {
				groupList.perpage = perpage;
			} else {
				groupList.perpage = 20;
			}

			if (page) {
				groupList.page = page;
			} else {
				groupList.page = 1;
			}

			if (angular.isArray(fields) && fields.length > 0) {
				groupList.fields = fields.join(',');
			}

			RestangularWT.all('usergroups')
				.customGETLIST('', groupList)
				.then(
					function (tmpGroups) {
						q.resolve(tmpGroups);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getRolesList(page, perpage, fields) {
			var q = $q.defer(),
				rolesList = {};

			if (perpage) {
				rolesList.perpage = perpage;
			} else {
				rolesList.perpage = 20;
			}

			if (page) {
				rolesList.page = page;
			} else {
				rolesList.page = 1;
			}

			if (angular.isArray(fields) && fields.length > 0) {
				rolesList.fields = fields.join(',');
			}

			RestangularWT.all('roles')
				.customGETLIST('', rolesList)
				.then(
					function (tmpRoles) {
						q.resolve(tmpRoles);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function removeGroup(groupId) {
			var q = $q.defer();

			RestangularWT.one('usergroups', groupId)
				.remove()
				.then(
					function (result) {
						
						q.resolve(result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function forceRemoveGroup(groupId) {
			var q = $q.defer();

			RestangularWT.one('usergroups', groupId)
				.one('force')
				.remove()
				.then(
					function (result) {
						
						q.resolve(result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function addRole(rolename) {
			var q = $q.defer();

			RestangularWT.all('roles')
				.post({ description: rolename })
				.then(
					function (tmpResult) {
						clearRoles();
						q.resolve(tmpResult);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function removeRole(roleId) {
			var q = $q.defer();

			RestangularWT.one('roles', roleId)
				.remove()
				.then(
					function (result) {
						clearRoles();
						q.resolve(result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getGroup(groupId) {
			var q = $q.defer();

			RestangularWT.one('usergroups', groupId)
				.customGET('', { with: 'users,roles' })
				.then(
					function (result) {
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function addGroup(groupname) {
			var q = $q.defer();

			RestangularWT.all('usergroups')
				.post({ name: groupname })
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function importGroup(parameter) {
			var q = $q.defer();

			RestangularWT.all('usergroups')
				.all('import')
				.post({ parameter: parameter })
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function removeFromGroup(groupIds, users) {
			var q = $q.defer(),
				removePost = {};

			if (angular.isDefined(groupIds)) {
				if (angular.isArray(groupIds)) {
					removePost.usergroups = groupIds;
				} else {
					removePost.usergroups = [groupIds];
				}
			}

			if (angular.isDefined(users)) {
				if (angular.isArray(users)) {
					removePost.users = users;
				} else {
					removePost.users = [users];
				}
			}

			RestangularWT.all('usergroups')
				.all('deleteuser')
				.post(removePost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function addToGroup(groupIds, users) {
			var q = $q.defer(),
				addPost = {};

			if (angular.isDefined(groupIds)) {
				if (angular.isArray(groupIds)) {
					addPost.usergroups = groupIds;
				} else {
					addPost.usergroups = [groupIds];
				}
			}

			if (angular.isDefined(users)) {
				if (angular.isArray(users)) {
					addPost.users = users;
				} else {
					addPost.users = [users];
				}
			}

			RestangularWT.all('usergroups')
				.all('adduser')
				.post(addPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getRoles() {
			var q = $q.defer();

			if (userRoles.length < 1) {
				RestangularWT.all('roles')
					.getList()
					.then(
						function (result) {
							userRoles = result;
							q.resolve(result);
						},
						function (error) {
							
							q.reject();
						}
					);
			} else {
				q.resolve(userRoles);
			}

			return q.promise;
		}

		function clearRoles() {
			userRoles = [];
		}

		function removeRolesFromGroup(groupId, roles) {
			var q = $q.defer(),
				removePost = { usergroups: [groupId], roles: roles };

			RestangularWT.all('usergroups')
				.all('deleterole')
				.post(removePost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function resendEmail(userId) {
			var q = $q.defer(),
				resendPost = { user_id: userId };

			RestangularWT.all('users')
				.all('resendactivation')
				.post(resendPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function resetPasswordEmail(userEmail) {
			var q = $q.defer(),
				resendPost = { email: userEmail };

			RestangularWT.all('users')
				.all('resetpassword')
				.post(resendPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function resyncReceipts(userId) {
			var q = $q.defer(),
				resyncPost = { user_id: userId };

			RestangularWT.all('users')
				.all('resync')
				.all('receipts')
				.post(resyncPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function resyncUser(userId) {
			var q = $q.defer(),
				resyncPost = { user_id: userId };

			RestangularWT.all('users')
				.all('resync')
				.all('user')
				.post(resyncPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function changeNumber(changeNumber) {
			var q = $q.defer(),
				resetPost = {
					type: changeNumber.type,
					user_id: changeNumber.user_id,
				};

			if (changeNumber.type == 'existing') {
				resetPost.number = changeNumber.number;
			}

			RestangularWT.all('users')
				.all('reset')
				.all('number')
				.post(resetPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function exportUsers() {
			var q = $q.defer(),
				resyncPost = {};

			RestangularWT.all('users')
				.all('export')
				.post(resyncPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getUserLogs(userId) {
			var q = $q.defer();

			RestangularWT.one('users', userId)
				.all('logs')
				.getList()
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function addRolesToGroup(groupId, roles) {
			var q = $q.defer(),
				addPost = { usergroups: [groupId], roles: roles };

			RestangularWT.all('usergroups')
				.all('addrole')
				.post(addPost)
				.then(
					function (result) {
						
						q.resolve(result.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function generateRandomPassword(length) {
			var chars = 'abcdefghijklmnopqrstuvwxyz#!@-_ABCDEFGHIJKLMNOP1234567890';
			var pass = '';
			for (var x = 0; x < length; x++) {
				var i = Math.floor(Math.random() * chars.length);
				pass += chars.charAt(i);
			}
			return pass;
		}

		function addUser(tmpUser) {
			var q = $q.defer();

			RestangularWT.all('users')
				.post({
					email: tmpUser.email,
					level: tmpUser.level,
					password: tmpUser.password,
					active: tmpUser.active,
				})
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function deleteUser(user_id) {
			var q = $q.defer();

			RestangularWT.one('users', user_id)
				.remove()
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function checkCode(user_id, code) {
			var q = $q.defer();

			RestangularAPI.one('users', user_id)
				.one('check', code)
				.get()
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function maintenanceAction(maintenance_id, user_id, hook_id, action, param) {
			var q = $q.defer(),
				params = {};

			if (action === 'updateCardnumber') {
				params = { user_id: user_id, new_cardnumber: param };
				RestangularWT.one('maintenance', maintenance_id)
					.all('updateCardnumber')
					.post(params)
					.then(
						function () {
							q.resolve();
						},
						function () {
							q.reject();
						}
					);
			}

			if (action === 'passingUser') {
				params = { user_id: user_id };
				RestangularWT.one('maintenance', maintenance_id)
					.all('passingUser')
					.post(params)
					.then(
						function () {
							q.resolve();
						},
						function () {
							q.reject();
						}
					);
			}

			if (action === 'restartHook') {
				params = { hook_id: hook_id };
				RestangularWT.one('maintenance', maintenance_id)
					.all('restartHook')
					.post(params)
					.then(
						function () {
							q.resolve();
						},
						function () {
							q.reject();
						}
					);
			}

			if (action === 'changeHook') {
				params = { user_id: user_id };
				RestangularWT.one('maintenance', maintenance_id)
					.all('changeHook')
					.post(params)
					.then(
						function () {
							q.resolve();
						},
						function () {
							q.reject();
						}
					);
			}

			if (action === 'confirmUser') {
				params = { user_id: user_id };
				RestangularWT.one('maintenance', maintenance_id)
					.all('confirm')
					.post(params)
					.then(
						function () {
							q.resolve();
						},
						function () {
							q.reject();
						}
					);
			}

			return q.promise;
		}
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('user.directive', [])
		.directive('compareTo', compareTo)
		.directive('maintenanceDashboard', maintenanceDashboard);

	compareTo.$inject = [];
	function compareTo() {
		return {
			require: 'ngModel',
			scope: {
				otherModelValue: '=compareTo'
			},
			link: function(scope, element, attributes, ngModel) {
				ngModel.$validators.compareTo = function(modelValue) {
					return modelValue == scope.otherModelValue;
				};
				scope.$watch('otherModelValue', function() {
					ngModel.$validate();
				});
			}
		};
	}

	maintenanceDashboard.$inject = [];

	function maintenanceDashboard() {
		return {
			restrict: 'EA',
			scope: {},
			templateUrl: 'static/templates/user/maintenanceDashboard.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'UserMaintenanceDashboardController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

})(angular);

/* global _, globalConfig, moment */

(function (angular) {
	'use strict';

	angular
		.module('user.controller', [])
		.controller('AppController', AppCtrl)
		.controller('UserLoginController', LoginCtrl)
		.controller('UserOverviewController', OverviewCtrl)
		.controller('UserDetailController', DetailCtrl)
		.controller('UserAddCardController', AddCardCtrl)
		.controller('UserChangeNumberController', ChangeNumberCtrl)
		.controller('UserGroupsController', UserGroupsCtrl)
		.controller('UserGroupsDetailController', UserGroupsDetailCtrl)
		.controller('UserRolesController', UserRolesCtrl)
		.controller('UserResetPasswordController', ResetPasswordCtrl)
		.controller('UserNewPasswordController', NewPasswordCtrl)
		.controller('UserEditController', EditCtrl)
		.controller('LogoutController', LogoutCtrl)
		.controller('LoggedoutController', LoggedoutController)
		.controller('LoggedinController', LoggedinCtrl)
		.controller('UserMaintenanceDashboardController', MaintenanceDashboardCtrl)
		.controller('UserMaintenanceController', MaintenanceCtrl)
		.controller('UserMaintenanceModalController', MaintenanceModalCtrl);

	AppCtrl.$inject = ['Page'];

	function AppCtrl(Page) {
		var vm = this;
		vm.page = Page;
	}

	LoginCtrl.$inject = ['Page', '$user', '$state', '$timeout', 'toaster'];

	function LoginCtrl(Page, $user, $state, $timeout, toaster) {
		var vm = this;
		Page.setTitle('Login');
		vm.loading = false;
		vm.user = {
			username: '',
			password: '',
		};

		check();

		vm.login = function () {
			vm.loading = true;
			$user.login(vm.user.username, vm.user.password).then(
				function () {
					vm.loading = false;
					$state.go('app.dashboard');
				},
				function () {
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'Zugangsdaten falsch',
						body: 'Die eingegebenen Zugangsdaten sind nicht korrekt.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		vm.resetpassword = function () {
			$state.go('start.resetpassword');
		};

		function check() {
			$user.isReady(function () {
				$timeout(function () {
					if ($user.isLoggedin()) {
						$state.go('app.dashboard');
					}
				});
			});
		}
	}

	ResetPasswordCtrl.$inject = ['Page', '$user', '$state', '$window', 'toaster'];

	function ResetPasswordCtrl(Page, $user, $state, $window, toaster) {
		var vm = this;
		Page.setTitle('Passwort vergessen');
		vm.user = {
			username: '',
		};

		vm.reset = function () {
			$user.resetPassword(vm.user.username).then(function () {
				$state.go('start.login');
				toaster.pop({
					type: 'success',
					title: 'Passwort zurücksetzen',
					body: 'Wir haben Ihnen eine E-Mail geschickt',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		vm.back = function () {
			$window.history.back();
		};
	}

	NewPasswordCtrl.$inject = ['Page', '$user', '$state', 'toaster', '$stateParams'];

	function NewPasswordCtrl(Page, $user, $state, toaster, $stateParams) {
		var vm = this;
		Page.setTitle('Passwort setzen');
		vm.password = {
			new: '',
			new_confirm: '',
		};

		vm.save = function () {
			if (vm.password.new === vm.password.new_confirm) {
				vm.password.old = $stateParams.code;
				$user.changePassword(vm.password, $stateParams.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Passwort geändert',
							body: 'Ihr Passwort wurde wie gewünscht geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						vm.password = {
							new: '',
							new_confirm: '',
						};
						$state.go('start.login');
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Passwort ändern fehlgeschlagen',
							body: 'Ihr Passwort konnte nicht geändert werden.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			} else {
				toaster.pop({
					type: 'error',
					title: 'Fehler!',
					body: 'Die Passwörter stimmen nicht überein.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			}
		};

		load();

		function load() {
			$user.checkCode($stateParams.id, $stateParams.code).then(
				function () {},
				function () {
					toaster.pop({
						type: 'error',
						title: 'Code ungültig!',
						body: 'Dieser Code ist nicht (mehr) gültig.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					$state.go('start.login');
				}
			);
		}
	}

	LoggedinCtrl.$inject = ['$user', '$state', 'Page', '$timeout', '$mandant', '$cookies', '$window', 'toaster', '$raffle'];

	function LoggedinCtrl($user, $state, Page, $timeout, $mandant, $cookies, $window, toaster, $raffle) {
		var vm = this,
			user = { level: 0 };
		Page.setBodyClasses(['layout-full', 'loggedin']);

		vm.isNavCollapsed = true;
		vm.isCollapsed = false;
		vm.isCollapsedHorizontal = false;
		vm.mandants = [];
		vm.mandant = 0;
		vm.module = [];

		vm.showNewVersion = false;

		vm.changeMandant = function () {
			$user.changeMandant(vm.mandant.id).then(function () {
				$mandant.getMandantModule().then(function (module) {
					vm.module = module;
					$state.go('app.dashboard');
				});
			});
		};

		vm.moduleActive = function (module_id) {
			if (vm.module.length > 0) {
				return angular.isDefined(_.find(vm.module, { module_id: module_id.toString() }));
			}
		};

		vm.getViewType = function (viewType) {
			return globalConfig.defaults.viewType === viewType;
		};

		vm.setViewType = function (viewType) {
			globalConfig.defaults.viewType = viewType === 'table' ? 'table' : 'preview';
			$cookies.putObject('viewtype', globalConfig.defaults.viewType);
		};

		vm.isAdmin = function () {
			return angular.isDefined(user.level) && user.level == 1;
		};

		vm.openChangelog = function () {
			globalConfig.version.last = globalConfig.version.current;
			$cookies.putObject('lastversion', globalConfig.version.last);
			vm.showNewVersion = false;
			$window.open('https://v2.dokumentation.gates-app.de/backend-updates', '_blank');
		};

		vm.openRaffleLogin = function () {
			vm.loadingRaffle = true;
			$raffle.getBackendLogin().then(
				function (res) {
					vm.loadingRaffle = false;
					var token = res.jwt || '';
					if (!token) {
						toaster.pop({
							type: 'error',
							title: 'Login fehlgeschlagen',
							body: 'Kein JWT erhalten.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						return;
					}
					var url = 'https://raffle.gates-app.de/auth/login?jwt=' + encodeURIComponent(token);
					$window.open(url, '_blank');
				},
				function () {
					vm.loadingRaffle = false;
					toaster.pop({
						type: 'error',
						title: 'Login fehlgeschlagen',
						body: 'Das JWT konnte nicht abgerufen werden.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		$user.isReady(function () {
			user = $user.get();

			if (user.loggedin === false) {
				$state.go('start.login');
			}

			vm.mandants = user.mandants;

			$timeout(function () {
				vm.mandant = _.find(vm.mandants, { id: user.device.mandant_id });
			}, 100);

			$mandant.getMandantModule().then(function (module) {
				vm.module = module;
				if (globalConfig.version.current !== globalConfig.version.last) {
					vm.showNewVersion = true;
				}
			});
		});
	}

	LoggedoutController.$inject = ['Page'];

	function LoggedoutController(Page) {
		Page.setBodyClasses(['layout-full', 'start', 'gray']);
	}

	LogoutCtrl.$inject = ['$user', '$state'];

	function LogoutCtrl($user, $state) {
		$user.logout().then(function () {
			$state.go('start.login');
		});
	}

	OverviewCtrl.$inject = ['Page', '$user', 'toaster', '$loading', '$state', '$stateParams', '$window', '$cookies', '$timeout', '$mandant'];

	function OverviewCtrl(Page, $user, toaster, $loading, $state, $stateParams, $window, $cookies, $timeout, $mandant) {
		var vm = this;
		Page.setTitle('Anwender');
		vm.users = [];
		vm.count = 0;
		vm.filters = [];
		vm.showFilterSection = false;
		vm.showColumnSelection = false;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		// Sortierung
		vm.sortField = null;
		vm.sortDirection = 'asc';

		// Verfügbare Spalten
		vm.availableColumns = [
			{ field: 'id', label: 'MODULE.USERS.ID', visible: true },
			{ field: 'email', label: 'MODULE.USERS.EMAIL', visible: true },
			{ field: 'first_name', label: 'MODULE.USERS.FIRSTNAME', visible: true },
			{ field: 'last_name', label: 'MODULE.USERS.LASTNAME', visible: true },
			{ field: 'active', label: 'MODULE.ADMIN.USER.ACTIVE', visible: true },
			{ field: 'created_at', label: 'MODULE.USERS.CREATED', visible: false },
			{ field: 'last_seen_app', label: 'MODULE.USERS.LASTSEEN', visible: false },
		];

		vm.searchField = {
			email: '',
			number: '',
			first_name: '',
			last_name: '',
		};

		vm.isColumnVisible = function (field) {
			var column = _.find(vm.availableColumns, { field: field });
			return column ? column.visible : false;
		};

		vm.updateColumns = function () {
			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 30);
			$cookies.putObject('user-columns', vm.availableColumns, {
				expires: expireDate,
			});
			load();
		};

		vm.sortBy = function (field) {
			if (vm.sortField === field) {
				vm.sortDirection = vm.sortDirection === 'asc' ? 'desc' : 'asc';
			} else {
				vm.sortField = field;
				vm.sortDirection = 'asc';
			}

			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 30);
			$cookies.putObject(
				'user-sort',
				{
					field: vm.sortField,
					direction: vm.sortDirection,
				},
				{
					expires: expireDate,
				}
			);

			load();
		};

		vm.resetFilters = function () {
			vm.filters = [];
			$cookies.remove('search-filter-user');
			vm.search();
		};

		vm.sendNewPassword = function (user) {
			if (confirm('Dem Anwender ' + user.email + ' ein neues Passwort zusenden?')) {
				$user.resetPassword(user.email).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'E-Mail wurde verschickt!',
							body: 'Der Kunde erhält eine E-Mail um sein Passwort zu ändern.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Senden nicht möglich!',
							body: 'Dem Kunden kann derzeit keine E-Mail zugesendet werden. Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.changePage = function () {
			$loading.start();
			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				$state.go('app.user.overview', tmp, { notify: false });
				load();
			}, 500);
		};

		vm.addFilter = function () {
			vm.filters.push({
				field: '',
				value: '',
			});
		};

		vm.removeFilter = function ($index) {
			vm.filters.splice($index, 1);
			vm.search();
		};

		vm.allReadyAdded = function (field, index) {
			if (angular.isDefined(field) && field !== '') {
				var find = _.findIndex(vm.filters, { field: field });
				if (find !== -1) {
					if (find !== index) {
						return true;
					}
				}
			}

			return false;
		};

		vm.search = function () {
			$loading.start();

			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 7);
			$cookies.putObject('search-filter-user', vm.filters, {
				expires: expireDate,
			});

			vm.currentPage = 1;
			load();
			$state.go('app.user.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
		};

		vm.exportUser = function () {
			$user.exportUsers().then(function () {
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gestartet!',
					body: 'Der Anwender-Export wurde in die Warteschlange hinzugefügt.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		load();

		function load() {
			var filterCookie = $cookies.getObject('search-filter-user');
			if (angular.isDefined(filterCookie)) {
				vm.filters = filterCookie;
			}

			var columnsCookie = $cookies.getObject('user-columns');
			if (angular.isDefined(columnsCookie)) {
				vm.availableColumns = columnsCookie;
			}

			var sortCookie = $cookies.getObject('user-sort');
			if (angular.isDefined(sortCookie)) {
				vm.sortField = sortCookie.field;
				vm.sortDirection = sortCookie.direction;
			}

			// Erstelle fields array basierend auf sichtbaren Spalten
			var fields = [];
			angular.forEach(vm.availableColumns, function (column) {
				if (column.visible) {
					fields.push(column.field);
				}
			});

			$user.getList(vm.currentPage, vm.entryLimit, vm.filters, fields, null, null, vm.sortField, vm.sortDirection).then(
				function (users) {
					vm.users = users;
					vm.count = users.pagination.total;

					vm.totalItems = users.pagination.total;
					vm.noOfPages = users.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.users = [];
					vm.count = 0;
					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}
	}

	DetailCtrl.$inject = ['Page', '$user', '$stateParams', '$mandant', '$loading', '$uibModal', '$window', '$state', 'toaster', '$vouchers'];

	function DetailCtrl(Page, $user, $stateParams, $mandant, $loading, $uibModal, $window, $state, toaster, $vouchers) {
		var vm = this;
		Page.setTitle('Anwender > Details');
		vm.user = {};
		vm.metadata = [];
		vm.usergroups = [];
		vm.selectedGroupsRemove = [];
		vm.selectedGroupsAdd = [];
		vm.coupons = [];
		vm.logs = [];
		vm.opened = {};

		vm.open = function ($event, elementOpened) {
			$event.preventDefault();
			$event.stopPropagation();

			vm.opened[elementOpened] = !vm.opened[elementOpened];
		};

		vm.updateMetadata = function () {
			var metadata = [],
				fields = angular.copy(vm.metadata);

			angular.forEach(fields, function (field) {
				if (angular.isDefined(field.givenAnswer) && field.givenAnswer !== '' && field.type !== 'checkbox') {
					if (angular.isDefined(field.givenAnswer[0].value) && field.givenAnswer[0].value !== '') {
						if (field.key === 'birthday') {
							field.givenAnswer[0].value = moment(field.givenAnswer[0].value).add(7, 'hours').toDate();
						}

						metadata.push({
							metadata_field_id: field.id,
							value: field.givenAnswer[0].value,
						});
					}
				} else {
					if (field.type === 'checkbox') {
						if (angular.isDefined(field.model) && field.model !== '') {
							metadata.push({
								metadata_field_id: field.id,
								value: field.model,
							});
						}
					}
				}
			});

			$loading.start();

			$user.updateUserMetadata(vm.user.id, metadata).then(function () {
				loadMetadata();
			});
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.inUserArray = function (id) {
			if (angular.isDefined(vm.user.groups)) {
				var _find = _.find(vm.user.groups, { id: id });

				if (angular.isDefined(_find)) {
					return false;
				}
			}

			return true;
		};

		vm.removeFromGroup = function () {
			$loading.start();
			$user.removeFromGroup(vm.selectedGroupsRemove, $stateParams.id).then(
				function () {
					vm.selectedGroupsRemove = [];
					vm.selectedGroupsAdd = [];
					loadUser();
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.addToGroup = function () {
			$loading.start();
			$user.addToGroup(vm.selectedGroupsAdd, $stateParams.id).then(
				function () {
					vm.selectedGroupsRemove = [];
					vm.selectedGroupsAdd = [];
					loadUser();
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.resendEmail = function (userId) {
			$user.resendEmail(userId).then(function () {
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gestartet!',
					body: 'Der Versand der E-Mail wurde erneut gestartet.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		vm.resetPasswordEmail = function (email) {
			var sendConfirm = $window.confirm('"Passwort vergessen" E-Mail wirklich versenden? Der Anwender erhält eine E-Mail mit einem Link um sein Passwort zurückzusetzen.');
			if (sendConfirm) {
				$user.resetPasswordEmail(email).then(function () {
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich gestartet!',
						body: 'Der Versand der "Passwort vergessen" E-Mail wurde gestartet.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				});
			}
		};

		vm.addCard = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/user/modalAddCard.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'UserAddCardController',
				controllerAs: 'vmm',
			});

			modalInstance.result.then(function (card) {
				$loading.start();
				card.user_id = vm.user.id;

				$user.addNewCard(card).then(
					function () {
						loadUser();
						$loading.finish();
					},
					function () {
						$loading.finish();
					}
				);
			});
		};

		vm.removeCard = function (card) {
			var deleteConfirm = $window.confirm(card.number + ' wirklich löschen?');
			if (deleteConfirm) {
				$loading.start();
				$user.deleteCard(card.id).then(
					function () {
						loadUser();
						$loading.finish();
					},
					function () {
						$loading.finish();
					}
				);
			}
		};

		vm.resyncRecipts = function (userId) {
			$user.resyncReceipts(userId).then(function () {
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gestartet!',
					body: 'Die Synchronisierung der Kassenbons wurde in die Warteschlange gelegt und wird bald gestartet.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		vm.resyncUser = function (userId) {
			$user.resyncUser(userId).then(function () {
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gestartet!',
					body: 'Die Synchronisierung des Anwenders wurde in die Warteschlange gelegt und wird bald gestartet.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		vm.changeNumber = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/user/modalChangeNumber.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'UserChangeNumberController',
				controllerAs: 'vmm',
			});

			modalInstance.result.then(function (number) {
				$loading.start();
				number.user_id = vm.user.id;

				$user.changeNumber(number).then(
					function () {
						loadUser();
						$loading.finish();
					},
					function () {
						$loading.finish();
					}
				);
			});
		};

		load();

		function load() {
			loadGroup();
			loadUser();
		}

		function loadUser() {
			$loading.start();
			$user.getUser($stateParams.id).then(
				function (user) {
					vm.user = user;

					loadMetadata();
					loadLogs(vm.user.id);
					loadCoupons(vm.user.id);
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Fehler!',
						body: 'Anwender wurde nicht gefunden.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					$state.go('app.user.overview');
				}
			);
		}

		function loadLogs(userId) {
			$user.getUserLogs(userId).then(function (logs) {
				vm.logs = logs;
			});
		}

		function loadCoupons(userId) {
			$vouchers.getUser(userId).then(function (coupons) {
				vm.coupons = coupons;
			});
		}

		function loadMetadata() {
			$user.getUserMetadata($stateParams.id).then(
				function (metadata) {
					vm.metadata = metadata;
					$loading.finish();

					angular.forEach(vm.metadata, function (field) {
						if (angular.isDefined(field.givenAnswer) && field.givenAnswer.length > 0 && field.key === 'birthday') {
							field.givenAnswer[0].value = moment(field.givenAnswer[0].value).toDate();
						}

						if (angular.isDefined(field.givenAnswer) && field.givenAnswer.length < 1 && field.type !== 'checkbox') {
							field.givenAnswer = [];
							field.givenAnswer.push({ value: '' });
						}

						if (field.type === 'checkbox') {
							field.model = [];
							angular.forEach(field.givenAnswer, function (answer) {
								field.model.push(answer.value);
							});
						}
					});
				},
				function () {
					vm.metadata = [];
					$loading.finish();
				}
			);
		}

		function loadGroup() {
			$user.getGroupsList(1, 99999, ['id', 'name']).then(function (usergroups) {
				vm.usergroups = usergroups;
			});
		}
	}

	AddCardCtrl.$inject = ['$user', '$uibModalInstance'];

	function AddCardCtrl($user, $uibModalInstance) {
		var vm = this;
		vm.card_types = [];
		vm.new_card = {
			card_type: '',
			number: '',
			has_card: '',
		};

		vm.save = function () {
			$uibModalInstance.close(vm.new_card);
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		load();

		function load() {
			$user.getCardTypes().then(
				function (tmpTypes) {
					vm.card_types = tmpTypes;
				},
				function () {
					vm.card_types = [];
				}
			);
		}
	}

	ChangeNumberCtrl.$inject = ['$uibModalInstance'];

	function ChangeNumberCtrl($uibModalInstance) {
		var vm = this;
		vm.changeNumber = {
			type: '',
			number: '',
		};

		vm.save = function () {
			$uibModalInstance.close(vm.changeNumber);
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	}

	UserGroupsCtrl.$inject = ['Page', '$user', 'toaster', '$window', '$loading', '$stateParams', '$state', '$timeout', '$mandant'];

	function UserGroupsCtrl(Page, $user, toaster, $window, $loading, $stateParams, $state, $timeout, $mandant) {
		var vm = this;
		Page.setTitle('Anwendergruppen');
		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.usergroups = [];

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				load();
				$state.go('app.user.groups', tmp, { notify: false });
			}, 500);
		};

		vm.add = function () {
			var groupname = $window.prompt('Name der neuen Anwender-Gruppe:', '');
			if (groupname !== null) {
				$loading.start();
				$user.addGroup(groupname).then(
					function () {
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Anwender-Gruppe wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						load(1);
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Anwender-Gruppe konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.importGroup = function () {
			var parameter = $window.prompt('ID/Name der Selektion/Kampagne (je nach Warenwirtschaft hier die ID oder den Namen der Selektion oder Kampagne eintragen):', '');
			if (parameter !== null) {
				$loading.start();
				$user.importGroup(parameter).then(
					function () {
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Import der Selektion/Kampagne als Anwender-Gruppe wurde erfolgreich zur Warteschlange hinzugefügt.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						load(1);
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Import konnte nicht zur Warteschlange hinzugefügt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.remove = function (usergroup) {
			var deleteUserGroup = $window.confirm(usergroup.name + ' löschen?');

			if (deleteUserGroup) {
				$loading.start();
				$user.removeGroup(usergroup.id).then(
					function () {
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Anwendergruppe wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						load(vm.currentPage);
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Anwendergruppe konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.forceRemove = function (usergroup) {
			var firstConfirm = $window.confirm('WARNUNG: Möchten Sie die Gruppe "' + usergroup.name + '" wirklich ERZWUNGEN löschen?\n\n' + 'Dies wird die Gruppe und ALLE zugehörigen Benutzer und Rollen UNWIDERRUFLICH entfernen!');

			if (!firstConfirm) {
				return;
			}

			var confirmation = $window.prompt('Zum Bestätigen der ERZWUNGENEN Löschung geben Sie bitte "OK" ein:', '');

			if (confirmation !== 'OK') {
				if (confirmation !== null) {
					toaster.pop({
						type: 'warning',
						title: 'Abgebrochen',
						body: 'Löschung wurde abgebrochen. Sie müssen "OK" eingeben.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
				return;
			}

			$loading.start();
			$user.forceRemoveGroup(usergroup.id).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich gelöscht!',
						body: 'Anwendergruppe wurde erzwungen gelöscht',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					load(vm.currentPage);
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Nicht gelöscht!',
						body: 'Anwendergruppe konnte nicht gelöscht werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		load();

		function load() {
			$user.getGroupsList(vm.currentPage, vm.entryLimit).then(
				function (usergroups) {
					vm.usergroups = usergroups;
					vm.count = usergroups.pagination.total;

					vm.totalItems = usergroups.pagination.total;
					vm.noOfPages = usergroups.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.usergroups = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}
	}

	UserGroupsDetailCtrl.$inject = ['Page', '$user', 'toaster', '$window', '$stateParams', '$state'];

	function UserGroupsDetailCtrl(Page, $user, toaster, $window, $stateParams, $state) {
		var vm = this;
		Page.setTitle('Anwendergruppen > Detail');

		vm.usergroup = {};
		vm.users = [];
		// Precomputed Liste der User, die hinzugefügt werden können
		vm.usersAddable = [];
		vm.roles = [];
		vm.selectedUsersRemove = [];
		vm.selectedUsersAdd = [];
		vm.selectedRolesRemove = [];
		vm.selectedRolesAdd = [];
		// Separate Suchfelder für beide Panels
		vm.userSearchInGroup = '';
		vm.userSearchAdd = '';

		// Hilfsfunktion: normalisiert Text (Lowercase, trim)
		function norm(txt) {
			return (txt || '').toLowerCase().trim();
		}

		// Erzeugt eine Match-Funktion für eine bestimmte Suchphrase (Mehrwort-Suche: alle Tokens müssen in Vor- ODER Nachnamen vorkommen)
		// Cache für zuletzt erzeugte Matcher (reduziert Garbage & Rebuild pro Digest)
		var _matcherCache = { inGroup: { q: null, fn: null }, add: { q: null, fn: null } };

		function buildUserMatcher(phrase) {
			phrase = norm(phrase);
			if (!phrase) {
				return function () {
					return true;
				};
			}
			var tokens = phrase.split(/\s+/).filter(function (t) {
				return t.length > 0;
			});
			return function (user) {
				var first = norm(user.first_name);
				var last = norm(user.last_name);
				if (!tokens.length) return true;
				var full = (first + ' ' + last).trim();
				for (var i = 0; i < tokens.length; i++) {
					var tk = tokens[i];
					if (first.indexOf(tk) === -1 && last.indexOf(tk) === -1 && full.indexOf(tk) === -1) {
						return false;
					}
				}
				return true;
			};
		}

		// Dynamische Prädikate für ng-repeat (werden bei jedem Digest neu evaluiert, daher leichtgewichtig halten)
		vm.userNameMatchesInGroup = function (user) {
			if (_matcherCache.inGroup.q !== vm.userSearchInGroup) {
				_matcherCache.inGroup = { q: vm.userSearchInGroup, fn: buildUserMatcher(vm.userSearchInGroup) };
			}
			return _matcherCache.inGroup.fn(user);
		};
		vm.userNameMatchesAdd = function (user) {
			if (_matcherCache.add.q !== vm.userSearchAdd) {
				_matcherCache.add = { q: vm.userSearchAdd, fn: buildUserMatcher(vm.userSearchAdd) };
			}
			return _matcherCache.add.fn(user);
		};

		// Set der User IDs in der Gruppe für O(1) Lookup
		var userGroupIdSet = {};
		function rebuildUserGroupIdSet() {
			userGroupIdSet = {};
			angular.forEach(vm.usergroupUsersArray || [], function (u) {
				if (u && angular.isDefined(u.id)) userGroupIdSet[u.id] = true;
			});
		}

		// Precompute Liste addbarer User (statt ng-if in jedem Digest)
		function recomputeAddable() {
			if (!vm.users || !vm.users.length) {
				vm.usersAddable = [];
				return;
			}
			var arr = [];
			for (var i = 0; i < vm.users.length; i++) {
				var u = vm.users[i];
				if (!u || angular.isUndefined(u.id)) continue;
				if (!userGroupIdSet[u.id]) arr.push(u);
			}
			vm.usersAddable = arr;
		}

		vm.remove = function (usergroup) {
			var deleteUserGroup = $window.confirm(usergroup.name + ' löschen?');

			if (deleteUserGroup) {
				$user.removeGroup(usergroup.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Anwendergruppe wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						$state.go('app.user.groups');
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Anwendergruppe konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.removeFromGroup = function () {
			$user.removeFromGroup($stateParams.id, vm.selectedUsersRemove).then(function () {
				vm.selectedUsersRemove = [];
				vm.selectedUsersAdd = [];
				loadGroup();
			});
		};

		vm.addToGroup = function () {
			$user.addToGroup($stateParams.id, vm.selectedUsersAdd).then(function () {
				vm.selectedUsersRemove = [];
				vm.selectedUsersAdd = [];
				loadGroup();
			});
		};

		vm.removeRole = function () {
			$user.removeRolesFromGroup($stateParams.id, vm.selectedRolesRemove).then(function () {
				vm.selectedRolesRemove = [];
				vm.selectedRolesAdd = [];
				loadGroup();
			});
		};

		vm.addRole = function () {
			$user.addRolesToGroup($stateParams.id, vm.selectedRolesAdd).then(function () {
				vm.selectedRolesRemove = [];
				vm.selectedRolesAdd = [];
				loadGroup();
			});
		};

		vm.notInRoleArray = function (id) {
			if (angular.isDefined(vm.usergroup.roles)) {
				var _find = _.find(vm.usergroup.roles, { id: id });

				if (angular.isDefined(_find)) {
					return false;
				}
			}

			return true;
		};

		vm.notInUserArray = function (id) {
			if (angular.isDefined(vm.usergroup.users)) {
				var _find = _.find(vm.usergroup.users, { id: id });

				if (angular.isDefined(_find)) {
					return false;
				}
			}

			return true;
		};

		load();

		function load() {
			loadGroup();
			loadUsers();
			loadRoles();
		}

		function loadGroup() {
			$user.getGroup($stateParams.id).then(function (usergroup) {
				vm.usergroup = usergroup;
				// Normalisieren: usergroup.users kann als Objekt (Key -> User) geliefert werden
				vm.usergroupUsersArray = [];
				if (usergroup && angular.isDefined(usergroup.users)) {
					if (angular.isArray(usergroup.users)) {
						vm.usergroupUsersArray = usergroup.users;
					} else if (angular.isObject(usergroup.users)) {
						angular.forEach(usergroup.users, function (val) {
							if (val && angular.isObject(val) && angular.isDefined(val.id)) {
								vm.usergroupUsersArray.push(val);
							}
						});
					}
				}
				rebuildUserGroupIdSet();
				recomputeAddable();
			});
		}

		function loadUsers() {
			$user.getList(1, 999999, false, ['id', 'mandant_id', 'first_name', 'last_name']).then(
				function (users) {
					// Manche Endpoints liefern ein Objekt mit numerischen Keys statt eines Arrays
					if (angular.isArray(users)) {
						vm.users = users;
					} else if (angular.isObject(users)) {
						var tmp = [];
						angular.forEach(users, function (val) {
							// Nur echte User-Objekte übernehmen (id vorhanden, keine Funktionen)
							if (val && angular.isObject(val) && angular.isDefined(val.id)) {
								tmp.push(val);
							}
						});
						vm.users = tmp;
					} else {
						vm.users = [];
					}
					recomputeAddable();
				},
				function () {
					vm.users = [];
					recomputeAddable();
				}
			);
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	UserRolesCtrl.$inject = ['Page', '$user', 'toaster', '$window', '$loading', '$stateParams', '$state', '$timeout'];

	function UserRolesCtrl(Page, $user, toaster, $window, $loading, $stateParams, $state, $timeout) {
		var vm = this;
		Page.setTitle('Rollen');
		vm.roles = [];
		vm.loading = false;
		vm.deleteConfirmed = false;
		vm.currentPage = $stateParams.page;
		vm.entryLimit = $stateParams.perpage;
		vm.totalItems = 0;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();
			$timeout(function () {
				load();
				$state.go('app.user.roles', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
			}, 200);
		};

		function load() {
			$loading.start();
			$user.getRolesList(vm.currentPage, vm.entryLimit).then(
				function (result) {
					vm.roles = result;
					vm.totalItems = result.pagination.total;
					vm.noOfPages = result.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.roles = [];
					vm.totalItems = 0;
					vm.noOfPages = 1;
					$loading.finish();
				}
			);
		}

		vm.add = function () {
			var rolename = $window.prompt('Name der neuen Rolle:', '');
			if (rolename !== null && rolename !== '') {
				$user.addRole(rolename).then(
					function () {
						toaster.pop({ type: 'success', title: 'Rolle erstellt', body: 'Rolle wurde erfolgreich erstellt.', timeout: globalConfig.toastTimeout, showCloseButton: true });
						$user.clearRoles && $user.clearRoles();
						load();
					},
					function () {
						toaster.pop({ type: 'error', title: 'Nicht erstellt', body: 'Rolle konnte nicht erstellt werden.', timeout: globalConfig.toastTimeout, showCloseButton: true });
					}
				);
			}
		};

		vm.remove = function (role) {
			var confirmed = $window.confirm('"' + role.description + '" löschen?');
			if (confirmed) {
				$user.removeRole(role.id).then(
					function () {
						toaster.pop({ type: 'success', title: 'Rolle gelöscht', body: 'Rolle wurde erfolgreich gelöscht.', timeout: globalConfig.toastTimeout, showCloseButton: true });
						$user.clearRoles && $user.clearRoles();
						load();
					},
					function () {
						toaster.pop({ type: 'error', title: 'Nicht gelöscht', body: 'Rolle konnte nicht gelöscht werden.', timeout: globalConfig.toastTimeout, showCloseButton: true });
					}
				);
			}
		};

		load();
	}

	EditCtrl.$inject = ['Page', '$user', 'toaster'];

	function EditCtrl(Page, $user, toaster) {
		var vm = this;
		Page.setTitle('Profil bearbeiten');
		vm.password = {
			old: '',
			new: '',
			new_confirm: '',
		};

		vm.user = $user.get();

		vm.changePw = function () {
			if (vm.password.new === vm.password.new_confirm) {
				$user.changePassword(vm.password).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Passwort geändert',
							body: 'Ihr Passwort wurde wie gewünscht geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						vm.password = {
							old: '',
							new: '',
						};
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Passwort ändern fehlgeschlagen',
							body: 'Ihr Passwort konnte nicht geändert werden.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			} else {
				toaster.pop({
					type: 'error',
					title: 'Fehler!',
					body: 'Die Passwörter stimmen nicht überein.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			}
		};
	}

	MaintenanceDashboardCtrl.$inject = ['$user'];

	function MaintenanceDashboardCtrl($user) {
		var vm = this;
		vm.userMaintenance = 0;

		load();

		function load() {
			$user.getMaintenanceList(1, 1).then(function (userMaintenance) {
				vm.userMaintenance = userMaintenance.pagination.total;
			});
		}
	}

	MaintenanceCtrl.$inject = ['Page', '$user', '$stateParams', '$state', '$loading', '$uibModal', '$window', '$timeout'];

	function MaintenanceCtrl(Page, $user, $stateParams, $state, $loading, $uibModal, $window, $timeout) {
		var vm = this;
		Page.setTitle('Fehlerprotokoll');
		vm.users = [];
		vm.count = 0;
		vm.filters = [];
		vm.showSearch = false;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				load();
				$state.go('app.user.maintenance', tmp, { notify: false });
			}, 500);
		};

		vm.action = function (maintenance) {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/user/modalMaintenanceAction.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'UserMaintenanceModalController',
				controllerAs: 'vmm',
				resolve: {
					actions: function () {
						return maintenance.actions;
					},
				},
			});

			modalInstance.result.then(function (data) {
				var action = data.action,
					param = data.param || '';
				$loading.start();

				$user.maintenanceAction(maintenance.id, maintenance.user.id, maintenance.hook_id, action, param).then(
					function () {
						load();
						$loading.finish();
					},
					function () {
						load();
						$loading.finish();
					}
				);
			});
		};

		load();

		function load() {
			$user.getMaintenanceList(vm.currentPage, vm.entryLimit).then(
				function (userMaintenance) {
					vm.users = userMaintenance;

					vm.count = userMaintenance.pagination.total;

					vm.totalItems = userMaintenance.pagination.total;
					vm.noOfPages = userMaintenance.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.users = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 1;
					$loading.finish();
				}
			);
		}
	}

	MaintenanceModalCtrl.$inject = ['$uibModalInstance', '$window', 'actions'];

	function MaintenanceModalCtrl($uibModalInstance, $window, actions) {
		var vm = this;
		vm.actions = [];
		vm.changeNumber = false;
		vm.form = {
			action: '',
			param: '',
		};

		vm.passingUser = function () {
			vm.form.action = 'passingUser';
			vm.save();
		};

		vm.updateCardnumber = function () {
			vm.form.action = 'updateCardnumber';
			vm.save();
		};

		vm.changeHook = function () {
			vm.form.action = 'changeHook';
			vm.save();
		};

		vm.restartHook = function () {
			vm.form.action = 'restartHook';
			vm.save();
		};

		vm.confirmUser = function () {
			vm.form.action = 'confirmUser';
			vm.save();
		};

		vm.save = function () {
			var message = 'Aktion wirklich ausführen?';

			if (vm.form.action === 'confirmUser') {
				message = 'Diese Aktion löscht nur diese Fehlermeldung! Es wird keine weitere Aktion ausgeführt.';
			}

			if ($window.confirm(message)) {
				$uibModalInstance.close(vm.form);
			}
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		load();

		function load() {
			vm.actions = actions;
		}
	}
})(angular);

/* global angular, _ */

(function (angular) {
	'use strict';

	angular.module('user.filter', ['user'])
		.filter('checkInObject', inObject)
		.filter('translateRightKey', translateRightKey);

	inObject.$inject = [];

	function inObject() {
		return function (input, select, find) {
			var search = [];
			search[select] = find;

			var _find = _.find(input, search);

			return angular.isUndefined(_find);
		};
	}

	translateRightKey.$inject = [];

	function translateRightKey() {
		return function (input, roles) {
			if(angular.isDefined(input) && input !== '' && input !== null) {
				if(input !== 'everybody') {
					var _find = _.find(roles, {'right_key': input});

					if(angular.isDefined(_find)) {
						return _find.description;
					} else {
						return 'CSV-Import';
					}
				} else {
					return 'alle';
				}
			}
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('help', ['help.controller']);

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('help.controller', [])
		.controller('HelpOverviewController', OverviewCtrl);

	OverviewCtrl.$inject = ['Page'];
	function OverviewCtrl(Page){
		var vm = this;
		Page.setTitle('Hilfe');

		function load(){

		}
	}

})(angular);

(function(angular) {
	'use strict';

	angular.module('pagination', ['pagination.controller', 'pagination.directive']);

})(angular);

(function (angular) {
	'use strict';

	angular.module('pagination.controller', [])
		.controller('PaginationTemplateController', paginationTemplateCtrl);

	function paginationTemplateCtrl() {
		var vm = this;
	}

})(angular);

(function (angular) {
	'use strict';

	angular.module('pagination.directive', [])
		.directive('paginationTemplate', paginationTemplate);

	function paginationTemplate() {
		return {
			restrict: 'EA',
			scope: {
				'itemLength': '=',
				'currentPage': '=',
				'totalItems': '=',
				'itemsPerPage': '=',
				'entryLimit': '=',
				'viewTypeDisabled': '=',
				'setViewType': '&',
				'changePage': '&',
				'getViewType': '&'
			},
			//replace: true,
			templateUrl: 'static/templates/pagination/template.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'PaginationTemplateController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('customers', ['customers.factory', 'customers.controller', 'customers.directive']);

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('customers.controller', [])
		.controller('CustomersListController', CustomersListCtrl)
		.controller('CustomersDetailController', CustomersDetailCtrl)
		.controller('CustomersGroupsListController', CustomersGroupsListCtrl)
		.controller('CustomersGroupsAddController', CustomersGroupsAddCtrl);

	CustomersListCtrl.$inject = ['Page', '$customers', 'toaster'];

	function CustomersListCtrl(Page, $customers, toaster) {
		var vm = this;
		Page.setTitle('Kunden');
		vm.customers = [];
		vm.count = 0;

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		vm.searchField = {
			email: '',
			number: '',
			first_name: '',
			last_name: ''
		};

		vm.sendNewPassword = function(customer) {
			if(confirm('Dem Kunden ' + customer.email + ' ein neues Passwort zusenden?')) {
				$customers.sendNewPassword(customer.email).then(
					function() {
						toaster.pop({
							type: 'success',
							title: 'E-Mail wurde verschickt!',
							body: 'Der Kunde erhält eine E-Mail um sein Passwort zu ändern.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function() {
						toaster.pop({
							type: 'error',
							title: 'Senden nicht möglich!',
							body: 'Dem Kunden kann derzeit keine E-Mail zugesendet werden. Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.changePage = function() {
			$customers.getList(vm.currentPage, vm.entryLimit).then(
				function(customers) {
					vm.customers = customers;
					vm.count = customers.pagination.total;

					vm.totalItems = customers.pagination.total;
					vm.noOfPages = customers.pagination.pages;
				}
			);
		};

		vm.search = function(field) {
			$customers.getList(1, vm.entryLimit, {field: field, text: vm.searchField[field]}).then(
				function(customers) {
					vm.customers = customers;
					vm.count = customers.pagination.total;

					vm.totalItems = customers.pagination.total;
					vm.noOfPages = customers.pagination.pages;
				},
				function() {

				}
			);
		};

		load();

		function load() {
			$customers.getList(1, vm.entryLimit).then(
				function(customers) {
					vm.customers = customers;
					vm.count = customers.pagination.total;

					vm.totalItems = customers.pagination.total;
					vm.noOfPages = customers.pagination.pages;
				},
				function() {

				}
			);
		}
	}

	CustomersDetailCtrl.$inject = ['Page', '$customers', '$stateParams', '$mandant'];

	function CustomersDetailCtrl(Page, $customers, $stateParams, $mandant) {
		var vm = this;
		Page.setTitle('Kunden > Detail');
		vm.customer = {};
		vm.credits = {};
		vm.transactions = [];

		vm.moduleActive = function(module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		load();

		function load() {
			$customers.get($stateParams.id).then(
				function(customer) {
					vm.customer = customer;
					Page.setTitle('Kunden > ' + customer.first_name + ' ' + customer.last_name);
					var transactions = [];

					transactions = transactions.concat(customer.manualtransactions, customer.paypaltransactions);
					vm.transactions = _.orderBy(transactions, 'created_at', 'desc');

					$customers.getCustomerCredits($stateParams.id).then(
						function(credits) {
							vm.credits = credits;
						}
					);
				},
				function() {

				}
			);
		}
	}

	CustomersGroupsListCtrl.$inject = ['Page', '$customers'];

	function CustomersGroupsListCtrl(Page, $customers) {
		var vm = this;
		Page.setTitle('Kunden > Kundengruppen');
		vm.groups = [];
		vm.count = 0;

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		vm.searchField = {
			email: '',
			number: '',
			first_name: '',
			last_name: ''
		};

		vm.changePage = function() {
			$customers.getGroupsList(vm.currentPage, vm.entryLimit).then(
				function(groups) {
					vm.groups = groups;
					vm.count = groups.pagination.total;

					vm.totalItems = groups.pagination.total;
					vm.noOfPages = groups.pagination.pages;
				}
			);
		};

		load();

		function load() {
			$customers.getGroupsList(1, vm.entryLimit).then(
				function(groups) {
					vm.groups = groups;
					vm.count = groups.pagination.total;

					vm.totalItems = groups.pagination.total;
					vm.noOfPages = groups.pagination.pages;
				},
				function() {

				}
			);
		}
	}

	CustomersGroupsAddCtrl.$inject = ['Page', '$customers', '$state', 'toaster'];

	function CustomersGroupsAddCtrl(Page, $customers, $state, toaster) {
		var vm = this;
		Page.setTitle('Kunden > Kundengruppen > Hinzufügen');
		vm.customers = [];
		vm.group = {
			name: '',
			customers: []
		};

		vm.add = function(){
			$customers.addGroup(vm.group).then(
				function(){
					toaster.pop({
						type: 'success',
						title: 'Kundengruppe erstellt!',
						body: 'Die Kundengruppe wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					$state.go('app.customers.customergroups');
				},
				function(){
					toaster.pop({
						type: 'error',
						title: 'Kundengruppe nicht erstellt!',
						body: 'Die Kundengruppe konnte nicht erstellt werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				}
			);
		};

		load();

		function load() {
			$customers.getList(1, 9999, {}, ['id', 'first_name', 'last_name', 'number']).then(
				function(tmpCustomers){
					vm.customers = tmpCustomers;
				}
			);
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('customers.factory', [])
		.factory('$customers', CustomersFactory);

	CustomersFactory.$inject = ['$q', '$log', '$api'];
	function CustomersFactory($q, $log, $api){
		return {
			get: get,
			getList: getList,
			getGroupsList: getGroupsList,
			addGroup: addGroup,
			sendNewPassword: sendNewPassword,
			getCustomerCredits: getCustomerCredits
		};

		function getList(page, perpage, search, fields){
			var q = $q.defer(),
				customList = {};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 20;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if(angular.isObject(search) && angular.isDefined(search.field) && search.field.length > 0){
				customList[search.field] = 'LIKE(%' + search.text + '%)';
			}

			if(angular.isArray(fields) && fields.length > 0){
				customList.fields = fields.join(',');
			}

			$api.withToken().all('customers').customGETLIST('', customList).then(
				function(tmpCustomers) {
					q.resolve(tmpCustomers);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function get(customer_id){
			var q = $q.defer();

			$api.withToken().one('customers', customer_id).customGET('', {with: 'manualtransactions,paypaltransactions'}).then(
				function(tmpCustomer) {
					q.resolve(tmpCustomer.result);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function sendNewPassword(customer_email){
			var q = $q.defer();

			$api.withToken().all('customers').all('resetpassword').post({'email': customer_email}).then(
				function(result) {
					
					q.resolve();
				},
				function(error) {
					
					q.reject(error.data.error.code);
				});

			return q.promise;
		}

		function getCustomerCredits(customer_id){
			var q = $q.defer();

			$api.withToken().one('customers', customer_id).all('credits').getList().then(
				function(tmpCustomerCredits) {
					q.resolve(tmpCustomerCredits);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getGroupsList(page, perpage){
			var q = $q.defer(),
				groupList = {

				};

			if(perpage) {
				groupList.perpage = perpage;
			} else {
				groupList.perpage = 20;
			}

			if(page) {
				groupList.page = page;
			} else {
				groupList.page = 1;
			}

			$api.withToken().all('customergroups').customGETLIST('', groupList).then(
				function(tmpGroups) {
					q.resolve(tmpGroups);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function addGroup(group){
			var q = $q.defer(),
				tmpGroup = {
					name: group.name,
					customers: group.customers
				};

			$api.withToken().all('customergroups').post(tmpGroup).then(
				function(tmpGroups) {
					q.resolve(tmpGroups);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('customers.directive', [])
		.directive('mwConfirmClick', mwConfirmClick);

	mwConfirmClick.$inject = [];
	function mwConfirmClick() {
		return {
			priority: -1,
			restrict: 'A',
			scope: {
				confirmFunction: '&mwConfirmClick'
			},
			link: function(scope, element, attrs) {
				element.bind('click', function() {
					var message = attrs.mwConfirmClickMessage ? attrs.mwConfirmClickMessage : 'Are you sure?';
					if(confirm(message)) {
						scope.confirmFunction();
					}
				});
			}
		};
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('media', ['media.factory', 'media.controller', 'media.directive']);

})(angular);

/* global angular, globalConfig, _ */

(function (angular) {
	'use strict';

	angular.module('media.controller', [])
		.controller('MediaImagesController', MediaImagesCtrl)
		.controller('MediaFilesController', MediaFilesCtrl)
		.controller('MediaModalMoveImageController', MediaModalMoveImageCtrl)
		.controller('MediaModalMoveFileController', MediaModalMoveFileCtrl)
		.controller('MediaUploadController', MediaUploadCtrl)
		.controller('MediaModalUploadImageController', MediaModalUploadImageCtrl)
		.controller('MediaModalUploadFileController', MediaModalUploadFileCtrl);

	MediaImagesCtrl.$inject = ['Page', '$media', 'toaster', '$window', '$stateParams', '$uibModal', '$loading', '$state', '$filter'];

	function MediaImagesCtrl(Page, $media, toaster, $window, $stateParams, $uibModal, $loading, $state, $filter) {
		var vm = this;
		Page.setTitle('Medien');
		vm.folders = [];
		vm.folder = {};
		vm.medias = [];
		vm.selectedMedia = [];
		vm.selectedMedias = [];
		vm.current_folder_id = $stateParams.folder;

		// Pagination
		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.addFolder = function () {
			var folderName = $window.prompt('Geben Sie den Ordner-Namen ein:', '');
			if(folderName !== null) {
				$media.addFolder(folderName, vm.current_folder_id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Ordner wurde erfolgreich erstellt',
							timeout: 5000,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Ordner konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: 5000,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.changeFolder = function (folder_id, folder_name) {
			var folderName = $window.prompt('Geben Sie den Ordner-Namen ein:', folder_name);
			if(folderName !== null) {
				$media.changeFolder(folder_id, folderName).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Ordner wurde erfolgreich gespeichert.',
							timeout: 5000,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Ordner konnte nicht gespeichert werden! Unbekannter Fehler.',
							timeout: 5000,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.deleteFolder = function (folder) {
			var deleteFolder = $window.confirm(folder.name + ' wirklich löschen?');

			if(deleteFolder) {
				$loading.start();

				$media.deleteFolder(folder.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Ordner wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						vm.current_folder_id = '0';
						load();
						$state.go('app.media.images', {
							page: vm.currentPage,
							perpage: vm.entryLimit,
							folder: vm.current_folder_id
						}, {notify: false});
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Ordner konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.deleteMedia = function (media) {
			var deleteImg = $window.confirm(media.name + ' wirklich löschen? Sollte dieses Bild/Video noch an einer Stelle verwendet werden, wird es nicht mehr dargestellt!');

			if(deleteImg) {
				$media.deleteImage(media.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Datei wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Datei konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.deleteMedias = function () {
			var deleteImg = $window.confirm(vm.selectedMedias.length + ' Medien wirklich löschen? Sollte dieses Bild/Video noch an einer Stelle verwendet werden, wird es nicht mehr dargestellt!');

			if(deleteImg) {
				var i = 1,
					length = vm.selectedMedias.length;

				$loading.start();
				angular.forEach(vm.selectedMedias, function (media) {
					$media.deleteImage(media).then(
						function () {
							if(length !== i) {
								i++;
							} else {
								loadImages();
								vm.selectedMedias = [];
								vm.selectedMedia = [];
								$loading.finish();
								toaster.pop({
									type: 'success',
									title: 'Erfolgreich gelöscht!',
									body: 'Medien wurden erfolgreich gelöscht.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true
								});
							}

						},
						function () {
							if(length !== i) {
								i++;
							} else {
								loadImages();
								$loading.finish();
							}
						}
					);
				});
			}
		};

		vm.moveMedia = function (media) {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/media/mediaModalMove.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'MediaModalMoveImageController',
				controllerAs: 'vmm'
			});

			modalInstance.result.then(function (selectedFolder) {
				$loading.start();
				$media.moveMedia(media.id, selectedFolder).then(
					function () {
						loadImages();
						vm.selectedMedias = [];
						vm.selectedMedia = [];
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich verschoben!',
							body: 'Media wurde erfolgreich verschoben.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						vm.selectedMedias = [];
						vm.selectedMedia = [];
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Datei konnte nicht verschoben werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			});
		};

		vm.moveMedias = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/media/mediaModalMove.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'MediaModalMoveImageController',
				controllerAs: 'vmm'
			});

			modalInstance.result.then(function (selectedFolder) {
				var i = 1,
					length = vm.selectedMedias.length;

				$loading.start();
				angular.forEach(vm.selectedMedias, function (media) {
					$media.moveMedia(media, selectedFolder).then(
						function () {
							if(length !== i) {
								i++;
							} else {
								loadImages();
								vm.selectedMedias = [];
								vm.selectedMedia = [];
								$loading.finish();
								toaster.pop({
									type: 'success',
									title: 'Erfolgreich verschoben!',
									body: 'Medien wurden erfolgreich verschoben.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true
								});
							}

						},
						function () {
							if(length !== i) {
								i++;
							} else {
								loadImages();
								vm.selectedMedias = [];
								vm.selectedMedia = [];
								$loading.finish();
							}
						}
					);
				});
			});
		};

		vm.changePage = function () {
			$loading.start();
			load();
			$state.go('app.media.images', {
				page: vm.currentPage,
				perpage: vm.entryLimit,
				folder: vm.current_folder_id
			}, {notify: false});
		};

		vm.selectFolder = function (folder_id) {
			$loading.start();
			vm.current_folder_id = folder_id;
			vm.currentPage = 1;
			load();
			$state.go('app.media.images', {
				page: vm.currentPage,
				perpage: vm.entryLimit,
				folder: vm.current_folder_id
			}, {notify: false});
		};

		vm.selectMedia = function (status, media) {
			if(status !== false) {
				vm.selectedMedias.push(media.id);
			} else {
				vm.selectedMedias = _.filter(vm.selectedMedias, function (x) {
					return x !== media.id;
				});
			}
		};

		vm.uploadMedia = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/media/mediaModalImageUpload.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'MediaModalUploadImageController',
				controllerAs: 'vmm'
			});

			modalInstance.result.then(function (selectedFolder) {
				vm.selectFolder(selectedFolder);
			});
		};

		load();

		function load() {
			if(vm.current_folder_id === '0') {
				vm.folder = {};

				$media.getFolders(vm.current_folder_id).then(
					function (folders) {
						vm.folders = $filter('listToMatrix')(folders, 6);
					},
					function () {
						vm.folders = [];
					}
				);
			} else {
				vm.folders = [];

				$media.getFolder(vm.current_folder_id).then(
					function (folder) {
						vm.folder = folder;
					},
					function () {
						vm.folder = {};
					}
				);
			}

			loadImages();

		}

		function loadImages() {
			$media.getList(vm.currentPage, vm.entryLimit, true, vm.current_folder_id).then(
				function (medias) {
					vm.medias = medias;

					vm.totalItems = medias.pagination.total;
					vm.noOfPages = medias.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.medias = [];

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$window.scrollTo(0, 0);
					$loading.finish();
				}
			);
		}
	}

	MediaFilesCtrl.$inject = ['Page', '$media', 'toaster', '$window', '$stateParams', '$uibModal', '$loading', '$state', '$filter'];

	function MediaFilesCtrl(Page, $media, toaster, $window, $stateParams, $uibModal, $loading, $state, $filter) {
		var vm = this;
		Page.setTitle('Dateien');

		vm.folders = [];
		vm.folder = {};
		vm.files = [];
		vm.selectedFile = [];
		vm.selectedFiles = [];
		vm.current_folder_id = $stateParams.folder;

		// Pagination
		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.addFolder = function () {
			var folderName = $window.prompt('Geben Sie den Ordner-Namen ein:', '');
			if(folderName !== null) {
				$media.addFileFolder(folderName, vm.current_folder_id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Ordner wurde erfolgreich erstellt',
							timeout: 5000,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Ordner konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: 5000,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.changeFolder = function (folder_id, folder_name) {
			var folderName = $window.prompt('Geben Sie den Ordner-Namen ein:', folder_name);
			if(folderName !== null) {
				$media.changeFileFolder(folder_id, folderName).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Ordner wurde erfolgreich gespeichert.',
							timeout: 5000,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Ordner konnte nicht gespeichert werden! Unbekannter Fehler.',
							timeout: 5000,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.deleteFolder = function (folder) {
			var deleteFolder = $window.confirm(folder.name + ' wirklich löschen?');

			if(deleteFolder) {
				$loading.start();

				$media.deleteFileFolder(folder.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Ordner wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						vm.current_folder_id = '0';
						load();
						$state.go('app.media.images', {
							page: vm.currentPage,
							perpage: vm.entryLimit,
							folder: vm.current_folder_id
						}, {notify: false});
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Ordner konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.selectMedia = function (status, media) {
			if(status !== false) {
				vm.selectedFiles.push(media.id);
			} else {
				vm.selectedFiles = _.filter(vm.selectedFiles, function (x) {
					return x !== media.id;
				});
			}
		};

		vm.uploadFileMedia = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/media/mediaFileModalUpload.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'MediaModalUploadFileController',
				controllerAs: 'vmm'
			});

			modalInstance.result.then(function (selectedFolder) {
				vm.selectFolder(selectedFolder);
			});
		};

		vm.selectFolder = function (folder_id) {
			$loading.start();
			vm.current_folder_id = folder_id;
			vm.currentPage = 1;
			load();
			$state.go('app.media.files', {
				page: vm.currentPage,
				perpage: vm.entryLimit,
				folder: vm.current_folder_id
			}, {notify: false});
		};

		vm.deleteMedia = function (file) {
			var deleteImg = $window.confirm(file.name + ' wirklich löschen? Sollte diese Datei noch an einer Stelle verwendet werden, wird sie nicht mehr dargestellt!');

			if(deleteImg) {
				$media.deleteFile(file.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Datei wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Datei konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.deleteMedias = function () {
			var deleteImg = $window.confirm(vm.selectedFiles.length + ' Dateien wirklich löschen? Sollte diese Datei noch an einer Stelle verwendet werden, wird es nicht mehr dargestellt!');

			if(deleteImg) {
				var i = 1,
					length = vm.selectedFiles.length;

				$loading.start();
				angular.forEach(vm.selectedFiles, function (file) {
					$media.deleteFile(file).then(
						function () {
							if(length !== i) {
								i++;
							} else {
								loadFiles();
								vm.selectedFiles = [];
								vm.selectedFile = [];
								$loading.finish();
								toaster.pop({
									type: 'success',
									title: 'Erfolgreich gelöscht!',
									body: 'Dateien wurden erfolgreich gelöscht.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true
								});
							}

						},
						function () {
							if(length !== i) {
								i++;
							} else {
								loadFiles();
								$loading.finish();
							}
						}
					);
				});
			}
		};

		vm.moveMedia = function (file) {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/media/mediaModalMove.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'MediaModalMoveFileController',
				controllerAs: 'vmm'
			});

			modalInstance.result.then(function (selectedFolder) {
				$loading.start();
				$media.moveFile(file.id, selectedFolder).then(
					function () {
						loadFiles();
						vm.selectedFiles = [];
						vm.selectedFile = [];
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich verschoben!',
							body: 'Datei wurde erfolgreich verschoben.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						vm.selectedFiles = [];
						vm.selectedFile = [];
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Datei konnte nicht verschoben werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			});
		};

		vm.moveMedias = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/media/mediaModalMove.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'MediaModalMoveFileController',
				controllerAs: 'vmm'
			});

			modalInstance.result.then(function (selectedFolder) {
				var i = 1,
					length = vm.selectedFiles.length;

				$loading.start();
				angular.forEach(vm.selectedFiles, function (file) {
					$media.moveFile(file, selectedFolder).then(
						function () {
							if(length !== i) {
								i++;
							} else {
								loadFiles();
								vm.selectedFiles = [];
								vm.selectedFile = [];
								$loading.finish();
								toaster.pop({
									type: 'success',
									title: 'Erfolgreich verschoben!',
									body: 'Medien wurden erfolgreich verschoben.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true
								});
							}

						},
						function () {
							if(length !== i) {
								i++;
							} else {
								loadFiles();
								vm.selectedFiles = [];
								vm.selectedFile = [];
								$loading.finish();
							}
						}
					);
				});
			});
		};

		load();

		function load() {
			if(vm.current_folder_id === '0') {
				vm.folder = {};

				$media.getFileFolders(vm.current_folder_id).then(
					function (folders) {
						vm.folders = $filter('listToMatrix')(folders, 6);
					},
					function () {
						vm.folders = [];
					}
				);
			} else {
				vm.folders = [];

				$media.getFileFolder(vm.current_folder_id).then(
					function (folder) {
						vm.folder = folder;
					},
					function () {
						vm.folder = {};
					}
				);
			}

			loadFiles();

		}

		function loadFiles() {
			$media.getFileList(vm.currentPage, vm.entryLimit, vm.current_folder_id).then(
				function (files) {
					vm.files = files;

					vm.totalItems = files.pagination.total;
					vm.noOfPages = files.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.files = [];

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$window.scrollTo(0, 0);
					$loading.finish();
				}
			);
		}
	}

	MediaModalMoveImageCtrl.$inject = ['$media', '$uibModalInstance'];

	function MediaModalMoveImageCtrl($media, $uibModalInstance) {
		var vm = this;
		vm.selectedFolder = '-1';

		vm.save = function () {
			$uibModalInstance.close(vm.selectedFolder);
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		load();

		function load() {
			$media.getFolders(0).then(
				function (folders) {
					vm.folders = folders;
				},
				function () {
					vm.folders = [];
				}
			);
		}
	}

	MediaModalMoveFileCtrl.$inject = ['$media', '$uibModalInstance'];

	function MediaModalMoveFileCtrl($media, $uibModalInstance) {
		var vm = this;
		vm.selectedFolder = '-1';

		vm.save = function () {
			$uibModalInstance.close(vm.selectedFolder);
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		load();

		function load() {
			$media.getFileFolders(0).then(
				function (folders) {
					vm.folders = folders;
				},
				function () {
					vm.folders = [];
				}
			);
		}
	}

	MediaUploadCtrl.$inject = ['Page', 'toaster', '$upload', '$state', '$media', '$stateParams'];

	function MediaUploadCtrl(Page, toaster, $upload, $state, $media, $stateParams) {
		var vm = this;
		Page.setTitle('Medien > Hochladen');
		vm.folder = 0;
		vm.fileinfos = {
			file: '',
			name: '',
			description: ''
		};

		vm.youtube = {
			file: '',
			name: '',
			url: ''
		};

		vm.submitImage = function () {
			$upload.upload({
				data: {
					image: vm.fileinfos.file,
					name: vm.fileinfos.name,
					description: vm.fileinfos.description,
					folder_id: vm.folder
				}
			}).then(
				function () {
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich hochgeladen!',
						body: 'Datei wurde erfolgreich hochgeladen.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					$state.go('app.media.overview-folder', {folder: vm.folder});
				}
			);
		};

		vm.submitYoutube = function () {
			var youtubeId = $media.fetchYoutubeId(vm.youtube.url);

			$media.uploadYoutube(vm.youtube.name, vm.youtube.description, youtubeId, vm.folder).then(
				function () {
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich hinzugefügt!',
						body: 'YouTube Video wurde erfolgreich hinzugefügt.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					$state.go('app.media.overview-folder', {folder: vm.folder});
				}
			);
		};

		load();

		function load() {
			if(angular.isDefined($stateParams.folder) && $stateParams.folder !== '') {
				vm.folder = $stateParams.folder;
			}
		}
	}

	MediaModalUploadImageCtrl.$inject = ['Page', 'toaster', '$upload', '$state', '$media', '$uibModalInstance', '$loading'];

	function MediaModalUploadImageCtrl(Page, toaster, $upload, $state, $media, $uibModalInstance, $loading) {
		var vm = this;
		vm.selectedFolder = '';
		vm.folders = [];
		vm.selectedTab = 'image';
		vm.fileinfos = {
			file: '',
			name: '',
			description: ''
		};

		vm.youtube = {
			file: '',
			name: '',
			url: ''
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		vm.selectTap = function (type) {
			vm.selectedTab = type;
		};

		vm.submit = function () {
			$loading.start();
			if(vm.selectedTab === 'image') {
				$upload.upload({
					data: {
						image: vm.fileinfos.file,
						name: vm.fileinfos.name,
						description: vm.fileinfos.description,
						folder_id: vm.selectedFolder
					}
				}).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich hochgeladen!',
							body: 'Datei wurde erfolgreich hochgeladen.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						$uibModalInstance.close(vm.selectedFolder);
						$loading.finish();
					}
				);
			} else {
				if(vm.selectedTab === 'youtube') {
					var youtubeId = $media.fetchYoutubeId(vm.youtube.url);

					$media.uploadYoutube(vm.fileinfos.name, vm.fileinfos.description, youtubeId, vm.selectedFolder).then(
						function () {
							toaster.pop({
								type: 'success',
								title: 'Erfolgreich hinzugefügt!',
								body: 'YouTube Video wurde erfolgreich hinzugefügt.',
								timeout: globalConfig.toastTimeout,
								showCloseButton: true
							});
							$uibModalInstance.close(vm.selectedFolder);
							$loading.finish();
						}
					);
				}
			}
		};

		load();

		function load() {
			$media.getFolders(0).then(
				function (folders) {
					vm.folders = folders;
				},
				function () {
					vm.folders = [];
				}
			);
		}
	}

	MediaModalUploadFileCtrl.$inject = ['Page', 'toaster', '$upload', '$state', '$media', '$uibModalInstance', '$loading'];

	function MediaModalUploadFileCtrl(Page, toaster, $upload, $state, $media, $uibModalInstance, $loading) {
		var vm = this;
		vm.selectedFolder = '';
		vm.folders = [];
		vm.fileinfos = {
			file: '',
			name: '',
			description: ''
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		vm.selectTap = function (type) {
			vm.selectedTab = type;
		};

		vm.formatBytes = function(bytes){
			return $upload.formatBytes(bytes);
		};

		vm.submit = function () {
			$loading.start();
			$upload.upload({
				data: {
					file: vm.fileinfos.file,
					name: vm.fileinfos.name,
					description: vm.fileinfos.description,
					folder_id: vm.selectedFolder
				}
			}, 'file').then(
				function () {
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich hochgeladen!',
						body: 'Datei wurde erfolgreich hochgeladen.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					$uibModalInstance.close(vm.selectedFolder);
					$loading.finish();
				}
			);
		};

		load();

		function load() {
			$media.getFileFolders(0).then(
				function (folders) {
					vm.folders = folders;
				},
				function () {
					vm.folders = [];
				}
			);
		}
	}

})(angular);

/* global angular, globalConfig */

(function (angular) {
	'use strict';

	angular.module('media.factory', [])
		.factory('$media', MediaFactory)
		.factory('$upload', UploadAPI);

	UploadAPI.$inject = ['$user', '$log', '$q', 'Upload'];
	function UploadAPI($user, $log, $q, Upload) {
		var user = $user.get();

		return {
			upload: upload,
			uploadMandantImage: uploadMandantImage,
			formatBytes: formatBytes
		};

		function refreshUser() {
			user = $user.get();
		}

		function upload(config, type) {
			var q = $q.defer();
			refreshUser();

			if(angular.isDefined(user.token) && user.token !== '') {
				config.headers = {
					'API-Token': user.token,
					'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
					'Authorization': 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU='
				};

				if(angular.isDefined(type)){
					if(type === 'image'){
						config.url = globalConfig.api.url + '/images';
					}

					if(type === 'derby'){
						config.url = globalConfig.api.url + '/bikes/import_csv';
					}

					if(type === 'derby-update'){
						config.url = globalConfig.api.url + '/bikes/import_csv/true';
					}

					if(type === 'news-csvimport'){
						config.url = globalConfig.api.url + '/news/selections';
					}

					if(type === 'file'){
						config.url = globalConfig.api.url + '/files';
					}
				} else {
					config.url = globalConfig.api.url + '/images';
				}

				Upload.upload(config).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					q.resolve(resp);
				}, function (resp) {
					//console.log('Error status: ' + resp.status);
					q.reject(resp);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
					q.notify(evt);
				});

			} else {
				
				
				q.reject();
			}

			return q.promise;
		}

		function uploadMandantImage(customerId, config) {
			var q = $q.defer();
			refreshUser();

			if(angular.isDefined(user.token) && user.token !== '') {
				config.headers = {
					'API-Token': user.token,
					'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
					'Authorization': 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU='
				};

				config.url = globalConfig.api.url + '/images/mandant/' + customerId;

				Upload.upload(config).then(function (resp) {
					//console.log('Success ' + resp.config.data.file.name + 'uploaded. Response: ' + resp.data);
					q.resolve(resp);
				}, function (resp) {
					//console.log('Error status: ' + resp.status);
					q.reject(resp);
				}, function (evt) {
					//var progressPercentage = parseInt(100.0 * evt.loaded / evt.total);
					//console.log('progress: ' + progressPercentage + '% ' + evt.config.data.file.name);
					q.notify(evt);
				});

			} else {
				
				
				q.reject();
			}

			return q.promise;
		}

		function formatBytes(a, b) {
			if(0 == a) {
				return '0 Bytes';
			}
			var c = 1024, d = b || 2, e = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
				f = Math.floor(Math.log(a) / Math.log(c));
			return parseFloat((a / Math.pow(c, f)).toFixed(d)) + ' ' + e[f];
		}
	}

	MediaFactory.$inject = ['$q', '$api', '$log'];
	function MediaFactory($q, $api, $log) {
		return {
			getList: getList,
			getFileList: getFileList,
			getFolders: getFolders,
			getFileFolders: getFileFolders,
			getFolder: getFolder,
			getFileFolder: getFileFolder,
			addFolder: addFolder,
			addFileFolder: addFileFolder,
			changeFolder: changeFolder,
			changeFileFolder: changeFileFolder,
			deleteFolder: deleteFolder,
			deleteFileFolder: deleteFileFolder,
			deleteImage: deleteImage,
			deleteFile: deleteFile,
			fetchYoutubeId: fetchYoutubeId,
			uploadYoutube: uploadYoutube,
			moveMedia: moveMedia,
			moveFile: moveFile
		};

		function getList(page, perpage, videos, folder) {
			var q = $q.defer(),
				customList = {
					'sort': '-created_at'
				};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 24;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if(angular.isUndefined(videos)) {
				videos = true;
			}

			if(videos === false) {
				customList.type = 'IN(1,2)';
			}

			if(angular.isDefined(folder)) {
				customList.folder_id = folder;
			}

			$api.withToken().all('images').customGETLIST('', customList).then(
				function (medias) {
					q.resolve(medias);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getFileList(page, perpage, folder, type) {
			var q = $q.defer(),
				customList = {
					'sort': '-created_at'
				};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 24;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if(angular.isDefined(folder) && folder !== false) {
				customList.folder_id = folder;
			}

			if(angular.isDefined(type)) {
				customList.type = type;
			}

			$api.withToken().all('files').customGETLIST('', customList).then(
				function (files) {
					q.resolve(files);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getFolders(parent_id) {
			var q = $q.defer(),
				customList = {'parent_id': parent_id, 'sort': '+name'};

			$api.withToken().all('imagefolders').customGETLIST('', customList).then(
				function (folders) {
					if(angular.isDefined(folders.status) && folders.status === false) {
						q.reject();
					} else {
						q.resolve(folders);
					}
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getFileFolders(parent_id) {
			var q = $q.defer(),
				customList = {'parent_id': parent_id, 'sort': '+name'};

			$api.withToken().all('filefolders').customGETLIST('', customList).then(
				function (folders) {
					if(angular.isDefined(folders.status) && folders.status === false) {
						q.reject();
					} else {
						q.resolve(folders);
					}
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getFolder(id) {
			var q = $q.defer();

			$api.withToken().one('imagefolders', id).customGET('', {}).then(
				function (folder) {
					q.resolve(folder.result);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getFileFolder(id) {
			var q = $q.defer();

			$api.withToken().one('filefolders', id).customGET('', {}).then(
				function (folder) {
					q.resolve(folder.result);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function addFolder(name, parent_id) {
			var q = $q.defer();

			$api.withToken().all('imagefolders').post({name: name, parent_id: parent_id}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function addFileFolder(name, parent_id) {
			var q = $q.defer();

			$api.withToken().all('filefolders').post({name: name, parent_id: parent_id}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function changeFolder(folder_id, folder_name) {
			var q = $q.defer();

			$api.withToken().one('imagefolders', folder_id).customPUT({name: folder_name}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function changeFileFolder(folder_id, folder_name) {
			var q = $q.defer();

			$api.withToken().one('filefolders', folder_id).customPUT({name: folder_name}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function deleteFolder(folder_id) {
			var q = $q.defer();

			$api.withToken().one('imagefolders', folder_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function deleteFileFolder(folder_id) {
			var q = $q.defer();

			$api.withToken().one('filefolders', folder_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function deleteImage(image_id) {
			var q = $q.defer();

			$api.withToken().one('images', image_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function deleteFile(file_id) {
			var q = $q.defer();

			$api.withToken().one('files', file_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function fetchYoutubeId(link) {
			function contains(str, substr) {
				return (str.indexOf(substr) > -1);
			}

			var youtubeRegexp = /https?:\/\/(?:[0-9A-Z-]+\.)?(?:youtu\.be\/|youtube(?:-nocookie)?\.com\S*[^\w\s-])([\w-]{11})(?=[^\w-]|$)(?![?=&+%\w.-]*(?:['"][^<>]*>|<\/a>))[?=&+%\w.-]*/ig;
			var id = link.replace(youtubeRegexp, '$1');

			if(contains(id, ';')) {
				var pieces = id.split(';');

				if(contains(pieces[1], '%')) {
					var uriComponent = decodeURIComponent(pieces[1]);
					id = ('http://youtube.com' + uriComponent)
						.replace(youtubeRegexp, '$1');
				} else {
					id = pieces[0];
				}
			} else {
				if(contains(id, '#')) {
					id = id.split('#')[0];
				}
			}

			return id;
		}

		function uploadYoutube(name, description, youtube, folder) {
			var q = $q.defer();

			$api.withToken().all('images').post({name: name, description: description, youtube: youtube, folder_id: folder}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function moveMedia(media_id, folder) {
			var q = $q.defer();

			$api.withToken().one('images', media_id).customPUT({folder_id: folder}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function moveFile(file_id, folder) {
			var q = $q.defer();

			$api.withToken().one('files', file_id).customPUT({folder_id: folder}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

	}

})(angular);

/* global globalConfig */

(function (angular) {
	'use strict';

	angular.module('media.directive', []).directive('mediaImage', mediaImage).directive('mediaBrowser', mediaBrowser);

	function mediaImage() {
		return {
			restrict: 'EAC',
			link: function (scope, elm, attrs) {
				scope.$watch(attrs.image, function (value) {
					if (value !== null && angular.isDefined(value) && value !== '') {
						var url = globalConfig.api.mediaUrl + '/';
						url += value.mandant_id + '/images/';

						if (angular.isDefined(attrs.size) && attrs.size !== null && attrs.size === 'thumb') {
							url += value.thumbnail;
						} else {
							url += value.file;
						}

						var alt = value.name;
					}

					var tag = '<img alt="' + alt + '" src="' + url + '" class="img-rounded"/>';
					elm.append(tag);
				});
			},
		};
	}

	mediaBrowser.$inject = ['$media', '$upload', 'toaster', '$timeout', '$uibModal'];

	function mediaBrowser($media, $upload, toaster, $timeout, $uibModal) {
		var MediaBrowserController = function () {
			var vm = this;
			vm.selectedFolder = '0';
			vm.selected = {};
			vm.medias = [];
			vm.folders = [];
			vm.active = 'medias';

			// Pagination
			vm.currentPage = 1;
			vm.displayItems = [];
			vm.totalItems = 0;
			vm.entryLimit = 8;
			vm.noOfPages = 1;

			vm.selectMedia = function (media) {
				vm.selected = media;
				vm.media = media;
				vm.selectedMedia({ selectedMedia: media });
			};
			vm.removeMedia = function () {
				vm.selected = {};
				vm.selectedMedia({ selectedMedia: {} });
			};
			vm.reloadMedia = function () {
				vm.currentPage = 1;
				vm.removeMedia();
				load();
			};

			vm.uploadClose = function () {
				vm.active = 'medias';
			};

			vm.changePage = function () {
				$media.getList(vm.currentPage, vm.entryLimit, vm.videos, vm.selectedFolder).then(function (medias) {
					vm.medias = medias;
				});
			};

			vm.changeFolder = function () {
				loadMedias();
			};

			vm.uploadMedia = function () {
				var modalInstance = $uibModal.open({
					templateUrl: 'static/templates/media/mediaModalImageUpload.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					controller: 'MediaModalUploadImageController',
					controllerAs: 'vmm',
				});

				modalInstance.result.then(function (selectedFolder) {
					vm.selectedFolder = selectedFolder;
					loadMedias();
				});
			};

			load();

			function load() {
				$timeout(function () {
					if (angular.isUndefined(vm.entryLimit)) {
						vm.entryLimit = 8;
					}

					$timeout(function () {
						if (angular.isDefined(vm.media) && angular.isDefined(vm.media.id) && vm.media.id !== '0') {
							//vm.selected = angular.copy(vm.media);
							vm.selectMedia(vm.media);
							vm.selectedFolder = vm.media.folder_id;
							loadMedias();
						}
					}, 2000);

					if (angular.isUndefined(vm.videos)) {
						vm.videos = true;
					} else {
						if (angular.isString(vm.videos)) {
							vm.videos = vm.videos === 'true';
						}
					}

					$media.getFolders(vm.current_folder_id).then(
						function (folders) {
							vm.folders = folders;
						},
						function () {
							vm.folders = [];
						}
					);

					loadMedias();
				});
			}

			function loadMedias() {
				$media.getList(1, vm.entryLimit, vm.videos, vm.selectedFolder).then(
					function (medias) {
						vm.medias = medias;

						vm.totalItems = medias.pagination.total;
						vm.noOfPages = medias.pagination.pages;
					},
					function () {
						vm.medias = [];

						vm.totalItems = 0;
						vm.noOfPages = 0;
					}
				);
			}
		};

		return {
			restrict: 'EA',
			scope: {
				entryLimit: '@entryLimit',
				selectedMedia: '&selectedMedia',
				videos: '@videos',
				media: '=media',
			},
			templateUrl: 'static/templates/media/browser.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: MediaBrowserController,
			controllerAs: 'bvm',
			bindToController: true,
		};
	}
})(angular);

(function (angular) {
	'use strict';

	angular.module('externallink', ['externallink.factory', 'externallink.controller', 'externallink.directive']);
})(angular);

(function (angular) {
	'use strict';

	angular.module('externallink.factory', []).factory('$externallink', ExternallinkFactory);

	ExternallinkFactory.$inject = ['$q', '$api', '$log'];

	function ExternallinkFactory($q, $api, $log) {
		var classes = [];

		return {
			getClasses: getClasses,
			addNewExternalLink: addNewExternalLink,
			saveExternalLink: saveExternalLink,
			remove: remove,
		};

		function getClasses() {
			var q = $q.defer(),
				customList = {};

			if (classes.length < 1) {
				$api
					.withToken()
					.all('externallinkclasses')
					.customGETLIST('', customList)
					.then(
						function (tmpResult) {
							classes = tmpResult;
							q.resolve(tmpResult);
						},
						function (error) {
							
							q.reject();
						}
					);
			} else {
				q.resolve(classes);
			}

			return q.promise;
		}

		function addNewExternalLink(newExternalLink, icon) {
			var q = $q.defer(),
				tmpExternalLink = {
					name: newExternalLink.name,
					class: newExternalLink.class,
					icon: icon.name,
					link: newExternalLink.link,
				};

			if (tmpExternalLink.class === 'content') {
				var tmpLink = tmpExternalLink.link.split('-');
				tmpExternalLink.link = tmpLink[1];
				if (tmpLink[0] === 'pg') {
					tmpExternalLink.class = 'contentgroup';
				}
			}

			$api
				.withToken()
				.all('externallinks')
				.post(tmpExternalLink)
				.then(
					function (tmpResult) {
						q.resolve(tmpResult.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function saveExternalLink(editExternalLink, icon) {
			var q = $q.defer(),
				customPut = {
					name: editExternalLink.name,
					class: editExternalLink.class,
					icon: icon.name,
					link: editExternalLink.link,
				};

			if (customPut.class === 'content') {
				var tmpLink = customPut.link.split('-');
				customPut.link = tmpLink[1];
				if (tmpLink[0] === 'pg') {
					customPut.class = 'contentgroup';
				}
			}

			$api
				.withToken()
				.one('externallinks', editExternalLink.id)
				.customPUT(customPut)
				.then(
					function (tmpResult) {
						q.resolve(tmpResult.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function remove(externalLinkId) {
			var q = $q.defer();

			$api
				.withToken()
				.one('externallinks', externalLinkId)
				.remove()
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}
	}
})(angular);

/* eslint-disable indent */
/* global _ */

(function (angular) {
	'use strict';

	angular.module('externallink.controller', []).controller('ExternalLinkDirectiveController', DirectiveCtrl);

	DirectiveCtrl.$inject = ['$window', 'toaster', '$externallink', '$surveys', '$contentgroup', '$media', '$brands', '$events', '$stores', '$contests', '$raffle'];

	function DirectiveCtrl($window, toaster, $externallink, $surveys, $contentgroup, $media, $brands, $events, $stores, $contests, $raffle) {
		var vm = this;
		vm.showAdd = false;
		vm.showEdit = false;
		vm.defaultIcon = true;
		vm.newExternalLink = {
			name: '',
			link: '',
			class: '',
		};
		vm.editExternalLink = {
			id: '',
			name: '',
			link: '',
			class: '',
		};
		vm.external_classes = [];
		vm.questionaries = [];
		vm.pagegroups = [];
		vm.brands = [];
		vm.events = [];
		vm.contests = [];
		vm.stores = [];
		vm.raffles = [];
		vm.popoverOpen = false;

		vm.icons = [
			{ name: 'link', class: 'fa fa-link' },
			{ name: 'pdf', class: 'fa fa-file-pdf' },
			{ name: 'word', class: 'fa fa-file-word' },
			{ name: 'excel', class: 'fa fa-file-excel' },
			{ name: 'powerpoint', class: 'fa fa-file-powerpoint' },
			{ name: 'at', class: 'fa fa-at' },
			{ name: 'file-download', class: 'fa fa-file-download' },
			{ name: 'youtube', class: 'fab fa-youtube' },
			{ name: 'facebook', class: 'fab fa-facebook-square' },
			{ name: 'instagram', class: 'fab fa-instagram' },
			{ name: 'xing', class: 'fab fa-xing' },
			{ name: 'phone', class: 'fa fa-phone' },
			{ name: 'question-circle', class: 'fa fa-question-circle' },
			{ name: 'qrcode', class: 'fa fa-qrcode' },
			{ name: 'credit-card', class: 'fa fa-credit-card' },
			{ name: 'map-signs', class: 'fa fa-map-signs' },
			{ name: 'address-card', class: 'fa fa-address-card' },
			{ name: 'bullhorn', class: 'fa fa-bullhorn' },
			{ name: 'bus', class: 'fa fa-bus' },
			{ name: 'calendar', class: 'fa fa-calendar' },
			{ name: 'camera', class: 'fa fa-camera' },
			{ name: 'car', class: 'fa fa-car' },
			{ name: 'chart-pie', class: 'fa fa-chart-pie' },
			{ name: 'cloud', class: 'fa fa-cloud' },
			{ name: 'cogs', class: 'fa fa-cogs' },
			{ name: 'comment', class: 'fa fa-comment' },
			{ name: 'grin', class: 'fa fa-grin' },
			{ name: 'meh', class: 'fa fa-meh' },
			{ name: 'frown', class: 'fa fa-frown' },
			{ name: 'headset', class: 'fa fa-headset' },
			{ name: 'heart', class: 'fa fa-heart' },
			{ name: 'id-card', class: 'fa fa-id-card' },
			{ name: 'info', class: 'fa fa-info' },
			{ name: 'image', class: 'fa fa-image' },
			{ name: 'images', class: 'fa fa-images' },
			{ name: 'newspaper', class: 'fa fa-newspaper' },
			{ name: 'shopping-cart', class: 'fa fa-shopping-cart' },
			{ name: 'sign', class: 'fa fa-sign' },
			{ name: 'sync', class: 'fa fa-sync' },
			{ name: 'tag', class: 'fa fa-tag' },
			{ name: 'tags', class: 'fa fa-tags' },
			{ name: 'thumbs-up', class: 'fa fa-thumbs-up' },
			{ name: 'thumbs-down', class: 'fa fa-thumbs-down' },
			{ name: 'train', class: 'fa fa-train' },
			{ name: 'trash', class: 'fa fa-trash' },
			{ name: 'user', class: 'fa fa-user' },
			{ name: 'video', class: 'fa fa-video' },
			{ name: 'store', class: 'fa fa-store' },
			{ name: 'gift', class: 'fa fa-gift' },
		];

		vm.pagination = {
			currentPage: 0,
			pageSize: 12,
			numberOfPages: function () {
				return Math.ceil(vm.icons.length / vm.pagination.pageSize);
			},
		};

		vm.selectedIcon = {};

		vm.selectIcon = function (icon) {
			vm.defaultIcon = false;
			vm.popoverOpen = false;
			vm.selectedIcon = icon;
		};

		vm.createExternalLink = function () {
			vm.showAdd = true;
			vm.selectedIcon = vm.icons[0];
			vm.popoverOpen = false;

			vm.closeEditExternalLink();
			loadClasses();
		};

		vm.changeCreateExternalLinkClass = function () {
			vm.newExternalLink.link = '';
			vm.newExternalLink.mode = '';

			change_icon(vm.newExternalLink.class);

			if (vm.newExternalLink.class === 'questionary') {
				$surveys.getQuestionariesList(1, 99999999).then(
					function (questionaries) {
						vm.questionaries = questionaries;
					},
					function () {
						vm.questionaries = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'content') {
				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'pdf') {
				vm.newExternalLink.mode = 'link';

				$media.getFileList(1, 999999, false, 'pdf').then(
					function (files) {
						vm.files = files;
					},
					function () {
						vm.files = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'brands') {
				$brands.getList(1, 999999).then(
					function (brands) {
						vm.brands = brands;
					},
					function () {
						vm.brands = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'events') {
				$events.getList(1, 999999).then(
					function (events) {
						vm.events = events;
					},
					function () {
						vm.events = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'contests') {
				$contests.getList(1, 999999).then(
					function (contests) {
						vm.contests = contests;
					},
					function () {
						vm.contests = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'stores') {
				$stores.getList(1, 999999).then(
					function (stores) {
						vm.stores = stores;
					},
					function () {
						vm.stores = [];
					}
				);
			}

			if (vm.newExternalLink.class === 'raffle') {
				$raffle.getBackendList().then(
					function (raffles) {
						vm.raffles = raffles;
					},
					function () {
						vm.raffles = [];
					}
				);
			}
		};

		vm.saveNewExternalLink = function () {
			vm.links = angular.isDefined(vm.links) && vm.links instanceof Array ? vm.links : [];

			$externallink.addNewExternalLink(vm.newExternalLink, vm.selectedIcon).then(function (newExternalLink) {
				vm.links.push(newExternalLink);
				vm.changeLinks({ links: vm.links });
				vm.closeCreateExternalLink();
			});
		};

		vm.closeCreateExternalLink = function () {
			vm.showAdd = false;
			vm.popoverOpen = false;
			vm.newExternalLink = {
				name: '',
				link: '',
				class: '',
			};
		};

		vm.changeExternalLink = function (externalLink) {
			vm.showEdit = true;
			vm.selectedIcon = vm.icons[0];
			vm.popoverOpen = false;

			vm.closeCreateExternalLink();
			loadClasses();

			vm.editExternalLink = angular.copy(externalLink);
			vm.selectedIcon = _.find(vm.icons, { name: externalLink.icon });

			if (vm.editExternalLink.class === 'questionary') {
				$surveys.getQuestionariesList(1, 99999999).then(
					function (questionaries) {
						vm.questionaries = questionaries;
					},
					function () {
						vm.questionaries = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'content') {
				vm.editExternalLink.link = 'p-' + vm.editExternalLink.link;
				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'contentgroup') {
				vm.editExternalLink.class = 'content';
				vm.editExternalLink.link = 'pg-' + vm.editExternalLink.link;
				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'pdf') {
				if (validURL(vm.editExternalLink.value)) {
					vm.editExternalLink.mode = 'link';
				} else {
					vm.editExternalLink.mode = 'file';
				}

				$media.getFileList(1, 999999, false, 'pdf').then(
					function (files) {
						vm.files = files;
					},
					function () {
						vm.files = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'brands') {
				$brands.getList(1, 999999).then(
					function (brands) {
						vm.brands = brands;
					},
					function () {
						vm.brands = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'events') {
				$events.getList(1, 999999).then(
					function (events) {
						vm.events = events;
					},
					function () {
						vm.events = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'contests') {
				$contests.getList(1, 999999).then(
					function (contests) {
						vm.contests = contests;
					},
					function () {
						vm.contests = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'stores') {
				$stores.getList(1, 999999).then(
					function (stores) {
						vm.stores = stores;
					},
					function () {
						vm.stores = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'raffle') {
				$raffle.getBackendList().then(
					function (raffles) {
						vm.raffles = raffles;
					},
					function () {
						vm.raffles = [];
					}
				);
			}
		};

		vm.changeEditExternalLinkClass = function () {
			vm.editExternalLink.link = '';
			vm.editExternalLink.mode = '';

			if (vm.editExternalLink.class === 'questionary') {
				$surveys.getQuestionariesList(1, 99999999).then(
					function (questionaries) {
						vm.questionaries = questionaries;
					},
					function () {
						vm.questionaries = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'content') {
				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'pdf') {
				if (validURL(vm.editExternalLink.value)) {
					vm.editExternalLink.mode = 'link';
				} else {
					vm.editExternalLink.mode = 'file';
				}

				$media.getFileList(1, 999999, false, 'pdf').then(
					function (files) {
						vm.files = files;
					},
					function () {
						vm.files = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'brands') {
				$brands.getList(1, 999999).then(
					function (brands) {
						vm.brands = brands;
					},
					function () {
						vm.brands = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'events') {
				$events.getList(1, 999999).then(
					function (events) {
						vm.events = events;
					},
					function () {
						vm.events = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'contests') {
				$contests.getList(1, 999999).then(
					function (contests) {
						vm.contests = contests;
					},
					function () {
						vm.contests = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'stores') {
				$stores.getList(1, 999999).then(
					function (stores) {
						vm.stores = stores;
					},
					function () {
						vm.stores = [];
					}
				);
			}

			if (vm.editExternalLink.class === 'raffle') {
				$raffle.getBackendList().then(
					function (raffles) {
						vm.raffles = raffles;
					},
					function () {
						vm.raffles = [];
					}
				);
			}
		};

		vm.saveEditExternalLink = function () {
			$externallink.saveExternalLink(vm.editExternalLink, vm.selectedIcon).then(function (editExternalLink) {
				var index = _.findIndex(vm.links, { id: editExternalLink.id });
				vm.links.splice(index, 1, editExternalLink);
				vm.closeEditExternalLink();
			});
		};

		vm.closeEditExternalLink = function () {
			vm.showEdit = false;
			vm.popoverOpen = false;
			vm.editExternalLink = {
				id: '',
				name: '',
				link: '',
				class: '',
			};
		};

		vm.removeExternalLink = function (externalLink, index) {
			if ($window.confirm('Die Verlinkung wirklich löschen? Dies kann nicht mehr rückgängig gemacht werden!')) {
				$externallink.remove(externalLink.id).then(function () {
					vm.links.splice(index, 1);
					vm.changeLinks({ links: vm.links });
				});
			}
		};

		load();

		function load() {
			vm.selectedIcon = vm.icons[0];
		}

		function validURL(str) {
			var pattern = new RegExp(
				'^(https?:\\/\\/)?' + // protocol
					'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
					'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
					'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
					'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
					'(\\#[-a-z\\d_]*)?$',
				'i'
			); // fragment locator
			return !!pattern.test(str);
		}

		function loadClasses() {
			if (vm.external_classes.length < 1) {
				$externallink.getClasses().then(
					function (external_classes) {
						vm.external_classes = external_classes;
					},
					function () {
						vm.external_classes = [];
					}
				);
			}
		}

		function change_icon(className) {
			var icon;

			switch (className) {
				case 'questionary':
					icon = 'question-circle';
					break;
				case 'events':
					icon = 'calendar';
					break;
				case 'pdf':
					icon = 'pdf';
					break;
				case 'word':
					icon = 'word';
					break;
				case 'excel':
					icon = 'excel';
					break;
				case 'powerpoint':
					icon = 'powerpoint';
					break;
				case 'email':
					icon = 'at';
					break;
				case 'download':
					icon = 'file-download';
					break;
				case 'facebook':
					icon = 'facebook';
					break;
				case 'xing':
					icon = 'xing';
					break;
				case 'instagram':
					icon = 'instagram';
					break;
				case 'call':
					icon = 'phone';
					break;
				case 'content':
					icon = 'link';
					break;
				case 'maps':
					icon = 'map-signs';
					break;
				case 'customercard':
					icon = 'address-card';
					break;
				case 'brands':
					icon = 'tag';
					break;
				case 'shop':
					icon = 'store';
					break;
				case 'vouchers':
					icon = 'tag';
					break;
				case 'chat':
					icon = 'comment';
					break;
				case 'raffle':
					icon = 'gift';
					break;
				default:
					icon = 'link';
			}

			if (vm.defaultIcon) {
				vm.selectedIcon = _.find(vm.icons, { name: icon });
			}
		}
	}
})(angular);

(function (angular) {
	'use strict';

	angular.module('externallink.directive', [])
		.directive('externalLinkPanel', externalLinkPanel);

	function externalLinkPanel() {
		return {
			restrict: 'EA',
			scope: {
				'links': '=',
				'changeLinks': '&changeLinks'
			},
			//replace: true,
			templateUrl: 'static/templates/externallink/directivepanel.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'ExternalLinkDirectiveController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('content', ['content.factory', 'content.controller']);

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('content.controller', [])
		.controller('ContentOverviewController', OverviewCtrl)
		.controller('ContentEditController', EditCtrl);

	OverviewCtrl.$inject = ['Page', '$content'];
	function OverviewCtrl(Page, $content) {
		var vm = this;
		Page.setTitle('Inhalt');
		vm.pages = [];

		load();

		function load() {
			$content.getPages().then(
				function(pages) {
					vm.pages = pages;
				},
				function() {
					vm.pages = [];
				}
			);
		}
	}

	EditCtrl.$inject = ['Page', '$content', '$stateParams', 'toaster', '$state'];
	function EditCtrl(Page, $content, $stateParams, toaster, $state) {
		var vm = this;
		Page.setTitle('Inhalt > Bearbeiten');
		vm.showMedia = false;
		vm.contents = [];
		vm.showBrowser = -1;

		vm.dragControlListeners = {
			accept: true,
			itemMoved: function() {
				vm.showBrowser = -1;
			},
			orderChanged: function() {
			},
			clone: false,
			allowDuplicates: false
		};

		vm.remove = function(index) {
			console.log('remove '+index);
			if(vm.contents[index].id !== '0'){
				vm.contents[index].deleted = '1';
			}else{
				vm.contents.splice(index, 1);
			}
		};

		vm.removeMedia = function(index) {
			vm.contents[index].title_image_id = 0;
			vm.contents[index].title_image = {};
		};

		vm.openMediaBrowser = function(index) {
			vm.showBrowser = index;
		};

		vm.showMediaBrowser = function(index) {
			return vm.showBrowser === index;
		};

		vm.selectMedia = function(media) {
			var type = 'jpg',
				index = vm.showBrowser;

			if(angular.isUndefined(media.id)){
				vm.showBrowser = -1;
				vm.contents[index].title_image_id = 0;
				vm.contents[index].title_image = {};
			}else{
				vm.contents[index].title_image_id = media.id;
				vm.contents[index].mandant_id = media.mandant_id;

				if(media.type === '3') {
					type = 'youtube';
					vm.contents[index].title_image = {
						mandant_id: media.mandant_id,
						content: media.file,
						type: type
					};
				} else {
					vm.contents[index].title_image = {
						mandant_id: media.mandant_id,
						file: media.file,
						type: type
					};
				}

				vm.showBrowser = -1;
			}
		};

		vm.add = function(){
			vm.contents.push({id: '0', title: '', content: '', title_image_id: '0', language_id: '1', form_id: '0'});
		};

		vm.save = function() {
			$content.saveContents($stateParams.id, vm.contents).then(
				function() {
					toaster.pop({
						type: 'success',
						title: 'Inhalt gespeichert!',
						body: 'Der Inhalt wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					$state.go('app.content.overview');
				}
			);
		};

		load();

		function load() {
			$content.getContents($stateParams.id).then(
				function(contents) {
					vm.contents = _.sortBy(contents, 'position');
				},
				function() {
					vm.contents = [];
				}
			);
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('content.factory', [])
		.factory('$content', ContentFactory);

	ContentFactory.$inject = ['$q', '$api', '$log'];
	function ContentFactory($q, $api, $log) {
		return {
			getPages: getPages,
			getContents: getContents,
			saveContents: saveContents
		};

		function getPages() {
			var q = $q.defer();

			$api.withToken().all('pages').getList().then(
				function(pages) {
					q.resolve(pages);
				},
				function(error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getContents(page_id) {
			var q = $q.defer();

			$api.withToken().one('pages', page_id).all('contents').getList().then(
				function(pages) {
					q.resolve(pages);
				},
				function(error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function saveContents(page_id, contents) {
			var q = $q.defer(),
				i = 0,
				l = contents.length;

			function resolve(){
				if(l === i) {
					q.resolve();
				}
			}

			angular.forEach(contents, function(content) {
				i++;

				if(content.deleted === '1') {
					
					$api.withToken().one('contents', content.id).remove().then(
						function() {
							resolve();
						}
					);
				} else {
					var editContent = {
						page_id: page_id,
						title: content.title,
						position: i.toString(),
						content: content.content,
						title_image_id: content.title_image_id
					};

					if(content.id !== '0') {
						
						$api.withToken().one('contents', content.id).customPUT(editContent).then(
							function() {
								resolve();
							}
						);
					} else {
						
						$api.withToken().all('contents').post(editContent).then(
							function() {
								resolve();
							}
						);
					}
				}

			});

			return q.promise;
		}

	}

})(angular);

(function(angular) {
	'use strict';

	angular.module('contentgroup', ['contentgroup.factory', 'contentgroup.controller', 'contentgroup.directive']);

})(angular);

/* global _, globalConfig */

(function (angular) {
	'use strict';

	angular.module('contentgroup.controller', [])
		.controller('ContentGroupOverviewController', OverviewCtrl)
		.controller('ContentGroupPageOverviewController', OverviewPageCtrl)
		.controller('ContentGroupEditController', EditCtrl)
		.controller('ContentgroupIconDirectiveController', IconDirectiveCtrl);

	OverviewCtrl.$inject = ['Page', '$contentgroup'];

	function OverviewCtrl(Page, $contentgroup) {
		var vm = this;
		Page.setTitle('Inhalt');
		vm.pagegroups = [];

		load();

		function load() {
			$contentgroup.getGroups().then(
				function (pagegroups) {
					vm.pagegroups = pagegroups;
				},
				function () {
					vm.pagegroups = [];
				}
			);
		}
	}

	OverviewPageCtrl.$inject = ['Page', '$contentgroup', '$stateParams', '$window', 'toaster', '$user', '$loading', '$location', '$anchorScroll'];

	function OverviewPageCtrl(Page, $contentgroup, $stateParams, $window, toaster, $user, $loading, $location, $anchorScroll) {
		var vm = this;
		Page.setTitle('Inhalt');
		vm.pagegroup = {};
		vm.pages = [];
		vm.pgId = 0;
		vm.loading = false;

		vm.dragControlListeners = {
			accept: true,
			itemMoved: function () {

			},
			orderChanged: function () {
				savePages();
			},
			clone: false,
			allowDuplicates: false
		};

		vm.add = function () {
			var pagename = $window.prompt('Geben Sie den Namen der neuen Inhaltsseite an:', '');
			if(pagename !== null && pagename !== '') {
				$loading.start();
				$contentgroup.addPage(pagename, vm.pgId, vm.pages.length).then(
					function () {
						load(true);
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Seite wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Seite konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			} else {
				if(pagename === ''){
					vm.add();
				}
			}
		};

		vm.remove = function (page) {
			var deleteNews = $window.confirm(page.name + ' wirklich löschen? Dabei gehen alle Inhalte in dieser Seite verloren!');

			if(deleteNews) {
				$loading.start();
				$contentgroup.removePage(page.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Seite wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Seite konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.save = function () {
			vm.loading = true;
			$contentgroup.save($stateParams.id, vm.pagegroup.fallback_text).then(
				function () {
					vm.loading = false;
				},
				function () {
					vm.loading = false;
				}
			);
		};

		vm.changeRole = function (page_id, new_role) {
			$contentgroup.savePage(page_id, new_role).then(
				function () {
					loadPages(vm.pagegroup.id);
				}
			);
		};

		vm.orderPagesByName = function(){
			vm.pages = _.orderBy(vm.pages, function(input){ return input.name.toLowerCase(); }, ['name'],['asc']);
			$loading.start();
			$contentgroup.savePages(vm.pages).then(
				function () {
					loadPages(vm.pagegroup.id);
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.updatePageTitle = function(page){
			if(page.name !== ''){
				$contentgroup.changePage(page.id, page.name).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Name wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						loadPages(vm.pgId);
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Name konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			} else {
				toaster.pop({
					type: 'error',
					title: 'Nicht geändert!',
					body: 'Name konnte nicht geändert werden! Der Name darf nicht leer sein.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true
				});
				loadPages(vm.pgId);
			}
		};

		vm.changeIcon = function(page, icon) {
			$loading.start();
			$contentgroup.changeIcon(page, icon).then(
				function () {
					loadPages(vm.pagegroup.id);
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		};

		function savePages() {
			$loading.start();
			$contentgroup.savePages(vm.pages).then(
				function () {
					loadPages(vm.pagegroup.id);
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		}

		load();

		function load(jumpBottom) {
			vm.pgId = $stateParams.id;
			$contentgroup.getGroup($stateParams.id).then(
				function (pagegroup) {
					vm.pagegroup = pagegroup;
					loadPages(pagegroup.id, jumpBottom);
					loadRoles();
				},
				function () {
					vm.pagegroup = {};
				}
			);
		}

		function loadPages(id, jumpBottom) {
			$contentgroup.getPages(id).then(
				function (pages) {
					vm.pages = pages;

					if(jumpBottom) {
						$location.hash('bottom');
						$anchorScroll();
					}
				},
				function () {
					vm.pages = [];
				}
			);
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {

				}
			);
		}
	}

	EditCtrl.$inject = ['Page', '$contentgroup', '$stateParams', 'toaster', '$state', '$loading', '$window', '$location', '$anchorScroll'];

	function EditCtrl(Page, $contentgroup, $stateParams, toaster, $state, $loading, $window, $location, $anchorScroll) {
		var vm = this;
		Page.setTitle('Inhalt > Bearbeiten');
		vm.showMedia = false;
		vm.pagegroup = {};
		vm.page = {};
		vm.contents = [];
		vm.showBrowser = -1;

		vm.dragControlListeners = {
			accept: true,
			itemMoved: function () {
				vm.showBrowser = -1;
			},
			orderChanged: function () {
				$loading.start();
				$contentgroup.savePositions($stateParams.id, vm.contents).then(
					function () {
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Position gespeichert!',
							body: 'Die Position wurde erfolgreich gespeichert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
					}
				);
			},
			clone: false,
			allowDuplicates: false
		};

		vm.remove = function (content) {
			if($window.confirm('Den Inhaltsblock wirklich löschen? Dies kann nicht mehr rückgängig gemacht werden!')) {
				$loading.start();
				$contentgroup.removeContent(content).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Inhaltsblock erfolgreich gelöscht!',
							body: 'Der Inhaltsblock wurde erfolgreich gelöscht.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
					}
				);
			}
		};

		vm.removeMedia = function (index) {
			vm.contents[index].title_image_id = 0;
			vm.contents[index].title_image = {};
		};

		vm.openMediaBrowser = function (index) {
			vm.showBrowser = index;
		};

		vm.showMediaBrowser = function (index) {
			return vm.showBrowser === index;
		};

		vm.selectMedia = function (media) {
			var type = '1',
				index = vm.showBrowser;

			if(angular.isUndefined(media.id)) {
				vm.showBrowser = -1;
				vm.contents[index].title_image_id = 0;
				vm.contents[index].title_image = {};
			} else {
				vm.contents[index].title_image_id = media.id;
				vm.contents[index].mandant_id = media.mandant_id;

				if(media.type === '3') {
					type = '3';
					vm.contents[index].title_image = {
						mandant_id: media.mandant_id,
						content: media.file,
						file: media.file,
						type: type
					};
				} else {
					vm.contents[index].title_image = {
						mandant_id: media.mandant_id,
						file: media.file,
						type: type
					};
				}

				vm.showBrowser = -1;
			}
		};

		vm.add = function () {
			$loading.start();
			$contentgroup.addContent($stateParams.id, (vm.contents.length + 1)).then(
				function () {
					load(true);
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Inhaltsblock erstellt!',
						body: 'Der Inhaltsblock wurde erfolgreich erstellt.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.changeExternalLinks = function (contentId, externalLinks) {
			$loading.start();
			$contentgroup.saveExternalLinks(contentId, externalLinks).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Verlinkung gespeichert!',
						body: 'Die Verlinkung wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.save = function (content) {
			$loading.start();
			$contentgroup.saveContent($stateParams.id, content).then(
				function () {
					load();
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Inhalt gespeichert!',
						body: 'Der Inhalt wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				},
				function () {
					$loading.finish();
				}
			);
		};

		load();

		function load(openLast) {
			$contentgroup.getGroup($stateParams.pgid).then(
				function (pagegroup) {
					vm.pagegroup = pagegroup;
				},
				function () {
					vm.pagegroup = {};
				}
			);

			$contentgroup.getPageInfos($stateParams.id).then(
				function (page) {
					vm.page = page;
					Page.setTitle('Inhalt > ' + page.name);
				},
				function () {
					vm.page = {};
				}
			);

			$contentgroup.getContents($stateParams.id).then(
				function (contents) {

					angular.forEach(contents, function (content) {
						content.content = content.content.replace(/href=\"\" ng-click=\"vm.link\(\'/g, 'href="').replace(/\'\)\"/g, '"');
						if(angular.isDefined(content.external_links) && content.external_links !== false) {

						} else {
							content.external_links = [];
						}
					});

					vm.contents = contents;

					if(openLast) {
						vm.contents[(vm.contents.length - 1)].show = true;
						$location.hash('bottom');
						$anchorScroll();
					}
				},
				function () {
					vm.contents = [];
				}
			);
		}
	}

	function IconDirectiveCtrl() {
		var vm = this;

		vm.popoverOpen = false;

		vm.icons = [
			{'name': 'link', 'class': 'fa fa-link'},
			{'name': 'pdf', 'class': 'fa fa-file-pdf'},
			{'name': 'word', 'class': 'fa fa-file-word'},
			{'name': 'excel', 'class': 'fa fa-file-excel'},
			{'name': 'powerpoint', 'class': 'fa fa-file-powerpoint'},
			{'name': 'at', 'class': 'fa fa-at'},
			{'name': 'file-download', 'class': 'fa fa-file-download'},
			{'name': 'youtube', 'class': 'fab fa-youtube'},
			{'name': 'facebook', 'class': 'fab fa-facebook-square'},
			{'name': 'instagram', 'class': 'fab fa-instagram'},
			{'name': 'xing', 'class': 'fab fa-xing'},
			{'name': 'phone', 'class': 'fa fa-phone'},
			{'name': 'question-circle', 'class': 'fa fa-question-circle'},
			{'name': 'qrcode', 'class': 'fa fa-qrcode'},
			{'name': 'credit-card', 'class': 'fa fa-credit-card'},
			{'name': 'map-signs', 'class': 'fa fa-map-signs'},
			{'name': 'address-card', 'class': 'fa fa-address-card'},
			{'name': 'bullhorn', 'class': 'fa fa-bullhorn'},
			{'name': 'bus', 'class': 'fa fa-bus'},
			{'name': 'calendar', 'class': 'fa fa-calendar'},
			{'name': 'camera', 'class': 'fa fa-camera'},
			{'name': 'car', 'class': 'fa fa-car'},
			{'name': 'chart-pie', 'class': 'fa fa-chart-pie'},
			{'name': 'cloud', 'class': 'fa fa-cloud'},
			{'name': 'cogs', 'class': 'fa fa-cogs'},
			{'name': 'comment', 'class': 'fa fa-comment'},
			{'name': 'grin', 'class': 'fa fa-grin'},
			{'name': 'meh', 'class': 'fa fa-meh'},
			{'name': 'frown', 'class': 'fa fa-frown'},
			{'name': 'headset', 'class': 'fa fa-headset'},
			{'name': 'heart', 'class': 'fa fa-heart'},
			{'name': 'id-card', 'class': 'fa fa-id-card'},
			{'name': 'info', 'class': 'fa fa-info'},
			{'name': 'image', 'class': 'fa fa-image'},
			{'name': 'images', 'class': 'fa fa-images'},
			{'name': 'newspaper', 'class': 'fa fa-newspaper'},
			{'name': 'shopping-cart', 'class': 'fa fa-shopping-cart'},
			{'name': 'sign', 'class': 'fa fa-sign'},
			{'name': 'sync', 'class': 'fa fa-sync'},
			{'name': 'tag', 'class': 'fa fa-tag'},
			{'name': 'tags', 'class': 'fa fa-tags'},
			{'name': 'thumbs-up', 'class': 'fa fa-thumbs-up'},
			{'name': 'thumbs-down', 'class': 'fa fa-thumbs-down'},
			{'name': 'train', 'class': 'fa fa-train'},
			{'name': 'trash', 'class': 'fa fa-trash'},
			{'name': 'user', 'class': 'fa fa-user'},
			{'name': 'video', 'class': 'fa fa-video'},
			{'name': 'store', 'class': 'fa fa-store'},
			{'name': 'archive', 'class': 'fa fa-archive'},
			{'name': 'book', 'class': 'fa fa-book'},
			{'name': 'bookmark', 'class': 'fa fa-bookmark'},
			{'name': 'envelope', 'class': 'fa fa-envelope'},
			{'name': 'folder', 'class': 'fa fa-folder'},
			{'name': 'pen', 'class': 'fa fa-pen'},
			{'name': 'quote-right', 'class': 'fa fa-quote-right'},
			{'name': 'bed', 'class': 'fa fa-bed'},
			{'name': 'smile', 'class': 'fa fa-smile'},
			{'name': 'bell', 'class': 'fa fa-bell'},
			{'name': 'exclamation', 'class': 'fa fa-exclamation'},
			{'name': 'exclamation-circle', 'class': 'fa fa-exclamation-circle'},
			{'name': 'chart-line', 'class': 'fa fa-chart-line'},
			{'name': 'download', 'class': 'fa fa-download'},
			{'name': 'play', 'class': 'fa fa-play'},
			{'name': 'ambulance', 'class': 'fa fa-ambulance'},
			{'name': 'car-battery', 'class': 'fa fa-car-battery'},
			{'name': 'charging-station', 'class': 'fa fa-charging-station'},
			{'name': 'taxi', 'class': 'fa fa-taxi'},
			{'name': 'coffee', 'class': 'fa fa-coffee'},
			{'name': 'wine-glass', 'class': 'fa fa-wine-glass'},
			{'name': 'wine-glass', 'class': 'fa fa-wine-glass'},
			{'name': 'building', 'class': 'fa fa-building'},
			{'name': 'campground', 'class': 'fa fa-campground'},
			{'name': 'clinic-medical', 'class': 'fa fa-clinic-medical'},
			{'name': 'industry', 'class': 'fa fa-industry'},
			{'name': 'university', 'class': 'fa fa-university'},
			{'name': 'warehouse', 'class': 'fa fa-warehouse'},
			{'name': 'school', 'class': 'fa fa-school'},
			{'name': 'gift', 'class': 'fa fa-gift'},
			{'name': 'tshirt', 'class': 'fa fa-tshirt'},
			{'name': 'sitemap', 'class': 'fa fa-sitemap'},
			{'name': 'window-maximize', 'class': 'fa fa-window-maximize'},
			{'name': 'keyboard', 'class': 'fa fa-keyboard'},
			{'name': 'bug', 'class': 'fa fa-bug'},
			{'name': 'tablet', 'class': 'fa fa-tablet'},
			{'name': 'tv', 'class': 'fa fa-tv'},
			{'name': 'mouse', 'class': 'fa fa-mouse'},
			{'name': 'headphones', 'class': 'fa fa-headphones'},
			{'name': 'hammer', 'class': 'fa fa-hammer'},
			{'name': 'money-bill', 'class': 'fa fa-money-bill'},
			{'name': 'clock', 'class': 'fa fa-clock'},
			{'name': 'kiss-wink-heart', 'class': 'fa fa-kiss-wink-heart'},
			{'name': 'grin-stars', 'class': 'fa fa-grin-stars'},
			{'name': 'grin-hearts', 'class': 'fa fa-grin-hearts'},
			{'name': 'grin', 'class': 'fa fa-grin'},
			{'name': 'angry', 'class': 'fa fa-angry'},
			{'name': 'dizzy', 'class': 'fa fa-dizzy'},
			{'name': 'flushed', 'class': 'fa fa-flushed'},
			{'name': 'frown', 'class': 'fa fa-frown'},
			{'name': 'grin-squint', 'class': 'fa fa-grin-squint'},
			{'name': 'laugh', 'class': 'fa fa-laugh'},
			{'name': 'smile-wink', 'class': 'fa fa-smile-wink'},
			{'name': 'surprise', 'class': 'fa fa-surprise'},
			{'name': 'tired', 'class': 'fa fa-tired'},
			{'name': 'cheese', 'class': 'fa fa-cheese'},
			{'name': 'pizza-slice', 'class': 'fa fa-pizza-slice'},
			{'name': 'dice-six', 'class': 'fa fa-dice-six'},
			{'name': 'toilet-paper', 'class': 'fa fa-toilet-paper'},
			{'name': 'snowman', 'class': 'fa fa-snowman'},
			{'name': 'cocktail', 'class': 'fa fa-cocktail'},
			{'name': 'hotel', 'class': 'fa fa-hotel'},
			{'name': 'wifi', 'class': 'fa fa-wifi'},
			{'name': 'key', 'class': 'fa fa-key'},
			{'name': 'swimmer', 'class': 'fa fa-swimmer'},
			{'name': 'suitcase', 'class': 'fa fa-suitcase'},
			{'name': 'shower', 'class': 'fa fa-shower'},
			{'name': 'couch', 'class': 'fa fa-couch'},
			{'name': 'barcode', 'class': 'fa fa-barcode'},
			{'name': 'flag', 'class': 'fa fa-flag'},
			{'name': 'star', 'class': 'fa fa-star'},
			{'name': 'shipping-fast', 'class': 'fa fa-shipping-fast'}
		];

		vm.showIcon = function(icon){
			return _.find(vm.icons, {name: icon}).class;
		};

		vm.pagination = {
			currentPage: 0,
			pageSize: 24,
			numberOfPages: function(){
				return Math.ceil(vm.icons.length / vm.pagination.pageSize);
			}
		};
	}

})(angular);

(function (angular) {
	'use strict';

	angular.module('contentgroup.factory', [])
		.factory('$contentgroup', ContentFactory);

	ContentFactory.$inject = ['$q', '$api', '$log'];

	function ContentFactory($q, $api, $log) {
		return {
			getGroups: getGroups,
			getGroup: getGroup,
			getPages: getPages,
			save: save,
			savePages: savePages,
			savePage: savePage,
			changePage: changePage,
			changeIcon: changeIcon,
			getPageInfos: getPageInfos,
			getContents: getContents,
			saveExternalLinks: saveExternalLinks,
			savePositions: savePositions,
			addContent: addContent,
			saveContent: saveContent,
			saveContents: saveContents,
			removeContent: removeContent,
			addPage: addPage,
			removePage: removePage
		};

		function getGroups(withPages) {
			var q = $q.defer(),
				groupList = {'sort': '+name'};

			if(withPages){
				groupList.with = 'pages';
			}

			$api.withToken().all('pagegroups').customGETLIST('', groupList).then(
				function (pagegroups) {
					q.resolve(pagegroups);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getGroup(pgId) {
			var q = $q.defer(),
				groupList = {};

			$api.withToken().one('pagegroups', pgId).customGET('', groupList).then(
				function (pagegroup) {
					q.resolve(pagegroup.result);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getPages(pageGroupId) {
			var q = $q.defer(),
				pagesList = {};

			if(pageGroupId !== false) {
				pagesList = {'pagegroup_id': pageGroupId, 'sort': '+position'};
			} else {
				pagesList = {'sort': '+id'};
			}

			$api.withToken().all('pages').customGETLIST('', pagesList).then(
				function (pages) {
					q.resolve(pages);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function savePage(pageId, right_key) {
			var q = $q.defer();
			$api.withToken().one('pages', pageId).customPUT({right_key: right_key}).then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function changePage(pageId, newName) {
			var q = $q.defer();
			$api.withToken().one('pages', pageId).customPUT({name: newName}).then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function changeIcon(pageId, newIcon) {
			var q = $q.defer();
			$api.withToken().one('pages', pageId).customPUT({icon: newIcon}).then(
				function () {
					q.resolve();
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}

		function savePages(pages) {
			var q = $q.defer(),
				i = 0,
				l = pages.length;

			function resolve() {
				if(l === i) {
					q.resolve();
				}
			}

			angular.forEach(pages, function (page) {
				i++;

				$api.withToken().one('pages', page.id).customPUT({position: i.toString()}).then(
					function () {
						resolve();
					}
				);

			});

			return q.promise;
		}

		function save(pageGroupId, fallback_text) {
			var q = $q.defer();

			$api.withToken().one('pagegroups', pageGroupId).customPUT({fallback_text: fallback_text}).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getContents(page_id) {
			var q = $q.defer();

			$api.withToken().one('pages', page_id).all('contents').customGETLIST('', {
				'with': 'title_image,external_links',
				'sort': '+position'
			}).then(
				function (pages) {
					q.resolve(pages);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getPageInfos(page_id) {
			var q = $q.defer();

			$api.withToken().one('pages', page_id).customGET('').then(
				function (page) {
					q.resolve(page.result);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function saveExternalLinks(content_id, external_links) {
			var q = $q.defer(),
				i = 0,
				l = external_links.length,
				linkIds = [];

			if(l > 0) {
				angular.forEach(external_links, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if(l === i) {
						$api.withToken().one('contents', content_id).customPUT({external_links: linkIds}).then(
							function () {
								q.resolve();
							},
							function (error) {
								
								//q.reject();
							}
						);
					}

				});
			} else {
				$api.withToken().one('contents', content_id).customPUT({external_links: []}).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						//q.reject();
					}
				);
			}

			return q.promise;
		}

		function savePositions(page_id, contents) {
			var q = $q.defer(),
				i = 0,
				l = contents.length;

			function resolve() {
				if(l === i) {
					q.resolve();
				}
			}

			angular.forEach(contents, function (content) {
				i++;

				var editContent = {
					position: i.toString()
				};

				$api.withToken().one('contents', content.id).customPUT(editContent).then(
					function () {
						resolve();
					},
					function (error) {
						
						//q.reject();
					}
				);

			});

			return q.promise;
		}

		function saveContent(page_id, content) {
			var q = $q.defer(),
				editContent = {
					page_id: page_id,
					title: content.title,
					content: content.content,
					title_image_id: content.title_image_id
				};

			$api.withToken().one('contents', content.id).customPUT(editContent).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function saveContents(page_id, contents) {
			var q = $q.defer(),
				i = 0,
				l = contents.length;

			function resolve() {
				if(l === i) {
					q.resolve();
				}
			}

			angular.forEach(contents, function (content) {
				i++;

				if(content.deleted === '1') {
					
					$api.withToken().one('contents', content.id).remove().then(
						function () {
							resolve();
						}
					);
				} else {
					var editContent = {
						page_id: page_id,
						title: content.title,
						position: i.toString(),
						content: content.content,
						title_image_id: content.title_image_id
					};

					if(content.id !== '0') {
						
						$api.withToken().one('contents', content.id).customPUT(editContent).then(
							function () {
								resolve();
							}
						);
					} else {
						
						$api.withToken().all('contents').post(editContent).then(
							function () {
								resolve();
							}
						);
					}
				}

			});

			return q.promise;
		}

		function addContent(page_id, contentposition) {
			var q = $q.defer();

			var editContent = {
				page_id: page_id,
				title: '',
				position: contentposition.toString(),
				content: '',
				title_image_id: 0,
				language_id: '1',
				form_id: '0'
			};

			$api.withToken().all('contents').post(editContent).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function removeContent(content) {
			var q = $q.defer();

			$api.withToken().one('contents', content.id).remove().then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function addPage(pagename, pgId, position) {
			var q = $q.defer(),
				tmpPage = {
					name: pagename,
					pagegroup_id: pgId,
					right_key: 'everybody',
					position: (position + 1).toString()
				};

			$api.withToken().all('pages').post(tmpPage).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function removePage(page_id) {
			var q = $q.defer();

			$api.withToken().one('pages', page_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

	}

})(angular);

(function (angular) {
	'use strict';

	angular.module('contentgroup.directive', [])
		.directive('contentIconPanel', iconPanel);

	function iconPanel() {
		return {
			restrict: 'EA',
			scope: {
				'icon': '=icon',
				'changeIcon': '&changeIcon'
			},
			//replace: true,
			templateUrl: 'static/templates/contentgroup/directiveicon.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'ContentgroupIconDirectiveController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('news', ['news.factory', 'news.directive', 'news.filter', 'news.controller']);

})(angular);

(function (angular) {
	'use strict';

	angular.module('news.directive', ['news'])
		.directive('emojiPanel', emojiPanel)
		.directive('emojiPicker', emojiPicker)
		.directive('youtubeIframe', youtubeIframe);

	youtubeIframe.$inject = ['$sce'];

	function youtubeIframe($sce) {
		return {
			restrict: 'EA',
			scope: {code: '='},
			replace: true,
			template: '<div><iframe width="{{width}}" height="{{height}}" ng-src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
			link: function ($scope, $element) {
				$scope.$watch('code', function (newVal) {
					if(newVal) {
						$scope.url = $sce.trustAsResourceUrl('https://www.youtube-nocookie.com/embed/' + newVal + '?rel=0');
					}
				});
				var width = $element.parent()[0].offsetWidth;

				$scope.width = '355px';
				$scope.height = '200px';
				$scope.width = width + 'px';
				$scope.height = (width * 0.563380282) + 'px';
			}
		};
	}

	function emojiPanel() {
		return {
			restrict: 'EA',
			scope: {},
			//replace: true,
			templateUrl: 'static/templates/news/emojipicker.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'EmojiPickerDirectiveController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

	emojiPicker.$inject = ['$document', 'toaster', '$timeout'];

	function emojiPicker($document, toaster, $timeout) {
		return {
			restrict: 'EA',
			scope: {},
			//replace: true,
			template: '<span></span>',
			link: function ($scope, $element) {
				function fallbackCopyTextToClipboard(text) {
					var textArea = $document.createElement('textarea');
					textArea.value = text;

					// Avoid scrolling to bottom
					textArea.style.top = '0';
					textArea.style.left = '0';
					textArea.style.position = 'fixed';

					$document.body.appendChild(textArea);
					textArea.focus();
					textArea.select();

					try {
						var successful = $document.execCommand('copy');
						var msg = successful ? 'successful' : 'unsuccessful';
					} catch(err) {
					}

					$document.body.removeChild(textArea);
				}

				function copyTextToClipboard(text) {
					if(!navigator.clipboard) {
						fallbackCopyTextToClipboard(text);
						return;
					}
					navigator.clipboard.writeText(text).then(function () {
					}, function (err) {
					});
				}

				var pickerOptions = {
					locale: 'de',
					theme: 'light',
					noCountryFlags: true,
					onEmojiSelect: function (emoji) {
						copyTextToClipboard(emoji.native);

						$timeout(function() {
							toaster.pop({
								type: 'success',
								title: 'Erfolgreich kopiert!',
								body: 'Das Emoji wurde erfolgreich in die Zwischenablage kopiert.',
								timeout: globalConfig.toastTimeout,
								showCloseButton: true
							});
						});
					}
				};
				var picker = new EmojiMart.Picker(pickerOptions);

				$element.append(picker);
			}
		};
	}
})(angular);

/* global angular, moment */

(function(angular) {
	'use strict';

	angular.module('news.filter', ['news'])
		.filter('dateToISO', dateToISO)
		.filter('startFrom', startFrom);

	function dateToISO() {
		return function(input) {
			return moment(input).toISOString();
		};
	}

	function startFrom(){
		return function (input, start) {
			if (input) {
				start = +start;
				return input.slice(start);
			}
			return [];
		};
	}
})(angular);

/* global angular, moment */

(function (angular) {
	'use strict';

	angular.module('news.factory', [])
		.factory('$news', NewsFactory);

	NewsFactory.$inject = ['$q', '$api', '$log'];

	function NewsFactory($q, $api, $log) {
		return {
			getList: getList,
			getDetail: getDetail,
			add: add,
			edit: edit,
			remove: remove,
			getGroups: getGroups,
			addGroup: addGroup,
			editGroupRole: editGroupRole,
			editGroupName: editGroupName,
			removeGroup: removeGroup
		};

		function getList(page, perpage, archive) {
			var q = $q.defer(),
				newsList = {
					'with': 'title_image,push_notification,notification,external_links',
					'sort': '-publish_at,-published'
				};

			if(perpage) {
				newsList.perpage = perpage;
			} else {
				newsList.perpage = 5;
			}

			if(page) {
				newsList.page = page;
			} else {
				newsList.page = 1;
			}

			if(archive){
				newsList.active = '3';
			} else {
				newsList['active<'] = '1';
			}

			$api.withToken().all('news').customGETLIST('', newsList).then(
				function (tmpNews) {
					q.resolve(tmpNews);
				}
			);

			return q.promise;
		}

		function getDetail(newsId) {
			var q = $q.defer(),
				newsList = {'with': 'title_image,external_links'};

			$api.withToken().one('news', newsId).customGET('', newsList).then(
				function (tmpNews) {
					q.resolve(tmpNews.result);
				}
			);

			return q.promise;
		}

		function add(news, externalLinks, push, media, campaign) {
			var q = $q.defer(),
				tmpNews = {
					title: news.title,
					content: news.content,
					active: news.active,
					right_key: news.right_key,
					newsgroup_id: news.newsgroup_id,
					publish_at: moment(new Date(news.datetime).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					published_until: null,
					external_links: []
				},
				i = 0,
				l = externalLinks.length,
				linkIds = [];

			var save = function () {
				$api.withToken().all('news').post(tmpNews).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);
			};

			if(angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpNews.title_image_id = media.id;
			} else {
				tmpNews.title_image_id = 0;
			}

			if(angular.isDefined(push) && push.enabled === true) {
				tmpNews.push_title = push.title;
				tmpNews.push_message = push.text;
				tmpNews.push_sound = push.sound;
				tmpNews.push_badge = 1;

				if(push.interests.length > 0){
					tmpNews.push_interests = push.interests;
				}
			}

			if(angular.isDefined(campaign) && campaign.enabled === true) {
				tmpNews.campaign = {
					'campaign_from': moment(new Date(campaign.from_date).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					'campaign_until': moment(new Date(campaign.until_date).toISOString()).format('YYYY-MM-DD HH:mm:ss')
				};
			}

			if(news.published_until !== false) {
				tmpNews.published_until = moment(new Date(news.published_until).toISOString()).hour(23).minute(59).seconds(59).format('YYYY-MM-DD HH:mm:ss');
			}

			if(l > 0) {
				angular.forEach(externalLinks, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if(l === i) {
						tmpNews.external_links = linkIds;
						save();
					}
				});
			} else {
				save();
			}

			return q.promise;
		}

		function edit(newsId, news, media) {
			var q = $q.defer(),
				tmpNews = {
					title: news.title,
					content: news.content,
					newsgroup_id: news.newsgroup_id,
					external_links: []
				},
				i = 0,
				l = news.external_links.length,
				linkIds = [];

			if(angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpNews.title_image_id = media.id;
			} else {
				tmpNews.title_image_id = 0;
			}

			var save = function () {
				$api.withToken().one('news', newsId).customPUT(tmpNews).then(
					function () {
						q.resolve();
					}
				);
			};

			if(l > 0) {
				angular.forEach(news.external_links, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if(l === i) {
						tmpNews.external_links = linkIds;
						save();
					}
				});
			} else {
				save();
			}

			return q.promise;
		}

		function remove(news_id) {
			var q = $q.defer();

			$api.withToken().one('news', news_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function getGroups(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api.withToken().all('newsgroups').customGETLIST('', customList).then(
				function (tmpNews) {
					q.resolve(tmpNews);
				}
			);

			return q.promise;
		}

		function addGroup(name) {
			var q = $q.defer();

			$api.withToken().all('newsgroups').post({name: name}).then(
				function (tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}

		function editGroupRole(groupId, rightKey) {
			var q = $q.defer();
			$api.withToken().one('newsgroups', groupId).customPUT({right_key: rightKey}).then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function editGroupName(groupId, newName) {
			var q = $q.defer();
			$api.withToken().one('newsgroups', groupId).customPUT({name: newName}).then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function removeGroup(groupId) {
			var q = $q.defer();

			$api.withToken().one('newsgroups', groupId).remove().then(
				function (tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}
	}

})(angular);

/* global globalConfig, _ */

(function (angular) {
	'use strict';

	angular
		.module('news.controller', [])
		.controller('NewsOverviewController', NewsOverviewCtrl)
		.controller('NewsArchiveController', NewsArchiveCtrl)
		.controller('NewsGroupsController', NewsGroupsCtrl)
		.controller('NewsNewController', NewsNewCtrl)
		.controller('NewsEditController', NewsEditCtrl)
		.controller('EmojiPickerDirectiveController', EmojiPickerDirectiveCtrl);

	NewsOverviewCtrl.$inject = ['Page', '$news', 'toaster', '$window', '$loading', '$user', '$stateParams', '$state', '$timeout'];

	function NewsOverviewCtrl(Page, $news, toaster, $window, $loading, $user, $stateParams, $state, $timeout) {
		var vm = this;
		Page.setTitle('News > Übersicht');
		vm.news = [];
		vm.newsgroups = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				load();
				$state.go('app.news.overview', tmp, { notify: false });
			}, 500);
		};

		vm.remove = function (news) {
			var deleteNews = $window.confirm(news.title + ' löschen?');

			if (deleteNews) {
				$loading.start();
				$news.remove(news.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'News wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'News konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.getGroupName = function (group_id) {
			if (angular.isDefined(group_id) && group_id !== '' && group_id !== null) {
				if (group_id !== '0') {
					var _find = _.find(vm.newsgroups, { id: group_id });

					if (angular.isDefined(_find)) {
						return _find.name;
					}
				} else {
					return 'keine';
				}
			}

			return false;
		};

		load();
		initialLoad();

		function load() {
			$news.getList(vm.currentPage, vm.entryLimit).then(
				function (news) {
					vm.news = news;
					vm.count = news.pagination.total;

					vm.totalItems = news.pagination.total;
					vm.noOfPages = news.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.news = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}

		function initialLoad() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);

			$news.getGroups(1, 999999).then(function (newsgroups) {
				vm.newsgroups = newsgroups;
			});
		}
	}

	NewsArchiveCtrl.$inject = ['Page', '$news', 'toaster', '$window', '$loading', '$user', '$stateParams', '$state', '$timeout'];

	function NewsArchiveCtrl(Page, $news, toaster, $window, $loading, $user, $stateParams, $state, $timeout) {
		var vm = this;
		Page.setTitle('News > Archiv');
		vm.news = [];
		vm.newsgroups = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				load();
				$state.go('app.news.archive', tmp, { notify: false });
			}, 500);
		};

		vm.getGroupName = function (group_id) {
			if (angular.isDefined(group_id) && group_id !== '' && group_id !== null) {
				if (group_id !== '0') {
					var _find = _.find(vm.newsgroups, { id: group_id });

					if (angular.isDefined(_find)) {
						return _find.name;
					}
				} else {
					return 'keine';
				}
			}

			return false;
		};

		load();
		initialLoad();

		function load() {
			$news.getList(vm.currentPage, vm.entryLimit, true).then(
				function (news) {
					vm.news = news;
					vm.count = news.pagination.total;

					vm.totalItems = news.pagination.total;
					vm.noOfPages = news.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.news = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}

		function initialLoad() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);

			$news.getGroups(1, 999999).then(function (newsgroups) {
				vm.newsgroups = newsgroups;
			});
		}
	}

	NewsNewCtrl.$inject = ['Page', '$news', 'toaster', '$state', '$user', '$loading', '$mandant', '$upload'];

	function NewsNewCtrl(Page, $news, toaster, $state, $user, $loading, $mandant, $upload) {
		var vm = this;
		Page.setTitle('News > Neu');
		vm.newsgroups = [];
		vm.push_interests = [];
		vm.loading = false;
		vm.showDateUntil = false;
		vm.news = {
			title: '',
			content: '',
			datetime: new Date(),
			published_until: '',
			title_image_id: '',
			published: '',
			right_key: 'everybody',
			newsgroup_id: '0',
		};
		vm.roles = [];
		vm.push = {
			enabled: 0,
			text: '',
			title: '',
			interests: [],
			sound: 'ping.aiff',
		};
		vm.campaign = {
			enabled: 0,
			from_date: '',
			until_date: '',
		};
		vm.selectedMedia = {};

		vm.loadingCSV = false;
		vm.csvFile = {
			uploaded: false,
			result: {},
			file: {},
		};

		vm.labels = {
			itemsSelected: 'gewählte Interessensgebiete',
			selectAll: 'Alle aktivieren',
			unselectAll: 'Alle deaktivieren',
			search: 'Suchen',
			select: 'Interessensgebiet(e) wählen',
		};

		vm.uploadCSV = function () {
			if (angular.isDefined(vm.csvFile.file.name) && vm.csvFile.file.name !== '') {
				$loading.start();
				vm.loadingCSV = true;
				$upload
					.upload(
						{
							data: { csv: vm.csvFile.file },
						},
						'news-csvimport'
					)
					.then(
						function (uploadResult) {
							if (vm.csvFile.result.rows_success < 1) {
								vm.loadingCSV = false;
								vm.csvFile.uploaded = false;
								vm.csvFile.result = {};

								toaster.pop({
									type: 'success',
									title: 'Erfolgreich hochgeladen!',
									body: 'CSV wurde erfolgreich hochgeladen.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true,
								});
							} else {
								vm.csvFile.result = uploadResult.data.result;
								vm.loadingCSV = false;
								vm.csvFile.uploaded = true;

								toaster.pop({
									type: 'success',
									title: 'Erfolgreich hochgeladen!',
									body: 'CSV wurde erfolgreich hochgeladen.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true,
								});
							}

							$loading.finish();
						},
						function () {
							vm.loadingCSV = false;
							vm.csvFile.uploaded = false;
							vm.csvFile.result = {};
							$loading.finish();
						}
					);
			}
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};

		vm.external_links = [];
		vm.addExternalLinks = function () {};

		// Datepicker
		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		// Datepicker
		vm.dateCampaignFromPopup = false;
		vm.dateCampaignUntilPopup = false;
		vm.timeCampaignFromPopup = false;
		vm.timeCampaignUntilPopup = false;
		vm.dateCampaignOptions = {
			minDate: new Date(),
			maxDate: '',
			readonlyInput: false,
			showMeridian: false,
		};

		vm.changeDate = function () {
			vm.dateUntilOptions.minDate = vm.news.datetime;

			vm.dateCampaignOptions.minDate = vm.news.datetime;
			vm.dateCampaignOptions.maxDate = vm.news.published_until;
		};

		// DatepickerUntil
		vm.dateUntilPopup = false;
		vm.dateUntilOptions = {
			minDate: new Date(),
		};

		// Datepicker Time
		vm.timePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};
		vm.removeMedia = function () {
			vm.selectedMedia = {};
		};
		vm.reloadMedia = function () {
			load();
		};

		vm.save = function () {
			vm.loading = true;
			if (angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				if (!confirm('News ohne Bild/Video veröffentlichen?')) {
					vm.loading = false;
					return false;
				}
			}

			if (vm.showDateUntil !== true) {
				vm.news.published_until = false;
			}

			if (vm.news.right_key === 'CSVIMPORT') {
				if (vm.csvFile.uploaded === true && vm.csvFile.result.rows_success > 0) {
					vm.news.right_key = vm.csvFile.result.selectionId;
				} else {
					return false;
				}
			}

			if (vm.push.enabled === true && vm.moduleActive(21)) {
				if (vm.push.interests.length > 0) {
					var i = 0,
						l = vm.push.interests.length,
						interests = [];
					angular.forEach(vm.push.interests, function (interest) {
						i++;

						interests.push(parseInt(interest.id));

						if (l === i) {
							vm.push.interests = interests;
							next();
						}
					});
				} else {
					toaster.pop({
						type: 'error',
						title: 'News nicht gespeichert!',
						body: 'Die News konnte nicht gespeichert werden! Die Push-Nachricht benötigt Interessen.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			} else {
				next();
			}

			function next() {
				$loading.start();
				$news.add(vm.news, vm.external_links, vm.push, vm.selectedMedia, vm.campaign).then(
					function () {
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'News gespeichert!',
							body: 'Die News wurde erfolgreich gespeichert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
						vm.loading = false;
						$state.go('app.news.overview');
					},
					function () {
						$loading.finish();
						vm.loading = false;
						toaster.pop({
							type: 'error',
							title: 'News nicht gespeichert!',
							body: 'Die News konnte nicht gespeichert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();

		function load() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
			$news.getGroups(1, 999999).then(function (newsgroups) {
				vm.newsgroups = newsgroups;
			});
			$user.getInterests().then(
				function (interests) {
					vm.push_interests = interests;
				},
				function () {
					vm.push_interests = [];
				}
			);
		}
	}

	NewsEditCtrl.$inject = ['Page', '$news', 'toaster', '$state', '$user', '$loading', '$stateParams', '$window'];

	function NewsEditCtrl(Page, $news, toaster, $state, $user, $loading, $stateParams, $window) {
		var vm = this;
		Page.setTitle('News > Bearbeiten');
		vm.newsgroups = [];
		vm.loading = false;
		vm.showMediaBrowser = false;
		vm.news = {
			title: '',
			content: '',
			title_image_id: '',
			right_key: 'everybody',
			newsgroup_id: '0',
		};
		vm.roles = [];
		vm.selectedMedia = {};

		vm.addExternalLinks = function () {};

		vm.selectMedia = function (media) {
			var type = '1';
			vm.selectedMedia = media;

			if (angular.isUndefined(media.id)) {
				vm.showMediaBrowser = false;
				vm.news.title_image_id = 0;
				vm.news.title_image = {};
			} else {
				vm.news.title_image_id = media.id;

				if (media.type === '3') {
					type = '3';
					vm.news.title_image = {
						mandant_id: media.mandant_id,
						content: media.file,
						file: media.file,
						type: type,
					};
				} else {
					vm.news.title_image = {
						mandant_id: media.mandant_id,
						file: media.file,
						type: type,
					};
				}

				vm.showMediaBrowser = false;
			}
		};

		vm.removeMedia = function () {
			vm.selectedMedia = {};
			vm.news.title_image_id = '0';
		};

		vm.reloadMedia = function () {
			load();
		};

		vm.save = function () {
			vm.loading = true;
			if (angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				if (!confirm('News ohne Bild/Video speichern?')) {
					vm.loading = false;
					return false;
				}
			}

			$loading.start();
			$news.edit($stateParams.id, vm.news, vm.selectedMedia).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'News gespeichert!',
						body: 'Die News wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
					$window.history.back();
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'News nicht gespeichert!',
						body: 'Die News konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		load();

		function load() {
			$news.getDetail($stateParams.id).then(function (news) {
				vm.news = news;

				if (news.title_image_id !== '0') {
					vm.media = news.title_image;
					vm.selectedMedia = news.title_image;
				}
			});

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
			$news.getGroups(1, 999999).then(function (newsgroups) {
				vm.newsgroups = newsgroups;
			});
		}
	}

	NewsGroupsCtrl.$inject = ['Page', '$news', 'toaster', '$window', '$loading', '$user', '$stateParams', '$state', '$timeout'];

	function NewsGroupsCtrl(Page, $news, toaster, $window, $loading, $user, $stateParams, $state, $timeout) {
		var vm = this;
		Page.setTitle('News > Gruppen');
		vm.newsgroups = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				load();
				$state.go('app.news.groups', tmp, { notify: false });
			}, 500);
		};

		vm.add = function () {
			var groupname = $window.prompt('Name der neuen Gruppe:', '');
			if (groupname !== null) {
				$loading.start();
				$news.addGroup(groupname).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Gruppe wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Gruppe konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.changeRole = function (group, new_role) {
			$loading.start();
			$news.editGroupRole(group.id, new_role).then(
				function () {
					load(vm.currentPage);
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.changeName = function (group) {
			var groupname = $window.prompt('Geben Sie den neuen Gruppen-Namen an:', group.name);
			if (groupname !== null) {
				$loading.start();
				$news.editGroupName(group.id, groupname).then(
					function () {
						load(vm.currentPage);
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Name wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Name konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.remove = function (group) {
			var deleteGroup = $window.confirm('Gruppe: ' + group.name + ' löschen?');

			if (deleteGroup) {
				$loading.start();
				$news.removeGroup(group.id).then(
					function () {
						$loading.finish();
						load(vm.currentPage);
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Gruppe wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Gruppe konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();
		loadRoles();

		function load() {
			$news.getGroups(vm.currentPage, vm.entryLimit).then(
				function (newsgroups) {
					vm.newsgroups = newsgroups;
					vm.count = newsgroups.pagination.total;

					vm.totalItems = newsgroups.pagination.total;
					vm.noOfPages = newsgroups.pagination.pages;
					$loading.finish();
				},
				function () {
					vm.newsgroups = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	EmojiPickerDirectiveCtrl.$inject = [];

	function EmojiPickerDirectiveCtrl() {
		var vm = this;
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('mandant', ['mandant.factory']);

})(angular);

/* global angular, _ */

(function(angular) {
	'use strict';

	angular.module('mandant.factory', [])
		.factory('$mandant', MandantFactory);

	MandantFactory.$inject = ['$q', '$user', '$api'];
	function MandantFactory($q, $user, $api) {
		var module = {};
		return {
			getMandantModule: getMandantModule,
			getMandantCredits: getMandantCredits,
			checkMandantModule: checkMandantModule
		};

		function getMandantModule() {
			var q = $q.defer(),
				user = $user.get();

			$api.withToken().one('mandants', user.active_mandant).all('modules').getList().then(
				function(tmpModules) {
					module = tmpModules.plain();
					q.resolve(tmpModules.plain());
				}
			);

			return q.promise;
		}

		function getMandantCredits() {
			var q = $q.defer(),
				user = [];

			$user.isReady(function() {
				user = $user.get();
				$api.withToken().one('mandants', user.active_mandant).all('creditaccounts').getList().then(
					function(tmpCreditAccounts) {
						q.resolve(tmpCreditAccounts.plain());
					}
				);
			});

			return q.promise;
		}

		function checkMandantModule(module_id) {
			if(module.length > 0) {
				return (angular.isDefined(_.find(module, {'module_id': module_id.toString()})));
			}
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('dashboard', ['dashboard.factory', 'dashboard.controller']);

})(angular);

(function (angular) {
	'use strict';

	angular.module('dashboard.controller', []).controller('DashboardController', DashboardCtrl);

	DashboardCtrl.$inject = ['Page', '$user', '$scope', '$mandant', '$dashboard'];

	function DashboardCtrl(Page, $user, $scope, $mandant, $dashboard) {
		var vm = this;
		Page.setTitle('Dashboard');
		vm.active_users = 0;
		vm.notactive_users = 0;

		vm.incidents = [];

		$scope.$on('mandantChanged', function () {
			load();
		});

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		load();

		function load() {
			$dashboard.getIncidents().then(function (incidents) {
				vm.incidents = incidents;
			});

			$user.getList(1, 1, {}, ['id'], 1).then(function (users) {
				vm.active_users = users.pagination.total;
			});

			$user.getList(1, 1, {}, ['id'], 0).then(function (users) {
				vm.notactive_users = users.pagination.total;
			});
		}
	}
})(angular);

/* global */

(function (angular) {
	'use strict';

	angular.module('dashboard.factory', [])
		.factory('$dashboard', DashboardFactory);

	DashboardFactory.$inject = ['$q', 'Restangular'];

	function DashboardFactory($q, Restangular) {
		return {
			getIncidents: getIncidents
		};

		function getIncidents() {
			var q = $q.defer();

			Restangular.allUrl('incidents', 'https://api.checklyhq.com/v1/dashboards/1958/incidents').getList().then(
				function (tmpIncidents) {
					var incidents = [];

					angular.forEach(tmpIncidents, function(tmpIncident){
						if(tmpIncident.stoppedAt == null) {
							incidents.push(tmpIncident);
						}
					});

					q.resolve(incidents);
				}
			);

			return q.promise;
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('admin', ['admin.factory', 'admin.controller']);

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('admin.controller', [])
		.controller('AdminUserListController', AdminUserListCtrl)
		.controller('AdminUserAddController', AdminUserAddCtrl)
		.controller('AdminGroupsOverviewController', AdminGroupsOverviewCtrl)
		.controller('AdminGroupsDetailController', AdminGroupsDetailCtrl)
		.controller('AdminMandantImageController', AdminMandantImageCtrl);

	AdminUserListCtrl.$inject = ['Page', '$user', '$window', 'toaster'];
	function AdminUserListCtrl(Page, $user, $window, toaster) {
		var vm = this;
		Page.setTitle('Admin > User');
		vm.users = [];
		vm.config = {
			itemsPerPage: 10,
			paginatorLabels: {
				stepBack: '‹',
				stepAhead: '›',
				jumpBack: '«',
				jumpAhead: '»',
				first: 'Erste',
				last: 'Letzte'
			}
		};

		vm.removeUser = function(user) {
			var currentUser = $user.get();
			var deleteUser = $window.confirm('Benutzer: ' + user.email + ' löschen?');

			if(deleteUser) {
				if(currentUser.id !== user.id) {
					$user.deleteUser(user.id).then(
						function() {
							toaster.pop({
								type: 'success',
								title: 'Benutzer gelöscht',
								body: 'Der Benutzer wurde erfolgreich gelöscht.',
								timeout: globalConfig.toastTimeout,
								showCloseButton: true
							});
							load();
						},
						function() {
							toaster.pop({
								type: 'error',
								title: 'Fehler!',
								body: 'Benutzer konnte nicht gelöscht werden! Unbekannter Fehler',
								timeout: globalConfig.toastTimeout,
								showCloseButton: true
							});
						}
					);
				} else {
					toaster.pop({
						type: 'error',
						title: 'Fehler!',
						body: 'Der eigene Benutzer kann nicht gelöscht werden.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				}
			}
		};

		load();

		function load() {
			$user.getUsers().then(
				function(users) {
					vm.users = users;
				}
			);
		}
	}

	AdminUserAddCtrl.$inject = ['Page', '$user', '$state', 'toaster'];
	function AdminUserAddCtrl(Page, $user, $state, toaster) {
		var vm = this;
		Page.setTitle('Admin > User > Add');
		vm.user = {
			email: '',
			username: '',
			password: '',
			password_confirm: '',
			level: '0',
			active: '0'
		};

		vm.randPw = '';

		vm.randomPassword = function() {
			var pw = $user.generateRandomPassword(16);
			vm.user.password = pw;
			vm.user.password_confirm = pw;
			vm.randPw = pw;
		};

		vm.add = function() {
			if(vm.user.password === vm.user.password_confirm) {
				$user.addUser(vm.user).then(
					function() {
						toaster.pop({
							type: 'success',
							title: 'Benutzer hinzugefügt',
							body: 'Der Benutzer wurde erfolgreich angelegt.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						$state.go('app.admin.user');
					},
					function() {
						toaster.pop({
							type: 'error',
							title: 'Fehler!',
							body: 'Benutzer konnte nicht erstellt werden! Unbekannter Fehler',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			} else {
				toaster.pop({
					type: 'error',
					title: 'Fehler!',
					body: 'Die eingegebenen Passwörter stimmen nicht überein!',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true
				});
			}
		};
	}

	AdminGroupsOverviewCtrl.$inject = ['Page', 'toaster', '$usergroups', '$window'];
	function AdminGroupsOverviewCtrl(Page, toaster, $usergroups, $window) {
		var vm = this;
		Page.setTitle('Anwender-Gruppen');
		vm.usergroups = [];

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		vm.add = function(){
			var groupname = $window.prompt('Name der neuen Anwender-Gruppe:', '');
			if (groupname !== null) {
				$usergroups.addGroup(groupname).then(
					function() {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Anwender-Gruppe wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						load();
					},
					function() {
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Anwender-Gruppe konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		load(1);

		function load(page){
			$usergroups.getList(page, vm.entryLimit).then(
				function(usergroups){
					vm.usergroups = usergroups;
					vm.count = usergroups.pagination.total;

					vm.totalItems = usergroups.pagination.total;
					vm.noOfPages = usergroups.pagination.pages;
				},
				function(){
					vm.usergroups = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
				}
			);
		}
	}

	AdminGroupsDetailCtrl.$inject = ['Page', 'toaster', '$usergroups', '$stateParams'];
	function AdminGroupsDetailCtrl(Page, toaster, $usergroups, $stateParams) {
		var vm = this;
		Page.setTitle('Anwender-Gruppen');
		vm.usergroup = {};

		load();

		function load(){
			$usergroups.getGroup($stateParams.id).then(
				function(usergroup){
					vm.usergroup = usergroup;
				},
				function(){
					vm.usergroups = {};
				}
			);
		}
	}

	AdminMandantImageCtrl.$inject = ['Page', 'toaster', '$upload'];
	function AdminMandantImageCtrl(Page, toaster, $upload) {
		var vm = this;
		Page.setTitle('Admin');
		vm.fileinfos = {
			customerid: ''
		};

		vm.submitImage = function() {
			$upload.uploadMandantImage(vm.fileinfos.customerid, {
				data: {image: vm.fileinfos.file}
			}).then(
				function() {
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich hochgeladen!',
						body: 'Datei wurde erfolgreich hochgeladen.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				}
			);
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('admin.factory', [])
		.factory('$usergroups', UserGroupsFactory)
		.factory('$admin', AdminFactory)
		.factory('$testApi', TestApiFactory);

	UserGroupsFactory.$inject = ['$q', '$user', '$api', '$log'];
	function UserGroupsFactory($q, $user, $api, $log){
		var api_endpoint = 'usergroups';
		return {
			getList: getList,
			addGroup: addGroup,
			getGroup: getGroup
		};

		function getList(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api.withToken().all(api_endpoint).customGETLIST('', customList).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}

		function addGroup(groupname) {
			var q = $q.defer();

			$api.withToken().all(api_endpoint).post({'name': groupname}).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}

		function getGroup(groupId) {
			var q = $q.defer();

			$api.withToken().one(api_endpoint, groupId).get().then(
				function(tmpResult) {
					q.resolve(tmpResult.result);
				}
			);

			return q.promise;
		}
	}

	AdminFactory.$inject = ['$q', '$user', '$api'];
	function AdminFactory($q, $user, $api){
		return {

		};

	}

	TestApiFactory.$inject = ['Restangular'];
	function TestApiFactory(Restangular){
		var $api = Restangular.withConfig(function(RestangularConfigurer) {
			RestangularConfigurer.setDefaultHeaders({
				'API-Token': user.token,
				'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
				'Authorization': 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU=',
				'Accept': 'application/json, text/javascript',
				'Content-Type': 'application/json; charset=utf-8'
			});
		});

		function apiWithToken(token){
			return Restangular.withConfig(function(RestangularConfigurer) {
				RestangularConfigurer.setDefaultHeaders({
					'API-Token': token,
					'API-KEY': 'QhVXBgaALkFhzW7LxqqU4UU3Y8G43YYU',
					'Authorization': 'Basic Y29kZXI6OHQ3czQzclkzWGdrZ1ZVUmRtZXU=',
					'Accept': 'application/json, text/javascript',
					'Content-Type': 'application/json; charset=utf-8'
				});
			});
		}
	}

})(angular);

(function (angular) {
	'use strict';

	angular.module('shop', ['shop.factory', 'shop.directive', 'shop.controller', 'shop.filter']);
})(angular);

/* global globalConfig */

(function (angular) {
	'use strict';

	angular
		.module('shop.controller', [])
		.controller('ShopOverviewController', OverviewCtrl)
		.controller('ShopDashboardController', DashboardCtrl)
		.controller('ShopNewController', NewCtrl)
		.controller('ShopEditController', EditCtrl)
		.controller('ShopCartController', CartCtrl)
		.controller('ShopCartDetailController', CartDetailCtrl)
		.controller('TransactionsController', TransactionsCtrl);

	OverviewCtrl.$inject = ['Page', '$shop', '$window', 'toaster', '$loading', '$stateParams', '$state', '$user'];

	function OverviewCtrl(Page, $shop, $window, toaster, $loading, $stateParams, $state, $user) {
		var vm = this;
		Page.setTitle('Shop');
		vm.products = [];
		vm.count = 0;
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;
		vm.fallback_text = '';

		vm.changePage = function () {
			$loading.start();
			load();
			$state.go('app.shop.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
		};

		vm.save = function () {
			$shop.saveFallback(vm.fallback_text).then(function () {
				loadFallback();
			});
		};

		vm.remove = function (product) {
			var deleteProduct = $window.confirm(product.name + ' löschen?');

			if (deleteProduct) {
				$loading.start();
				$shop.remove(product.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Produkt wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Produkt konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();
		initialLoad();

		function load() {
			$shop.get(vm.currentPage, vm.entryLimit).then(
				function (products) {
					vm.products = products;
					vm.count = products.pagination.total;

					vm.totalItems = products.pagination.total;
					vm.noOfPages = products.pagination.pages;
					$loading.finish();
					$window.scrollTo(0, 0);
				},
				function () {
					vm.products = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
					$window.scrollTo(0, 0);
				}
			);
		}

		function initialLoad() {
			loadFallback();

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {
					vm.roles = [];
				}
			);
		}

		function loadFallback() {
			$shop.loadFallback().then(function (fallbackText) {
				vm.fallback_text = fallbackText;
			});
		}
	}

	DashboardCtrl.$inject = ['$shop'];

	function DashboardCtrl($shop) {
		var vm = this;
		vm.neworders = 0;

		load();

		function load() {
			$shop.getOpenOrders().then(function (shop) {
				vm.neworders = shop.pagination.total;
			});
		}
	}

	NewCtrl.$inject = ['Page', '$shop', '$media', 'toaster', '$state', '$user', '$loading'];

	function NewCtrl(Page, $shop, $media, toaster, $state, $user, $loading) {
		var vm = this;
		Page.setTitle('Shop > Neu');
		vm.loading = false;
		vm.product = {
			name: '',
			description: '',
			gross: 0,
			vat: '19',
			net: '0',
			right_key: 'everybody',
			editable_price: '0',
		};
		vm.roles = [];

		//Media
		vm.selectedMedia = {};
		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};

		vm.calcNet = function () {
			var vat = parseInt(vm.product.vat) * 0.01 + 1,
				gross = vm.product.gross;

			vm.product.net = parseFloat(gross / vat);
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();
			$shop.add(vm.product, vm.selectedMedia).then(
				function () {
					$loading.finish();
					$state.go('app.shop.overview');
					toaster.pop({
						type: 'success',
						title: 'Produkt gespeichert!',
						body: 'Das Produkt wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Produkt nicht gespeichert!',
						body: 'Das Produkt konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	EditCtrl.$inject = ['Page', '$shop', '$media', 'toaster', '$state', '$stateParams', '$user', '$loading', '$window'];

	function EditCtrl(Page, $shop, $media, toaster, $state, $stateParams, $user, $loading, $window) {
		var vm = this;
		Page.setTitle('Shop > Bearbeiten');
		vm.media = {};
		vm.loading = false;
		vm.showMediaBrowser = false;
		vm.product = {
			name: '',
			description: '',
		};
		vm.roles = [];

		//Media
		vm.selectedMedia = {};
		vm.selectMedia = function (media) {
			var type = '1';
			vm.selectedMedia = media;

			if (angular.isUndefined(media.id)) {
				vm.showMediaBrowser = false;
				vm.product.image_id = 0;
				vm.product.image = {};
			} else {
				vm.product.image_id = media.id;

				if (media.type === '3') {
					type = '3';
					vm.product.image = {
						mandant_id: media.mandant_id,
						content: media.file,
						file: media.file,
						type: type,
					};
				} else {
					vm.product.image = {
						mandant_id: media.mandant_id,
						file: media.file,
						type: type,
					};
				}

				vm.showMediaBrowser = false;
			}
		};

		vm.removeMedia = function () {
			vm.selectedMedia = {};
			vm.product.image_id = '0';
		};

		vm.calcNet = function () {
			var vat = parseInt(vm.product.vat) * 0.01 + 1,
				gross = vm.product.gross;

			vm.product.net = parseFloat(gross / vat);
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();
			var editProduct = { name: vm.product.name, description: vm.product.description, right_key: vm.product.right_key };

			$shop.edit(vm.product.id, editProduct, vm.selectedMedia).then(
				function () {
					$loading.finish();
					$window.history.back();
					toaster.pop({
						type: 'success',
						title: 'Produkt gespeichert!',
						body: 'Das Produkt wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Produkt nicht gespeichert!',
						body: 'Das Produkt konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load() {
			$shop.getSingle($stateParams.id).then(function (product) {
				vm.product = product;

				if (product.image_id !== '0') {
					vm.media = product.image;
					vm.selectedMedia = product.image;
				}
			});

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	CartCtrl.$inject = ['Page', '$shop'];

	function CartCtrl(Page, $shop) {
		var vm = this;
		Page.setTitle('Shop');
		vm.carts = [];
		vm.count = 0;

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		vm.changePage = function () {
			load(vm.currentPage);
		};

		load(1);

		function load(page) {
			$shop.getCarts(page, vm.entryLimit).then(
				function (carts) {
					vm.carts = carts;
					vm.count = carts.pagination.total;

					vm.totalItems = carts.pagination.total;
					vm.noOfPages = carts.pagination.pages;
				},
				function () {
					vm.carts = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
				}
			);
		}
	}

	CartDetailCtrl.$inject = ['Page', '$shop', '$stateParams', 'toaster', '$loading'];

	function CartDetailCtrl(Page, $shop, $stateParams, toaster, $loading) {
		var vm = this;
		Page.setTitle('Shop > Bestellungen');
		vm.cart = {};
		vm.cartitems = [];
		vm.cartState = '';
		vm.toggleState = false;

		vm.changeState = function () {
			$loading.start();
			vm.toggleState = false;
			$shop.changeCartState(vm.cart.id, vm.cart.state).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Status gespeichert!',
						body: 'Der Status wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Status nicht gespeichert!',
						body: 'Der Status konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load() {
			$shop.getCartDetail($stateParams.id).then(
				function (cart) {
					vm.cart = cart;

					$shop.getCartDetailItems(cart.id).then(
						function (cartitems) {
							vm.cartitems = cartitems;
						},
						function () {
							vm.cartitems = [];
						}
					);
				},
				function () {
					vm.carts = {};
				}
			);
		}
	}

	TransactionsCtrl.$inject = ['Page', '$shop'];

	function TransactionsCtrl(Page, $shop) {
		var vm = this;
		vm.show = 'manual';
		vm.transactions = {
			paypal: [],
			manual: [],
		};

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		Page.setTitle('Shop > Transaktionen');

		vm.changeType = function (type) {
			vm.show = type;
			load(type);
		};

		vm.retryVerify = function (transaction) {
			$shop.retryVerify(transaction.id).then(
				function () {
					load(vm.show);
				},
				function () {}
			);
		};

		vm.changePage = function () {
			load(vm.show);
		};

		load();

		function load(type) {
			type = type || 'manual';
			vm.show = type;

			$shop.getTransactions(type, vm.currentPage, vm.entryLimit).then(
				function (tmpTransactions) {
					vm.transactions[type] = tmpTransactions;

					vm.count = tmpTransactions.pagination.total;

					vm.totalItems = tmpTransactions.pagination.total;
					vm.noOfPages = tmpTransactions.pagination.pages;
				},
				function () {
					vm.transactions[type] = [];
				}
			);
		}
	}
})(angular);

/* global angular */

(function (angular) {
	'use strict';

	angular.module('shop.directive', [])
		.directive('shopDashboard', shopDashboard);

	shopDashboard.$inject = [];

	function shopDashboard() {
		return {
			restrict: 'EA',
			scope: {},
			templateUrl: 'static/templates/shop/dashboard.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'ShopDashboardController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('shop.factory', [])
		.factory('$shop', ShopFactory);

	ShopFactory.$inject = ['$q', '$api', '$log'];
	function ShopFactory($q, $api, $log) {
		return {
			get: get,
			getSingle: getSingle,
			add: add,
			edit: edit,
			remove: remove,
			getTransactions: getTransactions,
			getCarts: getCarts,
			getCartDetail: getCartDetail,
			getCartDetailItems: getCartDetailItems,
			changeCartState: changeCartState,
			retryVerify: retryVerify,
			getOpenOrders: getOpenOrders,
			loadFallback: loadFallback,
			saveFallback: saveFallback
		};

		function get(page, perpage){
			var q = $q.defer(),
				customList = {'with': 'image'};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api.withToken().all('articles').customGETLIST('', customList).then(
				function(tmpProducts){
					q.resolve(tmpProducts);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getCarts(page, perpage){
			var q = $q.defer(),
				customList = {'state!': 'new', 'sort': 'state'};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api.withToken().all('carts').customGETLIST('', customList).then(
				function(tmpCarts){
					q.resolve(tmpCarts);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getOpenOrders(){
			var q = $q.defer(),
				customList = {'fields': 'id', 'state': 'open', 'perpage': 1};

			$api.withToken().all('carts').customGETLIST('', customList).then(
				function(tmpChats) {
					q.resolve(tmpChats);
				}
			);

			return q.promise;
		}

		function getCartDetail(cartId){
			var q = $q.defer();

			$api.withToken().one('carts', cartId).customGET('', {'with': 'user'}).then(
				function(tmpCart){
					q.resolve(tmpCart.result);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getCartDetailItems(cartId){
			var q = $q.defer();

			$api.withToken().one('cartitems', cartId).customGETLIST('', {'with': 'article'}).then(
				function(tmpCart){
					q.resolve(tmpCart);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function changeCartState(cartId, state){
			var q = $q.defer();

			$api.withToken().one('carts', cartId).customPUT({state: state}).then(
				function(tmpCart){
					q.resolve(tmpCart);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getSingle(productId){
			var q = $q.defer();

			$api.withToken().one('articles', productId).customGET('', {'with': 'image'}).then(
				function(tmpProducts){
					q.resolve(tmpProducts.result);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function add(product, media) {
			var q = $q.defer(),
				tmpProduct = {
					name: product.name,
					description: product.description,
					gross: product.gross,
					right_key: product.right_key,
					editable_price: product.editable_price
				};

			if(angular.isDefined(media) && angular.isDefined(media.id)){
				tmpProduct.image_id = media.id;
			}else{
				tmpProduct.image_id = 0;
			}

			$api.withToken().all('articles').post(tmpProduct).then(
				function(){
					q.resolve();
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function edit(productId, product, media) {
			var q = $q.defer(),
				tmpProduct = {
					name: product.name,
					description: product.description,
					right_key: product.right_key,
					editable_price: product.editable_price
				};

			if(angular.isDefined(media) && angular.isDefined(media.id)){
				tmpProduct.image_id = media.id;
			}else{
				tmpProduct.image_id = 0;
			}

			$api.withToken().one('articles', productId).customPUT(tmpProduct).then(
				function(){
					q.resolve();
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function loadFallback() {
			var q = $q.defer();

			$api.withToken().all('configurations').all('fallbackTextShop').customGET('').then(
				function(tmpResult){
					q.resolve(tmpResult.result.value);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function saveFallback(fallbackText) {
			var q = $q.defer();

			$api.withToken().all('configurations').all('fallbackTextShop').customPUT({value: fallbackText}).then(
				function(){
					q.resolve();
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function remove(product_id){
			var q = $q.defer();

			$api.withToken().one('articles', product_id).remove().then(
				function(){
					q.resolve();
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function getTransactions(type, page, perpage){
			var q = $q.defer(),
				getWith = 'customer',
				transactionsList = {
				};

			transactionsList.sort = '-created_at';

			if(type === 'manual'){
				transactionsList.with = getWith + ',user,credit_account';
			}

			if(type === 'paypal'){
				transactionsList.with = getWith + ',product';
			}

			if(perpage) {
				transactionsList.perpage = perpage;
			} else {
				transactionsList.perpage = 20;
			}

			if(page) {
				transactionsList.page = page;
			} else {
				transactionsList.page = 1;
			}

			$api.withToken().all('transactions').all(type).customGETLIST('', transactionsList).then(
				function(tmpTransactions){
					q.resolve(tmpTransactions);
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}

		function retryVerify(transaction_id){
			var q = $q.defer();

			$api.withToken().all('transactions').one('paypal', transaction_id).all('verify').customPUT().then(
				function(){
					q.resolve();
				},
				function(error){
					
					q.reject();
				}
			);

			return q.promise;
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('shop.filter', [])
		.filter('asEur', asEur);

	function asEur() {
		return function(input, n, x, s, c) {
			var inp = parseFloat(input);
			var re = '\\d(?=(\\d{' + (x || 3) + '})+' + (n > 0 ? '\\D' : '$') + ')',
				num = inp.toFixed(Math.max(0, ~~n));
			return (c ? num.replace('.', c) : num).replace(new RegExp(re, 'g'), '$&' + (s || ',')) + ' €';
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('vouchers', ['vouchers.factory', 'vouchers.controller']);

})(angular);

/* global globalConfig, moment */

(function (angular) {
	'use strict';

	angular.module('vouchers.controller', []).controller('VouchersOverviewController', OverviewCtrl).controller('VouchersOverviewArchiveController', OverviewArchiveCtrl).controller('VouchersAddController', AddCtrl).controller('VouchersEditController', EditCtrl);

	OverviewCtrl.$inject = ['Page', '$vouchers', '$stateParams', '$window', '$loading', '$user', '$timeout', '$state', 'toaster'];
	function OverviewCtrl(Page, $vouchers, $stateParams, $window, $loading, $user, $timeout, $state, toaster) {
		var vm = this;
		Page.setTitle('Gutscheine');
		vm.vouchers = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		load();

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				loadVouchers();
				$state.go('app.vouchers.overview', tmp, { notify: false });
			}, 500);
		};

		vm.remove = function (voucher) {
			if (!confirm('Den Gutschein wirklich löschen?')) {
				return false;
			}

			$vouchers.deleteVoucher(voucher).then(function () {
				toaster.pop({
					type: 'success',
					title: 'Gutschein gelöscht!',
					body: 'Der Gutschein wurde erfolgreich zur Löschung vorgesehen.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		function load() {
			loadVouchers();

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}

		function loadVouchers() {
			$vouchers.getList(vm.currentPage, vm.entryLimit).then(
				function (vouchers) {
					vm.vouchers = vouchers;

					vm.count = vouchers.pagination.total;

					vm.totalItems = vouchers.pagination.total;
					vm.noOfPages = vouchers.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.vouchers = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}
	}

	OverviewArchiveCtrl.$inject = ['Page', '$vouchers', '$stateParams', '$window', '$loading', '$user', '$timeout', '$state'];
	function OverviewArchiveCtrl(Page, $vouchers, $stateParams, $window, $loading, $user, $timeout, $state) {
		var vm = this;
		Page.setTitle('Gutscheine > Abgelaufen');
		vm.vouchers = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		load();

		vm.changePage = function () {
			$loading.start();

			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				loadVouchers();
				$state.go('app.vouchers.archive', tmp, { notify: false });
			}, 500);
		};

		function load() {
			loadVouchers();

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}

		function loadVouchers() {
			$vouchers.getList(vm.currentPage, vm.entryLimit, true).then(
				function (vouchers) {
					vm.vouchers = vouchers;

					vm.count = vouchers.pagination.total;

					vm.totalItems = vouchers.pagination.total;
					vm.noOfPages = vouchers.pagination.pages;
					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.vouchers = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}
	}

	AddCtrl.$inject = ['Page', '$vouchers', 'toaster', '$state', '$user'];
	function AddCtrl(Page, $vouchers, toaster, $state, $user) {
		var vm = this,
			defaultVoucher = {
				title: '',
				content: '',
				barcode: '',
				valid_from: new Date(),
				valid_until: '',
				right_key: 'everybody',
				expiry_after_days: 0,
				button_visible: true,
				import_balance: 0,
				barcode_visible: 0,
			};

		Page.setTitle('Gutscheine > Hinzufügen');
		vm.loading = false;

		vm.step = 1;
		vm.voucherType = 0; // 0 = normal, 1 = import

		vm.show = {
			expiry_after_days: false,
			barcode: false,
		};

		vm.roles = [];

		vm.voucher = {
			title: '',
			content: '',
			barcode: '',
			valid_from: new Date(),
			valid_until: '',
			right_key: 'everybody',
			expiry_after_days: 0,
			button_visible: true,
		};

		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		vm.timePopup = {
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.datePopupUntil = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		vm.timePopupUntil = {
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.push = {
			enabled: 0,
			text: '',
			title: '',
			sound: 'ping.aiff',
		};

		vm.selectedMedia = {};
		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};

		vm.selectType = function (type) {
			vm.voucher = angular.copy(defaultVoucher);
			vm.voucherType = type;
			vm.step = 2;
		};

		vm.save = function () {
			vm.loading = true;

			if (!vm.show.barcode) {
				vm.voucher.barcode = '';
			}

			if (!vm.show.expiry_after_days) {
				vm.voucher.expiry_after_days = 0;
			}

			if (angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				toaster.pop({
					type: 'error',
					title: 'Gutschein kann nicht gespeichert werden!',
					body: 'Ein Gutschein muss ein Bild haben. Bitte wählen Sie ein Bild aus.',
					timeout: globalConfig.toastTimeout + 2000,
					showCloseButton: true,
				});

				vm.loading = false;
				return false;
			}

			if (angular.isUndefined(vm.push.enabled) || !vm.push.enabled) {
				if (!confirm('Gutschein wirklich ohne Push-Nachricht speichern?')) {
					vm.loading = false;
					return false;
				}
			}

			vm.voucher.voucher_type = vm.voucherType;

			if (vm.show.barcode === true) {
				vm.voucher.barcode_visible = 1;
			}

			$vouchers.add(vm.voucher, vm.push, vm.selectedMedia).then(
				function () {
					toaster.pop({
						type: 'success',
						title: 'Gutschein gespeichert!',
						body: 'Der Gutschein wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
					$state.go('app.vouchers.overview');
				},
				function () {
					toaster.pop({
						type: 'error',
						title: 'Gutschein nicht gespeichert!',
						body: 'Der Gutschein konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	EditCtrl.$inject = ['Page', '$vouchers', 'toaster', '$state', '$user', '$stateParams', '$loading'];
	function EditCtrl(Page, $vouchers, toaster, $state, $user, $stateParams, $loading) {
		var vm = this;
		Page.setTitle('Gutscheine > Bearbeiten');
		vm.loading = false;
		vm.showMediaBrowser = false;

		vm.show = {
			expiry_after_days: false,
			barcode: false,
		};

		vm.roles = [];

		vm.voucher = {
			id: '',
			title: '',
			content: '',
			barcode: '',
			valid_from: new Date(),
			valid_until: '',
			right_key: 'everybody',
			expiry_after_days: 0,
			button_visible: true,
			title_image_id: '',
		};

		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		vm.timePopup = {
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.datePopupUntil = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		vm.timePopupUntil = {
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.push = {
			enabled: 0,
			text: '',
			title: '',
			sound: 'ping.aiff',
		};

		vm.selectedMedia = {};
		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};

		vm.removeMedia = function () {
			vm.selectedMedia = {};
			vm.voucher.title_image_id = '0';
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();

			if (!vm.show.barcode) {
				vm.voucher.barcode = '';
			}

			if (!vm.show.expiry_after_days) {
				vm.voucher.expiry_after_days = 0;
			}

			if (angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				toaster.pop({
					type: 'error',
					title: 'Gutschein kann nicht gespeichert werden!',
					body: 'Ein Gutschein muss ein Bild haben. Bitte wählen Sie ein Bild aus.',
					timeout: globalConfig.toastTimeout + 2000,
					showCloseButton: true,
				});

				$loading.finish();
				vm.loading = false;
				return false;
			}

			$vouchers.edit(vm.voucher, vm.selectedMedia).then(
				function () {
					toaster.pop({
						type: 'success',
						title: 'Gutschein gespeichert!',
						body: 'Der Gutschein wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					$loading.finish();
					vm.loading = false;
					$state.go('app.vouchers.overview');
				},
				function () {
					toaster.pop({
						type: 'error',
						title: 'Gutschein nicht gespeichert!',
						body: 'Der Gutschein konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					$loading.finish();
					vm.loading = false;
				}
			);
		};

		load();

		function load() {
			$loading.start();
			$vouchers.getSingle($stateParams.id).then(function (voucher) {
				vm.voucher.id = voucher.id;
				vm.voucher.mandant_id = voucher.mandant_id;
				vm.voucher.title = voucher.title;
				vm.voucher.content = voucher.content;
				vm.voucher.right_key = voucher.right_key;
				vm.voucher.valid_from = moment(voucher.valid_from).toDate();
				vm.voucher.valid_until = moment(voucher.valid_till).toDate();

				vm.show.barcode = voucher.code_visible == '1' ? true : false;
				vm.voucher.barcode = voucher.coupon_code;

				vm.show.expiry_after_days = voucher.expiry_after_days != null ? true : false;
				vm.voucher.expiry_after_days = parseInt(voucher.expiry_after_days);

				vm.voucher.button_visible = voucher.button_visible == '1' ? true : false;

				if (voucher.title_image_id != '0') {
					vm.media = voucher.title_image;
					vm.selectedMedia = voucher.title_image;
					vm.voucher.title_image = voucher.title_image;
				}
				$loading.finish();
			});

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}
})(angular);

/* global moment */

(function (angular) {
	'use strict';
	var api_endpoint = 'coupons';

	angular.module('vouchers.factory', []).factory('$vouchers', VouchersFactory);

	VouchersFactory.$inject = ['$q', '$log', '$api'];
	function VouchersFactory($q, $log, $api) {
		return {
			getList: getList,
			getSingle: getSingle,
			add: add,
			edit: edit,
			getUser: getUser,
			deleteVoucher: deleteVoucher,
		};

		function getList(page, perpage, archive) {
			var q = $q.defer(),
				customList = { sort: '-id', with: 'title_image' };

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if (archive) {
				customList.deleted_at = true;
			}

			$api
				.withToken()
				.all(api_endpoint)
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getSingle(id) {
			var q = $q.defer(),
				voucherList = { with: 'title_image' };

			$api
				.withToken()
				.one(api_endpoint, id)
				.customGET('', voucherList)
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function add(voucher, push, media) {
			var q = $q.defer(),
				tmpVoucher = {
					title: voucher.title,
					content: voucher.content,
					barcode_visible: voucher.barcode,
					barcode: voucher.barcode,
					expiry_after_days: voucher.expiry_after_days,
					button_visible: voucher.button_visible,
					right_key: voucher.right_key,
					voucher_type: voucher.voucher_type,
					import_balance: voucher.import_balance,
				};

			if (angular.isDefined(voucher.valid_from) && voucher.valid_from !== '') {
				tmpVoucher.valid_from = moment(new Date(voucher.valid_from).toISOString()).format('YYYY-MM-DD HH:mm:ss');
			} else {
				q.reject();
			}

			if (angular.isDefined(voucher.valid_until) && voucher.valid_until !== '') {
				tmpVoucher.valid_until = moment(new Date(voucher.valid_until).toISOString()).format('YYYY-MM-DD HH:mm:ss');
			} else {
				q.reject();
			}

			if (angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpVoucher.title_image_id = media.id;
			} else {
				q.reject();
			}

			if (angular.isDefined(push) && push.enabled === true) {
				tmpVoucher.push_title = push.title;
				tmpVoucher.push_message = push.text;
				tmpVoucher.push_sound = push.sound;
				tmpVoucher.push_badge = 1;
			}

			$api
				.withToken()
				.all('coupons')
				.post(tmpVoucher)
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function edit(voucher, media) {
			var q = $q.defer(),
				tmpVoucher = {
					title: voucher.title,
					content: voucher.content,
					barcode: voucher.barcode,
					expiry_after_days: voucher.expiry_after_days,
					button_visible: voucher.button_visible,
					right_key: voucher.right_key,
				};

			if (angular.isDefined(voucher.valid_from) && voucher.valid_from !== '') {
				tmpVoucher.valid_from = moment(new Date(voucher.valid_from).toISOString()).format('YYYY-MM-DD HH:mm:ss');
			} else {
				q.reject();
			}

			if (angular.isDefined(voucher.valid_until) && voucher.valid_until !== '') {
				tmpVoucher.valid_until = moment(new Date(voucher.valid_until).toISOString()).format('YYYY-MM-DD HH:mm:ss');
			} else {
				q.reject();
			}

			if (angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpVoucher.title_image_id = media.id;
			} else {
				q.reject();
			}

			$api
				.withToken()
				.one('coupons', voucher.id)
				.customPUT(tmpVoucher)
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function deleteVoucher(voucher) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, voucher.id)
				.remove()
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function getUser(userId) {
			var q = $q.defer(),
				customList = {};

			$api
				.withToken()
				.all(api_endpoint)
				.all('backend')
				.one('user', userId)
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('chat', ['chat.factory', 'chat.directive', 'chat.controller']);

})(angular);

/* global angular */

(function (angular) {
	'use strict';

	angular.module('chat.controller', [])
		.controller('ChatOverviewController', ChatOverviewCtrl)
		.controller('ChatDashboardController', ChatDashboardCtrl)
		.controller('ChatNewController', ChatNewCtrl)
		.controller('ChatDetailController', ChatDetailCtrl);

	ChatOverviewCtrl.$inject = ['Page', '$messages', 'toaster', '$window'];

	function ChatOverviewCtrl(Page, $messages, toaster, $window) {
		var vm = this;
		Page.setTitle('Chat > Übersicht');
		vm.chats = [];
		vm.count = 0;

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '5';
		vm.noOfPages = 1;

		vm.changePage = function () {
			load(vm.currentPage);
		};

		load(1);

		function load(page) {
			$messages.getList(page, vm.entryLimit).then(
				function (chats) {
					vm.chats = chats;
					vm.count = chats.pagination.total;

					vm.totalItems = chats.pagination.total;
					vm.noOfPages = chats.pagination.pages;
				}
			);
		}
	}

	ChatNewCtrl.$inject = ['$messages', '$state', '$stateParams'];

	function ChatNewCtrl($messages, $state, $stateParams) {
		var vm = this;
		load();

		function load() {
			$messages.mandantchat($stateParams.userId).then(
				function (chat_id) {
					$state.go('app.chat.detail', {id: chat_id});
				}
			);
		}
	}

	ChatDashboardCtrl.$inject = ['$messages'];

	function ChatDashboardCtrl($messages) {
		var vm = this;
		vm.chatcount = 0;
		load();

		function load() {
			$messages.getUnreadChats().then(
				function(chats) {
					vm.chatcount = chats.pagination.total;
				}
			);
		}
	}

	ChatDetailCtrl.$inject = ['Page', '$messages', '$stateParams', '$log', '$timeout', '$interval', '$rootScope', '$state', '$window', '$user'];

	function ChatDetailCtrl(Page, $messages, $stateParams, $log, $timeout, $interval, $rootScope, $state, $window, $user) {
		var vm = this,
			objDiv = null;

		vm.user = {};

		vm.interval = null;
		Page.setTitle('Chat > Detail');
		vm.messages = [];

		vm.chat = {
			message: ''
		};

		vm.sendChat = function () {
			var tmpMessage = angular.copy(vm.chat.message);
			vm.chat.message = '';
			$messages.postMessage($stateParams.id, tmpMessage).then(
				function () {
					loadMessages();
					$timeout(
						function () {
							vm.chat.message = '';
						}, 0);
				},
				function () {
					vm.chat.message = tmpMessage;
				}
			);
		};

		vm.closeChat = function () {
			var closeChat = $window.confirm('Chat wirklich abschließen?');
			if(closeChat) {
				$messages.deleteChat($stateParams.id).then(
					function () {
						$state.go('app.chat.overview');
					}
				);
			}
		};

		$rootScope.$on('$stateChangeStart',
			function (event, toState, toParams, fromState, fromParams) {
				$interval.cancel(vm.interval);
				vm.interval = null;
			});

		load();

		function scrollBottom() {
			$timeout(function () {
				objDiv.scrollTop = objDiv.scrollHeight;
			}, 0);
		}

		function loadMessages() {
			$messages.getMessages($stateParams.id).then(
				function (messages) {
					var tmpOldMessages = vm.messages.length;
					if(tmpOldMessages !== messages.length) {
						scrollBottom();
						vm.messages = messages;
					}
				}
			);
		}

		function load() {
			objDiv = document.getElementById('chatmessages');
			loadMessages();
			$user.isReady(function () {
				vm.user = $user.get();
				console.log(vm.user);
			});

			vm.interval = $interval(function () {
				
				loadMessages();
			}, 5000);
		}
	}

})(angular);

/* global angular */

(function (angular) {
	'use strict';

	angular.module('chat.directive', [])
		.directive('chatDashboard', chatDashboard);

	chatDashboard.$inject = [];

	function chatDashboard() {
		return {
			restrict: 'EA',
			scope: {},
			templateUrl: 'static/templates/chat/dashboard.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
			controller: 'ChatDashboardController',
			controllerAs: 'vm',
			bindToController: true
		};
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('chat.factory', [])
		.factory('$messages', MessagesFactory);

	MessagesFactory.$inject = ['$q', '$api', '$log'];
	function MessagesFactory($q, $api, $log) {
		return {
			getList: getList,
			getMessages: getMessages,
			mandantchat: mandantchat,
			postMessage: postMessage,
			deleteChat: deleteChat,
			getUnreadChats: getUnreadChats
		};

		function getList(page, perpage) {
			var q = $q.defer();

			var messagesList = {'sort': '-unread_messages,-updated_at,-created_at'};
			

			if(perpage) {
				messagesList.perpage = perpage;
			} else {
				messagesList.perpage = 5;
			}

			if(page) {
				messagesList.page = page;
			} else {
				messagesList.page = 1;
			}

			$api.withToken().all('messages').customGETLIST('', messagesList).then(
				function(tmpChats) {
					q.resolve(tmpChats);
				}
			);

			return q.promise;
		}

		function getUnreadChats() {
			var q = $q.defer(),
				messagesList = {'fields': 'id', 'unread_messages>': '1', 'perpage': 1};

			$api.withToken().all('messages').customGETLIST('', messagesList).then(
				function(tmpChats) {
					q.resolve(tmpChats);
				}
			);

			return q.promise;
		}

		function getMessages(chat_id) {
			var q = $q.defer();

			$api.withToken().one('messages', chat_id).getList().then(
				function(tmpMessages) {
					q.resolve(tmpMessages);
				}
			);

			return q.promise;
		}

		function mandantchat(user_id) {
			var q = $q.defer();

			$api.withToken().all('messages').one('mandantchat', user_id).customGET().then(
				function(tmpChat) {
					
					q.resolve(tmpChat.result.id);
				}
			);

			return q.promise;
		}

		function postMessage(chat_id, content){
			var q = $q.defer(),
				message = {content: content};

			$api.withToken().one('messages', chat_id).customPOST(message).then(
				function(result) {
					
					q.resolve();
				},
				function(error) {
					
					q.reject();
				});

			return q.promise;
		}

		function deleteChat(chat_id){
			var q = $q.defer();

			$api.withToken().one('messages', chat_id).remove().then(
				function(){
					q.resolve();
				}
			);

			return q.promise;
		}

	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('events', ['events.factory', 'events.controller']);

})(angular);

/* global moment, globalConfig, _ */

(function (angular) {
	'use strict';

	angular.module('events.controller', [])
		.controller('EventsOverviewController', EventsOverviewCtrl)
		.controller('EventsGroupsController', EventsGroupsCtrl)
		.controller('EventsArchiveController', EventsArchiveCtrl)
		.controller('EventsNewController', EventsNewCtrl)
		.controller('EventsEditController', EventsEditCtrl);

	EventsOverviewCtrl.$inject = ['Page', '$events', 'toaster', '$window', '$loading', '$stateParams', '$state', '$user', '$timeout'];
	function EventsOverviewCtrl(Page, $events, toaster, $window, $loading, $stateParams, $state, $user, $timeout) {
		var vm = this;
		Page.setTitle('Veranstaltungen > Übersicht');
		vm.events = [];
		vm.count = 0;

		vm.groups = [];
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function() {
			$loading.start();

			$timeout(function(){
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit
				};

				load();
				$state.go('app.events.overview', tmp, {notify: false});
			}, 500);
		};

		vm.getGroupName = function (group_id) {
			if(angular.isDefined(group_id) && group_id !== '' && group_id !== null) {
				if(group_id !== '0') {
					var _find = _.find(vm.groups, {'id': group_id});

					if(angular.isDefined(_find)) {
						return _find.description;
					}
				} else {
					return 'keine';
				}
			}

			return 'gelöscht';
		};

		vm.remove = function (event) {
			var deleteEvent = $window.confirm(event.title + ' löschen?');

			if(deleteEvent) {
				$loading.start();
				$events.remove(event.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Veranstaltung wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Veranstaltung konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		load();
		initialLoad();

		function initialLoad(){
			$events.getEventGroups(1, 99999).then(
				function (groups) {
					vm.groups = groups;
				},
				function(){
					vm.groups = [];
				}
			);

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {
					vm.roles = [];
				}
			);
		}

		function load() {
			$events.getList(vm.currentPage, vm.entryLimit).then(
				function (events) {
					vm.events = events;
					vm.count = events.pagination.total;

					vm.totalItems = events.pagination.total;
					vm.noOfPages = events.pagination.pages;
					$loading.finish();
					$window.scrollTo(0, 0);
				},
				function () {
					vm.events = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
					$window.scrollTo(0, 0);
				}
			);
		}
	}

	EventsGroupsCtrl.$inject = ['Page', '$events', 'toaster', '$window', '$loading', '$user', '$state', '$timeout', '$stateParams'];
	function EventsGroupsCtrl(Page, $events, toaster, $window, $loading, $user, $state, $timeout, $stateParams) {
		var vm = this;
		Page.setTitle('Veranstaltungen > Gruppen');
		vm.eventgroups = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function() {
			$loading.start();

			$timeout(function(){
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit
				};

				load();
				$state.go('app.events.groups', tmp, {notify: false});
			}, 500);
		};

		vm.add = function () {
			var groupname = $window.prompt('Name der neuen Gruppe:', '');
			if(groupname !== null) {
				$loading.start();
				$events.addEventGroup(groupname).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Gruppe wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Gruppe konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.changeRole = function (group, new_role) {
			$loading.start();
			$events.editGroupRole(group.id, new_role).then(
				function () {
					load();
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.changeName = function (group) {
			var groupname = $window.prompt('Geben Sie den neuen Gruppen-Namen an:', group.description);
			if(groupname !== null) {
				$loading.start();
				$events.editGroupName(group.id, groupname).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Name wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Name konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.remove = function (group) {
			var deleteGroup = $window.confirm(group.description + ' löschen?');

			if(deleteGroup) {
				$loading.start();
				$events.removeGroup(group.id).then(
					function () {
						$loading.finish();
						load();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Gruppe wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Gruppe konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		load();
		loadRoles();

		function load() {
			$events.getEventGroups(vm.currentPage, vm.entryLimit).then(
				function (eventgroups) {
					vm.eventgroups = eventgroups;
					vm.count = eventgroups.pagination.total;

					vm.totalItems = eventgroups.pagination.total;
					vm.noOfPages = eventgroups.pagination.pages;
					$loading.finish();
				},
				function () {
					vm.eventgroups = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				}
			);
		}
	}

	EventsArchiveCtrl.$inject = ['Page', '$events', 'toaster', '$window', '$user', '$stateParams', '$state', '$timeout', '$loading'];
	function EventsArchiveCtrl(Page, $events, toaster, $window, $user, $stateParams, $state, $timeout, $loading) {
		var vm = this;
		Page.setTitle('Veranstaltungen > Archive');
		vm.events = [];
		vm.count = 0;

		vm.groups = [];
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function() {
			$loading.start();

			$timeout(function(){
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit
				};

				load();
				$state.go('app.events.archive', tmp, {notify: false});
			}, 500);
		};

		vm.getGroupName = function (group_id) {
			if(angular.isDefined(group_id) && group_id !== '' && group_id !== null) {
				if(group_id !== '0') {
					var _find = _.find(vm.groups, {'id': group_id});

					if(angular.isDefined(_find)) {
						return _find.description;
					}
				} else {
					return 'keine';
				}
			}

			return 'gelöscht';
		};

		load();
		initialLoad();

		function initialLoad(){
			$events.getEventGroups(1, 99999).then(
				function (groups) {
					vm.groups = groups;
				},
				function(){
					vm.groups = [];
				}
			);

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {
					vm.roles = [];
				}
			);
		}

		function load() {
			$events.getArchiveList(vm.currentPage, vm.entryLimit).then(
				function (events) {
					vm.events = events;
					vm.count = events.pagination.total;

					vm.totalItems = events.pagination.total;
					vm.noOfPages = events.pagination.pages;
					$loading.finish();
				},
				function(){
					vm.events = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}
	}

	EventsNewCtrl.$inject = ['Page', '$events', 'toaster', '$state', '$user', '$loading', '$scope'];
	function EventsNewCtrl(Page, $events, toaster, $state, $user, $loading, $scope) {
		var vm = this;
		Page.setTitle('Veranstaltungen > Neu');
		vm.groups = [];
		vm.loading = false;
		vm.event = {
			title: '',
			preview: '',
			content: '',
			event_start: new Date(),
			event_end: '',
			title_image_id: '',
			location_name: '',
			street: '',
			zip: '',
			town: '',
			external_name: '',
			external_url: '',
			right_key: 'everybody'
		};
		vm.roles = [];
		vm.push = {
			enabled: 0,
			text: '',
			title: '',
			sound: 'ping.aiff'
		};
		vm.selectedMedia = {};
		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};

		vm.fullday = false;
		vm.setFullDay = function () {
			if(vm.fullday === true) {
				vm.event.event_start = moment(vm.event.event_start).hour(0).minute(0).second(0).toDate();

				if(vm.event.event_end === '') {
					vm.event.event_end = moment(vm.event.event_start).hour(23).minute(59).second(59).toDate();
				} else {
					vm.event.event_end = moment(vm.event.event_end).hour(23).minute(59).second(59).toDate();
				}
			}
		};

		// Datepicker
		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date()
		};

		$scope.$watch(function () {
			return vm.event.event_start;
		},function(value){
			vm.enddateOptions.minDate = value;
		});

		// Datepicker Time
		vm.timePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false
			}
		};

		// Datepicker
		vm.enddatePopup = false;
		vm.enddateOptions = {
			date: new Date(),
			minDate: new Date()
		};

		// Datepicker Time
		vm.endtimePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false
			}
		};

		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};
		vm.removeMedia = function () {
			vm.selectedMedia = {};
		};
		vm.reloadMedia = function () {
			load();
		};

		vm.save = function () {
			vm.loading = true;
			if(angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				if(!confirm('Veranstaltung ohne Bild/Video veröffentlichen?')) {
					vm.loading = false;
					return false;
				}
			}
			$loading.start();

			$events.add(vm.event, vm.push, vm.selectedMedia).then(
				function () {
					$state.go('app.events.overview');
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Veranstaltung gespeichert!',
						body: 'Die Veranstaltung wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'Veranstaltung nicht gespeichert!',
						body: 'Die Veranstaltung konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				}
			);
		};

		load();

		function load() {
			$events.getEventGroups(1, 99999).then(
				function (groups) {
					vm.groups = groups;
				}
			);

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {

				}
			);
		}
	}

	EventsEditCtrl.$inject = ['Page', '$events', 'toaster', '$state', '$stateParams', '$user', '$loading', '$window'];
	function EventsEditCtrl(Page, $events, toaster, $state, $stateParams, $user, $loading, $window) {
		var vm = this;
		Page.setTitle('Veranstaltungen > Bearbeiten');
		vm.loading = false;
		vm.event = {
			title: '',
			preview: '',
			content: '',
			event_start: '',
			event_end: '',
			title_image_id: '',
			location_name: '',
			street: '',
			zip: '',
			town: '',
			external_name: '',
			external_url: '',
			right_key: 'everybody'
		};
		vm.roles = [];
		vm.push = {
			enabled: 0,
			text: '',
			title: '',
			sound: 'ping.aiff'
		};
		vm.groups = [];

		vm.fullday = false;
		vm.setFullDay = function () {
			if(vm.fullday === true) {
				vm.event.event_start = moment(vm.event.event_start).hour(0).minute(0).second(0).toDate();

				if(vm.event.event_end === '') {
					vm.event.event_end = moment(vm.event.event_start).hour(23).minute(59).second(59).toDate();
				} else {
					vm.event.event_end = moment(vm.event.event_end).hour(23).minute(59).second(59).toDate();
				}
			}
		};

		// Datepicker
		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date()
		};

		// Datepicker Time
		vm.timePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false
			}
		};

		// Datepicker
		vm.enddatePopup = false;
		vm.enddateOptions = {
			minDate: vm.event_start
		};

		// Datepicker Time
		vm.endtimePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false
			}
		};

		vm.selectedMedia = {};
		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};

		vm.media = {};

		vm.save = function () {
			vm.loading = true;
			if(angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				if(!confirm('Veranstaltung ohne Bild/Video veröffentlichen?')) {
					return false;
				}
			}

			$loading.start();
			$events.edit($stateParams.id, vm.event, vm.selectedMedia).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Veranstaltung gespeichert!',
						body: 'Die Veranstaltung wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
					$window.history.back();
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Veranstaltung nicht gespeichert!',
						body: 'Die Veranstaltung konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load() {
			$events.getSingle($stateParams.id).then(
				function (event) {
					vm.event = event;
					vm.event.event_start = moment(event.event_start).toDate();
					vm.event.event_end = moment(event.event_end).toDate();
					if(event.title_image_id !== '0') {
						vm.media = event.title_image;
					}

					if(moment(event.event_start).hour() === 0 && moment(event.event_start).minute() === 0 && moment(event.event_end).hour() === 23 && moment(event.event_end).minute() === 59) {
						vm.fullday = true;
					}
				}
			);

			$events.getEventGroups(1, 99999).then(
				function (groups) {
					vm.groups = groups;
				}
			);

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {

				}
			);
		}
	}

})(angular);

/* global moment */

(function (angular) {
	'use strict';
	var api_endpoint = 'events';

	angular.module('events.factory', []).factory('$events', EventsFactory);

	EventsFactory.$inject = ['$q', '$api', '$log'];

	function EventsFactory($q, $api, $log) {
		return {
			getList: getList,
			getArchiveList: getArchiveList,
			getEventGroups: getEventGroups,
			addEventGroup: addEventGroup,
			editGroupRole: editGroupRole,
			editGroupName: editGroupName,
			removeGroup: removeGroup,
			add: add,
			edit: edit,
			remove: remove,
			getSingle: getSingle,
		};

		function getList(page, perpage) {
			var q = $q.defer(),
				customList = { 'active>': '=0', with: 'title_image', 'event_end>': 'CURRENT_TIMESTAMP' };

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all(api_endpoint)
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getEventGroups(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all('eventgroups')
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function addEventGroup(name) {
			var q = $q.defer();

			$api
				.withToken()
				.all('eventgroups')
				.post({ description: name })
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function editGroupRole(groupId, rightKey) {
			var q = $q.defer();
			$api
				.withToken()
				.one('eventgroups', groupId)
				.customPUT({ right_key: rightKey })
				.then(function () {
					q.resolve();
				});

			return q.promise;
		}

		function editGroupName(groupId, newName) {
			var q = $q.defer();
			$api
				.withToken()
				.one('eventgroups', groupId)
				.customPUT({ description: newName })
				.then(function () {
					q.resolve();
				});

			return q.promise;
		}

		function removeGroup(groupId) {
			var q = $q.defer();

			$api
				.withToken()
				.one('eventgroups', groupId)
				.remove()
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getArchiveList(page, perpage) {
			var q = $q.defer(),
				customList = { 'active>': '=0', with: 'title_image', 'event_end<': 'CURRENT_TIMESTAMP' };

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all(api_endpoint)
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function add(event, push, media) {
			var q = $q.defer(),
				tmpEvent = {
					title: event.title,
					content: event.content,
					active: 1,
					event_start: moment(new Date(event.event_start).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					location_name: event.location_name,
					preview: event.preview,
					street: event.street,
					town: event.town,
					zip: event.zip,
					external_name: event.external_name,
					external_url: event.external_url,
					eventgroup_id: event.eventgroup_id,
					right_key: event.right_key,
				};

			if (angular.isDefined(event.event_end) && event.event_end !== '' && new Date(event.event_end).toISOString().length > 0) {
				tmpEvent.event_end = moment(new Date(event.event_end).toISOString()).format('YYYY-MM-DD HH:mm:ss');
			}

			if (angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpEvent.title_image_id = media.id;
			} else {
				tmpEvent.title_image_id = 0;
			}

			if (angular.isDefined(push) && push.enabled === true) {
				tmpEvent.push_title = push.title;
				tmpEvent.push_message = push.text;
				tmpEvent.push_sound = push.sound;
				tmpEvent.push_badge = 1;
			}

			$api
				.withToken()
				.all(api_endpoint)
				.post(tmpEvent)
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function edit(event_id, event, media) {
			var q = $q.defer(),
				tmpEvent = {
					title: event.title,
					content: event.content,
					active: 1,
					event_start: moment(new Date(event.event_start).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					location_name: event.location_name,
					preview: event.preview,
					street: event.street,
					town: event.town,
					zip: event.zip,
					external_name: event.external_name,
					external_url: event.external_url,
					eventgroup_id: event.eventgroup_id,
					right_key: event.right_key,
				};

			if (angular.isDefined(event.event_end) && event.event_end !== '' && new Date(event.event_end).toISOString().length > 0) {
				tmpEvent.event_end = moment(new Date(event.event_end).toISOString()).format('YYYY-MM-DD HH:mm:ss');
			}

			if (angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpEvent.title_image_id = media.id;
			} else {
				tmpEvent.title_image_id = 0;
			}

			$api
				.withToken()
				.one(api_endpoint, event_id)
				.customPUT(tmpEvent)
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function remove(id) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, id)
				.remove()
				.then(
					function () {
						q.resolve();
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function getSingle(id) {
			var q = $q.defer(),
				custom = { with: 'title_image' };

			$api
				.withToken()
				.one(api_endpoint, id)
				.customGET('', custom)
				.then(
					function (event) {
						q.resolve(event.result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}
	}
})(angular);

(function(angular) {
	'use strict';

	angular.module('stores', ['stores.factory', 'stores.controller']);

})(angular);

/* global globalConfig, moment */

(function(angular) {
	'use strict';

	angular.module('stores.controller', [])
		.controller('StoresOverviewController', StoresOverviewCtrl)
		.controller('StoresNewController', StoresNewCtrl)
		.controller('StoresEditController', StoresEditCtrl)
		.controller('StoresCategoriesController', CategoriesCtrl);

	StoresOverviewCtrl.$inject = ['Page','$stores', 'toaster', '$window', '$loading', '$stateParams', '$state', '$timeout'];
	function StoresOverviewCtrl(Page, $stores, toaster, $window, $loading, $stateParams, $state, $timeout){
		var vm = this;
		Page.setTitle('Filialen > Übersicht');
		vm.stores = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.storeCategories = [];
		vm.category_id = '';

		vm.changeCategory = function () {
			vm.currentPage = 1;
			vm.activeLetter = false;

			vm.changePage();
		};

		vm.changePage = function() {
			$loading.start();

			$timeout(function(){
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit
				};

				if(vm.category_id !== '') {
					tmp.category = vm.category_id;
				} else {
					tmp.category = '';
				}

				load();
				$state.go('app.stores.overview', tmp, {notify: false});
			}, 500);
		};

		vm.changeExternalLinks = function (storeId, externalLinks) {
			$loading.start();
			$stores.saveExternalLinks(storeId, externalLinks).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Verlinkung gespeichert!',
						body: 'Die Verlinkung wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.remove = function(event){
			var deleteStore = $window.confirm(event.name + ' löschen?');

			if(deleteStore) {
				$loading.start();
				$stores.remove(event.id).then(
					function() {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Filialen wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function() {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Veranstaltung konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		init();
		load();

		function init() {
			if($stateParams.category !== ''){
				vm.category_id = $stateParams.category;
			}

			$stores.getStoreCategories(1, 999999999999).then(
				function (storeCategories) {
					vm.storeCategories = storeCategories;
				},
				function(){
					vm.storeCategories = [];
				}
			);
		}

		function load(){
			$stores.getList(vm.currentPage, vm.entryLimit, vm.category_id).then(
				function(stores){
					vm.stores = stores;
					vm.count = stores.pagination.total;

					vm.totalItems = stores.pagination.total;
					vm.noOfPages = stores.pagination.pages;
					$loading.finish();
					$window.scrollTo(0, 0);
				},
				function(){
					vm.stores = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
					$window.scrollTo(0, 0);
				}
			);
		}
	}

	StoresNewCtrl.$inject = ['Page', '$stores', 'toaster', '$state', '$loading', '$mandant'];
	function StoresNewCtrl(Page, $stores, toaster, $state, $loading, $mandant){
		var vm = this;
		Page.setTitle('Filialen > Neu');
		vm.loading = false;
		vm.store = {
			name: '',
			phone: '',
			email: '',
			image_id: '',
			street: '',
			zip: '',
			town: '',
			description: '',
			category_id: '',
			sort: 0,
			visible_in_registration: 1
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};
		vm.openings = [];
		vm.storeCategories = [];
		vm.openingOptions = {
			readonlyInput: false,
			showMeridian: false
		};
		vm.selectedMedia = {};

		vm.external_links = [];
		vm.addExternalLinks = function(){

		};

		vm.selectMedia = function(media){
			vm.selectedMedia = media;
		};

		vm.selectMedia = function(media){
			vm.selectedMedia = media;
		};
		vm.removeMedia = function(){
			vm.selectedMedia = {};
		};
		vm.reloadMedia = function(){
			load();
		};

		vm.addOpening = function(){
			vm.openings.push({day: '', open_from: moment().hour('00').minutes('00').second('00').toDate(), open_until: moment().hour('00').minutes('00').second('00').toDate()});
		};

		vm.removeOpening = function(index) {
			vm.openings.splice(index, 1);
		};

		vm.save = function(){
			vm.loading = true;
			if(angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == ''){
				if(!confirm('Filiale ohne Bild/Video veröffentlichen?')){
					return false;
				}
			}

			$loading.start();

			$stores.add(vm.store, vm.openings, vm.external_links, vm.selectedMedia).then(
				function(){
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Filiale gespeichert!',
						body: 'Die Filiale wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
					$state.go('app.stores.overview');
				},
				function(){
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Filiale nicht gespeichert!',
						body: 'Die Filiale konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load(){
			$stores.getStoreCategories(1, 9999999999).then(
				function (storeCategories) {
					vm.storeCategories = storeCategories;
				}
			);
		}
	}

	StoresEditCtrl.$inject = ['Page', '$stores', 'toaster', '$state', '$loading', '$stateParams', '$window', '$brands', '$mandant'];
	function StoresEditCtrl(Page, $stores, toaster, $state, $loading, $stateParams, $window, $brands, $mandant){
		var vm = this;
		Page.setTitle('Filialen > Bearbeiten');
		vm.loading = false;
		vm.showMediaBrowser = false;
		vm.store = {};
		vm.openings = [];
		vm.storeCategories = [];
		vm.openingOptions = {
			readonlyInput: false,
			showMeridian: false
		};
		vm.selectedMedia = {};
		vm.labels = {
			'itemsSelected': 'verfügbare Marken',
			'selectAll': 'Alle aktivieren',
			'unselectAll': 'Alle deaktivieren',
			'search': 'Suchen',
			'select': 'Marke(n) wählen'
		};

		vm.rewardLabels = {
			'itemsSelected': 'verfügbare Prämien',
			'selectAll': 'Alle aktivieren',
			'unselectAll': 'Alle deaktivieren',
			'search': 'Suchen',
			'select': 'Prämie(n) wählen'
		};

		vm.brands = [];
		vm.rewards = [];
		vm.selectedBrands = [];
		vm.selectedRewards = [];

		vm.addExternalLinks = function(){

		};

		vm.selectMedia = function (media) {
			var type = '1';
			vm.selectedMedia = media;

			if(angular.isUndefined(media.id)) {
				vm.showMediaBrowser = false;
				vm.store.image_id = 0;
				vm.store.image = {};
			} else {
				vm.store.image_id = media.id;

				if(media.type === '3') {
					type = '3';
					vm.store.image = {
						mandant_id: media.mandant_id,
						content: media.file,
						file: media.file,
						type: type
					};
				} else {
					vm.store.image = {
						mandant_id: media.mandant_id,
						file: media.file,
						type: type
					};
				}

				vm.showMediaBrowser = false;
			}
		};

		vm.removeMedia = function () {
			vm.selectedMedia = {};
			vm.store.image_id = '0';
		};

		vm.reloadMedia = function(){
			load();
		};

		vm.addOpening = function(){
			vm.openings.push({day: '', open_from: moment().hour('00').minutes('00').second('00').toDate(), open_until: moment().hour('00').minutes('00').second('00').toDate()});
		};

		vm.removeOpening = function(index) {
			vm.openings.splice(index, 1);
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.save = function() {
			vm.loading = true;
			if(angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == ''){
				if(!confirm('Filiale ohne Bild/Video veröffentlichen?')){
					return false;
				}
			}

			$loading.start();

			$stores.edit(vm.store, vm.openings, vm.selectedMedia).then(
				function(){
					$stores.saveBrands(vm.store.id, vm.selectedBrands);
					$stores.saveRewards(vm.store.id, vm.selectedRewards);

					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Filiale gespeichert!',
						body: 'Die Filiale wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
					$window.history.back();
				},
				function(){
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Filiale nicht gespeichert!',
						body: 'Die Filiale konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.loading = false;
				}
			);
		};

		load();

		function load(){
			$stores.getStoreCategories(1, 9999999999).then(
				function (storeCategories) {
					vm.storeCategories = storeCategories;
				}
			);

			$brands.getList(1, 9999999, 'all', 'id,title,right_key').then(
				function(brands){
					vm.brands = brands;
				},
				function(brands){
					vm.brands = brands;
				}
			);

			$stores.getRewards(1, 9999999, 'id,title').then(
				function(rewards){
					vm.rewards = rewards;
				},
				function(rewards){
					vm.rewards = rewards;
				}
			);

			$stores.getDetail($stateParams.id).then(
				function(store){
					vm.store = store;
					if(store.image_id !== '0'){
						vm.selectedMedia = store.image;
						vm.media = store.image;
					}

					vm.selectedBrands = angular.copy(vm.store.brands);
					vm.selectedRewards = angular.copy(vm.store.rewards);

					if(store.openings.length > 0){
						angular.forEach(store.openings, function(opening){
							var tmpFrom = opening.open_from.split(':');
							var tmpUntil = opening.open_until.split(':');

							vm.openings.push( { day: opening.day, open_from: moment().hour(tmpFrom[0]).minutes(tmpFrom[1]).second('00').toDate(), open_until: moment().hour(tmpUntil[0]).minutes(tmpUntil[1]).second('00').toDate() } );
						});
					}
				},
				function(){
					$state.go('app.stores.overview');
				}
			);
		}
	}

	CategoriesCtrl.$inject = ['Page', '$stores', 'toaster', '$window', '$loading', '$stateParams', '$state'];
	function CategoriesCtrl(Page, $stores, toaster, $window, $loading, $stateParams, $state) {
		var vm = this;
		Page.setTitle('Filialen > Kategorien');
		vm.storeCategories = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			changeSite();
		};

		vm.add = function () {
			var categoryname = $window.prompt('Name der neuen Kategorie:', '');
			if(categoryname !== null) {
				$loading.start();
				$stores.addCategory(categoryname).then(
					function () {
						changeSite();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Kategorie wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Kategorie konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.changeName = function (category) {
			var categoryname = $window.prompt('Geben Sie den neuen Kategorie-Namen an:', category.name);
			if(categoryname !== null) {
				$loading.start();
				$stores.editCategoryName(category.id, categoryname).then(
					function () {
						changeSite();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Name wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Name konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.remove = function (category) {
			var deleteCategory = $window.confirm(category.name + ' löschen?');

			if(deleteCategory) {
				$loading.start();
				$stores.removeCategory(category.id).then(
					function () {
						$loading.finish();
						changeSite();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Kategorie wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Kategorie konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		load();

		function load() {
			$stores.getStoreCategories(vm.currentPage, vm.entryLimit).then(
				function (storeCategories) {
					vm.storeCategories = storeCategories;
					vm.count = storeCategories.pagination.total;

					vm.totalItems = storeCategories.pagination.total;
					vm.noOfPages = storeCategories.pagination.pages;
				},
				function(){
					vm.storeCategories = [];
					vm.count = 0;
					vm.totalItems = 0;
					vm.noOfPages = 0;
				}
			);
		}

		function changeSite() {
			var tmp = {
				page: vm.currentPage,
				perpage: vm.entryLimit
			};

			load();
			$state.go('app.brands.categories', tmp, {notify: false});
		}
	}

})(angular);

/* global moment, globalConfig */

(function(angular) {
	'use strict';
	var api_endpoint = 'stores';

	angular.module('stores.factory', [])
		.factory('$stores', StoresFactory);

	StoresFactory.$inject = ['$q', '$api', '$log'];

	function StoresFactory($q, $api, $log) {
		return {
			getList: getList,
			add: add,
			edit: edit,
			getDetail: getDetail,
			remove: remove,
			saveExternalLinks: saveExternalLinks,
			saveBrands: saveBrands,
			saveRewards: saveRewards,
			getStoreCategories: getStoreCategories,
			addCategory: addCategory,
			editCategoryName: editCategoryName,
			removeCategory: removeCategory,
			getRewards: getRewards
		};

		function getList(page, perpage, category) {
			var q = $q.defer(),
				customList = {'with': 'image,openings,external_links'};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = globalConfig.defaults.perPage;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if(category){
				customList.category_id = category;
			}

			$api.withToken().all(api_endpoint).customGETLIST('', customList).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}

		function getRewards(page, perpage, fields) {
			var q = $q.defer(),
				customList = {};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = globalConfig.defaults.perPage;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if(fields){
				customList.fields = fields;
			}

			$api.withToken().all('rewards').customGETLIST('', customList).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}

		function add(store, openings, externalLinks, media) {
			var q = $q.defer(),
				tmpStore = {
					name: store.name,
					description: store.description,
					street: store.street,
					town: store.town,
					zip: store.zip,
					email: store.email,
					phone: store.phone,
					sort: parseInt(store.sort, 10) || 0,
					visible_in_registration: angular.isDefined(store.visible_in_registration) ? parseInt(store.visible_in_registration, 10) : 1,
					openings: [],
					external_links: []
				},
				i = 0,
				l = externalLinks.length,
				linkIds = [];

			var save = function(){
				$api.withToken().all(api_endpoint).post(tmpStore).then(
					function() {
						q.resolve();
					},
					function(error) {
						
						q.reject();
					}
				);
			};

			if(angular.isDefined(openings) && openings.length > 0) {
				angular.forEach(openings, function(opening) {
					tmpStore.openings.push({
						day: opening.day,
						open_from: moment(new Date(opening.open_from).toISOString()).format('HH:mm'),
						open_until: moment(new Date(opening.open_until).toISOString()).format('HH:mm'),
						notice: ''
					});
				});
			}

			if(angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpStore.image_id = media.id;
			} else {
				tmpStore.image_id = 0;
			}

			if(store.category_id !== ''){
				tmpStore.category_id = store.category_id;
			}

			if(l > 0) {
				angular.forEach(externalLinks, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if(l === i) {
						tmpStore.external_links = linkIds;
						save();
					}
				});
			} else {
				save();
			}

			return q.promise;
		}

		function edit(store, openings, media) {
			var q = $q.defer(),
				tmpStore = {
					name: store.name,
					description: store.description,
					street: store.street,
					town: store.town,
					zip: store.zip,
					email: store.email,
					phone: store.phone,
					sort: parseInt(store.sort, 10) || 0,
					visible_in_registration: angular.isDefined(store.visible_in_registration) ? parseInt(store.visible_in_registration, 10) : 1,
					openings: [],
					external_links: []
				},
				i = 0,
				l = store.external_links.length,
				linkIds = [];

			var save = function(){
				$api.withToken().one(api_endpoint, store.id).customPUT(tmpStore).then(
					function() {
						q.resolve();
					},
					function(error) {
						
						q.reject();
					}
				);
			};

			if(angular.isDefined(openings) && openings.length > 0) {
				angular.forEach(openings, function(opening) {
					tmpStore.openings.push({
						day: opening.day,
						open_from: moment(new Date(opening.open_from).toISOString()).format('HH:mm'),
						open_until: moment(new Date(opening.open_until).toISOString()).format('HH:mm'),
						notice: ''
					});
				});
			}

			if(angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpStore.image_id = media.id;
			} else {
				tmpStore.image_id = 0;
			}

			if(store.category_id !== ''){
				tmpStore.category_id = store.category_id;
			}

			if(l > 0) {
				angular.forEach(store.external_links, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if(l === i) {
						tmpStore.external_links = linkIds;
						save();
					}
				});
			} else {
				save();
			}

			return q.promise;
		}

		function getDetail(id) {
			var q = $q.defer(),
				customList = {'with': 'image,openings,external_links,rewards'};

			$api.withToken().one(api_endpoint, id).customGET('', customList).then(
				function(tmpResult) {
					var store = tmpResult.result;
					store.sort = parseInt(store.sort, 10) || 0;
					store.visible_in_registration = parseInt(store.visible_in_registration, 10);
					q.resolve(store);
				}
			);

			return q.promise;
		}

		function remove(id) {
			var q = $q.defer();

			$api.withToken().one(api_endpoint, id).remove().then(
				function() {
					q.resolve();
				},
				function() {
					q.reject();
				}
			);

			return q.promise;
		}

		function saveExternalLinks(store_id, external_links) {
			var q = $q.defer(),
				i = 0,
				l = external_links.length,
				linkIds = [];

			if(l > 0) {
				angular.forEach(external_links, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if(l === i) {
						$api.withToken().one(api_endpoint, store_id).customPUT({external_links: linkIds}).then(
							function () {
								q.resolve();
							},
							function (error) {
								
								//q.reject();
							}
						);
					}

				});
			} else {
				$api.withToken().one(api_endpoint, store_id).customPUT({external_links: []}).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						//q.reject();
					}
				);
			}

			return q.promise;
		}

		function saveBrands(store_id, brands) {
			var q = $q.defer(),
				i = 0,
				l = brands.length,
				linkIds = [];

			if(l > 0) {
				angular.forEach(brands, function (brand) {
					i++;

					linkIds.push(brand.id);

					if(l === i) {
						$api.withToken().one(api_endpoint, store_id).all('brands').customPOST({brands: linkIds}).then(
							function () {
								q.resolve();
							},
							function (error) {
								
								//q.reject();
							}
						);
					}

				});
			} else {
				$api.withToken().one(api_endpoint, store_id).all('brands').customPOST({brands: []}).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						//q.reject();
					}
				);
			}

			return q.promise;
		}

		function saveRewards(store_id, rewards) {
			var q = $q.defer(),
				i = 0,
				l = rewards.length,
				linkIds = [];

			if(l > 0) {
				angular.forEach(rewards, function (reward) {
					i++;

					linkIds.push(reward.id);

					if(l === i) {
						$api.withToken().one(api_endpoint, store_id).all('rewards').customPOST({rewards: linkIds}).then(
							function () {
								q.resolve();
							},
							function (error) {
								
								//q.reject();
							}
						);
					}

				});
			} else {
				$api.withToken().one(api_endpoint, store_id).all('rewards').customPOST({rewards: []}).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						//q.reject();
					}
				);
			}

			return q.promise;
		}

		function getStoreCategories(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api.withToken().all('stores').all('categories').customGETLIST('', customList).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}

		function addCategory(name){
			var q = $q.defer();

			$api.withToken().all('stores').all('categories').post({name: name}).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}

		function editCategoryName(categoryId, newName) {
			var q = $q.defer();
			$api.withToken().all('stores').one('categories', categoryId).customPUT({name: newName}).then(
				function () {
					q.resolve();
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}

		function removeCategory(categoryId) {
			var q = $q.defer();

			$api.withToken().all('stores').one('categories', categoryId).remove().then(
				function(tmpResult) {
					q.resolve(tmpResult);
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}
	}

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('surveys', ['surveys.run', 'surveys.factory', 'surveys.controller']);

})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('surveys.run', ['surveys'])
		.run(templateOverride);

	templateOverride.$inject = ['$templateCache'];
	function templateOverride($templateCache){
		$templateCache.put('mw-form-question-builder.html','<div class="mw-form-question-builder-wrapper"> <div class="mw-form-question-builder" ng-class="{\'ng-submitted\':ctrl.formSubmitted}"> <div ng-form="ctrl.form" ng-if="!ctrl.isPreview"> <div class="form-horizontal"> <div class="form-group"> <mw-label label-for="question-text-{{ctrl.id}}" label-class="col-sm-2 control-label" label-key="mwForm.question.text"></mw-label> <div class="col-sm-10 col-md-8"> <input type="text" class="form-control" name="text" ng-attr-id="question-text-{{ctrl.id}}" ng-model="ctrl.question.text" ng-readonly="ctrl.readOnly" required> </div></div><div class="form-group mw-question-type"> <mw-label label-for="question-type-{{ctrl.id}}" label-class="col-sm-2 control-label" label-key="mwForm.question.type"></mw-label> <div class="col-sm-10 form-inline"> <select ng-attr-id="question-type-{{ctrl.id}}" ng-options="\'mwForm.question.types.\'+type+\'.name\'|translate for type in ctrl.questionTypes" ng-model="ctrl.question.type" ng-change="ctrl.questionTypeChanged()" class="form-control" ng-disabled="ctrl.readOnly || ctrl.question.offeredAnswers.length > 0" required></select> <div class="checkbox" ng-if="ctrl.question.type==\'radio\' || ctrl.question.type==\'select\'"> <label> <input type="checkbox" ng-model="ctrl.question.pageFlowModifier" ng-change="ctrl.pageFlowModifierChanged()" ng-readonly="ctrl.readOnly"> <span translate="mwForm.pageFlow.afterQuestionAnswer">Przejdź do strony w oparciu o odpowiedź</span> </label> </div></div></div><div class="form-group mw-question-type" ng-repeat="select in ctrl.options.customQuestionSelects"> <mw-label label-for="question-{{select.key}}-{{ctrl.id}}" label-class="col-sm-2 control-label" label-key="{{select.label}}"></mw-label> <div class="col-sm-10 form-inline"> <select ng-attr-id="question-{{opt.key}}-{{ctrl.id}}" ng-options="opt.label for opt in select.options track by opt.key" ng-model="ctrl.question[select.key]" class="form-control" ng-disabled="ctrl.readOnly" ng-required="select.required"></select> </div></div></div><div class="row" ng-if="ctrl.question.type"> <div class="mw-form-question-answers-builder col-sm-10 col-sm-offset-2 col-md-8" ng-switch="ctrl.question.type"> <div ng-if="ctrl.question.type==\'text\'"> <input class="form-control" type="text" disabled value="{{\'mwForm.question.preview.text\'|translate}}"> </div><div ng-switch-when="textarea"> <textarea class="form-control" disabled>{{\'mwForm.question.preview.textarea\'|translate}}</textarea> </div><div ng-switch-when="radio"> <mw-question-offered-answer-list-builder question="ctrl.question" form-object="ctrl.formObject" read-only="ctrl.readOnly"></mw-question-offered-answer-list-builder> </div><div ng-switch-when="select"> <mw-question-offered-answer-list-builder question="ctrl.question" form-object="ctrl.formObject" read-only="ctrl.readOnly" disable-other-answer="true"></mw-question-offered-answer-list-builder> </div><div ng-switch-when="checkbox"> <mw-question-offered-answer-list-builder question="ctrl.question" form-object="ctrl.formObject" read-only="ctrl.readOnly"></mw-question-offered-answer-list-builder> </div><div ng-switch-when="priority"> <mw-question-priority-list-builder question="ctrl.question" read-only="ctrl.readOnly"></mw-question-priority-list-builder> </div><div ng-switch-when="number" class="form-inline"> <div class="range-config form-inline"> <span translate="mwForm.question.number.min">Min</span>: <input class="form-control" type="number" ng-model="ctrl.question.min" max="{{ctrl.question.max}}" ng-readonly="ctrl.readOnly"/> <span translate="mwForm.question.number.max">Max</span>: <input class="form-control" type="number" min="{{ctrl.question.min}}" ng-model="ctrl.question.max" ng-readonly="ctrl.readOnly"/> </div><br/> <input class="form-control" type="number" disabled > </div><div ng-switch-when="date" class="form-inline"> <input class="form-control" type="date" disabled> </div><div ng-switch-when="datetime" class="form-inline"> <input class="form-control" type="datetime" disabled> </div><div ng-switch-when="time" class="form-inline"> <input class="form-control" type="datetime" disabled> </div><div ng-switch-when="email" class="form-inline"> <input class="form-control" type="email" disabled> </div><div ng-switch-when="range" > <div class="range-config form-inline"> <span translate="mwForm.question.range.from">Range from</span> <input class="form-control" type="number" ng-model="ctrl.question.min" required ng-readonly="ctrl.readOnly"/> <span translate="mwForm.question.range.to">to</span> <input class="form-control" type="number" ng-model="ctrl.question.max" required ng-readonly="ctrl.readOnly"/> </div><br/> <div class="mw-range"> <input min="ctrl.question.min" max="ctrl.question.max" class="" type="range" disabled> </div></div><div ng-switch-when="url" class="form-inline"> <input class="form-control" type="url" disabled> </div></div><div class="col-sm-12" ng-if="ctrl.question.type==\'grid\'"> <mw-question-grid-builder question="ctrl.question" read-only="ctrl.readOnly"></mw-question-grid-builder> </div><div class="col-sm-12" ng-if="ctrl.question.type==\'division\'"> <mw-question-division-builder question="ctrl.question" read-only="ctrl.readOnly"></mw-question-division-builder> </div></div><br/> <br/> <div class="row"> <div class="col-xs-2"> <button type="button" class="btn btn-primary" ng-click="ctrl.save()" translate="mwForm.buttons.questionReady">Gotowe</button> </div><div class="col-xs-10"> <div class="checkbox"> <label> <input type="checkbox" ng-model="ctrl.question.required" ng-disabled="ctrl.readOnly"><span translate="mwForm.question.required">Required</span> </label> </div></div></div></div><div class="mw-preview" ng-if="ctrl.isPreview"> <div class="mw-question-text">{{ctrl.question.text}}<span ng-if="ctrl.question.required">*</span> </div><div class="question-answers" ng-switch="ctrl.question.type"> <div ng-switch-when="text"> <input class="form-control" type="text" disabled value="{{\'mwForm.question.preview.text\'|translate}}"> </div><div ng-switch-when="number" class="form-inline"> <input class="form-control" type="number" disabled> </div><div ng-switch-when="date" class="form-inline"> <input class="form-control" type="date" disabled> </div><div ng-switch-when="datetime" class="form-inline"> <input class="form-control" type="datetime" disabled> </div><div ng-switch-when="time" class="form-inline"> <input class="form-control" type="time" disabled> </div><div ng-switch-when="email" class="form-inline"> <input class="form-control" type="email" disabled> </div><div ng-switch-when="range" class="mw-range"> <input ng-attr-min="{{ctrl.question.min}}" ng-attr-max="{{ctrl.question.max}}" class="" type="range" disabled> </div><div ng-switch-when="url" class="form-inline"> <input class="form-control" type="url" disabled> </div><div ng-switch-when="textarea"> <textarea class="form-control" type="text" disabled>{{\'mwForm.question.preview.textarea\'|translate}}</textarea> </div><div ng-switch-when="radio"> <div class="radio" ng-repeat="answer in ctrl.question.offeredAnswers"> <label> <input type="radio">{{answer.value}}</label> </div><div class="radio" ng-if="ctrl.question.otherAnswer"> <label><input type="radio"><span translate="mwForm.question.preview.otherAnswer">Inna</span>:</label> <span class="form-inline"> <input type="text" class="form-control" disabled> </span> </div></div><div ng-switch-when="checkbox"> <div class="checkbox" ng-repeat="answer in ctrl.question.offeredAnswers"> <label> <input type="checkbox">{{answer.value}}</label> </div><div class="checkbox" ng-if="ctrl.question.otherAnswer"> <label><input type="checkbox"><span translate="mwForm.question.preview.otherAnswer">Inna</span>:</label> <span class="form-inline"> <input type="text" class="form-control" disabled> </span> </div></div><div ng-switch-when="select"> <select class="form-control" ng-disabled="true"> <option ng-repeat="answer in ctrl.question.offeredAnswers">{{answer.value}}</option> </select> </div><div ng-switch-when="grid"> <div class="table-responsive"> <table class="table table-condensed table-striped" border="0" cellpadding="5" cellspacing="0"> <thead> <tr> <td></td><td ng-repeat="col in ctrl.question.grid.cols"> <label>{{col.label}}</label> </td></tr></thead> <tbody> <tr ng-repeat="row in ctrl.question.grid.rows"> <td>{{row.label}}</td><td ng-repeat="col in ctrl.question.grid.cols" ng-switch="ctrl.question.grid.cellInputType"> <input ng-switch-when="radio" type="radio" disabled> <input ng-switch-when="checkbox" type="checkbox" disabled> <input ng-switch-default ng-attr-type="{{ctrl.question.grid.cellInputType}}" disabled ng-class="\'form-control\'"> </td></tr></tbody> </table> </div></div><div class="mw-priority-list" ng-switch-when="priority"> <table> <thead> <tr> <th translate="mwForm.question.priority.sorted">Sorted</th> <th translate="mwForm.question.priority.available">Available</th> </tr></thead> <tbody> <tr> <td class="mw-ordered-items"> </td><td class="mw-available-items"> <div class="mw-item" ng-repeat="item in ctrl.question.priorityList">{{::item.value}}</div></td></tr></tbody> </table> </div><div ng-switch-when="division" class=""> <div class="form-inline" style="margin-bottom: 5px" ng-repeat="item in ctrl.question.divisionList"> <div class="form-group"> <label>{{item.value}}</label> <input type="number" class="form-control" style="width: 80px" > <span>{{ctrl.question.unit}}</span> </div></div><div class="form-inline" style="margin-bottom: 5px"> <div class="form-group"> <label translate="mwForm.question.division.assignedSumLabel"> Przydzielono </label> <input type="number" class="form-control strict-validation" style="width: 80px" readonly value="0"> <span>{{ctrl.question.unit}}<span translate="mwForm.question.division.fromRequiredLabel">z wymaganych</span> <strong>{{ctrl.question.quantity}}</strong>{{ctrl.question.unit}}</span> </div></div></div></div></div></div></div>');
	}
})(angular);

/* global globalConfig, _ */

(function (angular) {
	'use strict';

	angular
		.module('surveys.controller', [])
		.controller('SurveysOverviewController', SurveysOverviewCtrl)
		.controller('SurveysArchiveController', SurveysArchiveCtrl)
		.controller('SurveysDraftController', SurveysDraftCtrl)
		.controller('SurveysTemplatesOverviewController', SurveysTemplatesOverviewCtrl)
		.controller('SurveysNewController', SurveysNewCtrl)
		.controller('SurveysNewModalController', SurveysNewModalCtrl)
		.controller('SurveysDownloadModalController', SurveysDownloadModalCtrl)
		.controller('SurveysEditController', SurveysEditCtrl)
		.controller('SurveysDetailController', SurveysDetailCtrl);

	SurveysOverviewCtrl.$inject = ['Page', '$surveys', 'toaster', '$window', '$user', '$mandant', '$loading', '$stateParams', '$state', '$uibModal'];

	function SurveysOverviewCtrl(Page, $surveys, toaster, $window, $user, $mandant, $loading, $stateParams, $state, $uibModal) {
		var vm = this;
		Page.setTitle('Umfragen > Übersicht');
		vm.surveys = [];
		vm.count = 0;
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.create = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/surveys/newmodal.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'SurveysNewModalController',
				controllerAs: 'vmm',
			});

			modalInstance.result.then(function (template) {
				if (template === '0') {
					$state.go('app.surveys.add');
				} else {
					$state.go('app.surveys.add', { template: template });
				}
			});
		};

		vm.changePage = function () {
			$loading.start();
			load();
			$state.go('app.surveys.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.changeRole = function (qId, new_role) {
			$loading.start();
			$surveys.changeRole(qId, new_role).then(
				function () {
					load();
					$state.go('app.surveys.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
				},
				function () {
					load();
				}
			);
		};

		vm.remove = function (survey) {
			var deleteSurvey = $window.confirm(survey.questionary.name + ' deaktiviert?');

			if (deleteSurvey) {
				$loading.start();
				$surveys.deactivate(survey.questionary.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich deaktiviert!',
							body: 'Umfrage wurde erfolgreich deaktiviert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht deaktiviert!',
							body: 'Umfrage konnte nicht deaktiviert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.download = function (survey) {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/surveys/modalDownloadOptions.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'SurveysDownloadModalController',
				controllerAs: 'vmm',
				resolve: {
					survey: function () {
						return survey;
					},
				},
			});

			modalInstance.result.then(function (downloadOption) {
				$loading.start('Export wird vorbereitet. Dieser Vorgang kann einige Minuten dauern...');

				if (downloadOption === 'wide') {
					$surveys.downloadWide(survey.questionary.id).then(function (downloadRes) {
						$loading.finish();
						$window.open(downloadRes, '_self', '');
					});
				} else if (downloadOption === 'long') {
					$surveys.downloadLong(survey.questionary.id).then(function (downloadRes) {
						$loading.finish();
						$window.open(downloadRes, '_self', '');
					});
				}
			});
		};

		vm.downloadDerby = function (survey) {
			$surveys.downloadDerby(survey.questionary.id).then(function (downloadRes) {
				$window.open(downloadRes, '_self', '');
			});
		};

		load();

		function load() {
			$loading.start('Umfragen werden geladen. Dieser Vorgang kann einige Minuten benötigen...');
			$surveys.getQuestionariesList(vm.currentPage, vm.entryLimit, true).then(
				function (surveys) {
					$loading.finish();
					vm.surveys = surveys;
					vm.count = surveys.pagination.total;

					vm.totalItems = surveys.pagination.total;
					vm.noOfPages = surveys.pagination.pages;
					$window.scrollTo(0, 0);
				},
				function () {
					$loading.finish();
					vm.surveys = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$window.scrollTo(0, 0);
				}
			);

			loadRoles();
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	SurveysArchiveCtrl.$inject = ['Page', '$surveys', 'toaster', '$window', '$user', '$mandant', '$loading', '$stateParams', '$state', '$uibModal'];

	function SurveysArchiveCtrl(Page, $surveys, toaster, $window, $user, $mandant, $loading, $stateParams, $state, $uibModal) {
		var vm = this;
		Page.setTitle('Umfragen > Archiv');
		vm.surveys = [];
		vm.count = 0;
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();
			load();
			$state.go('app.surveys.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.download = function (survey) {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/surveys/modalDownloadOptions.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'SurveysDownloadModalController',
				controllerAs: 'vmm',
				resolve: {
					survey: function () {
						return survey;
					},
				},
			});

			modalInstance.result.then(function (downloadOption) {
				if (downloadOption === 'wide') {
					$surveys.downloadWide(survey.questionary.id).then(function (downloadRes) {
						$window.open(downloadRes, '_self', '');
					});
				} else if (downloadOption === 'long') {
					$surveys.downloadLong(survey.questionary.id).then(function (downloadRes) {
						$window.open(downloadRes, '_self', '');
					});
				}
			});
		};

		vm.downloadDerby = function (survey) {
			$surveys.downloadDerby(survey.questionary.id).then(function (downloadRes) {
				$window.open(downloadRes, '_self', '');
			});
		};

		vm.remove = function (survey) {
			var deleteSurvey = $window.confirm(survey.questionary.name + ' endgültig löschen?');

			if (deleteSurvey) {
				$loading.start();
				$surveys.remove(survey.questionary.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Umfrage wurde erfolgreich gelöscht.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Umfrage konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();

		function load() {
			$loading.start('Umfragen werden geladen. Dieser Vorgang kann einige Minuten benötigen...');
			$surveys.getQuestionariesList(vm.currentPage, vm.entryLimit, null, true).then(
				function (surveys) {
					$loading.finish();
					vm.surveys = surveys;
					vm.count = surveys.pagination.total;

					vm.totalItems = surveys.pagination.total;
					vm.noOfPages = surveys.pagination.pages;
					$window.scrollTo(0, 0);
				},
				function () {
					$loading.finish();
					vm.surveys = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$window.scrollTo(0, 0);
				}
			);

			loadRoles();
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	SurveysDraftCtrl.$inject = ['Page', '$surveys', 'toaster', '$window', '$user', '$mandant', '$loading', '$stateParams', '$state'];

	function SurveysDraftCtrl(Page, $surveys, toaster, $window, $user, $mandant, $loading, $stateParams, $state) {
		var vm = this;
		Page.setTitle('Umfragen > Archiv');
		vm.surveys = [];
		vm.count = 0;
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();
			load();
			$state.go('app.surveys.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.download = function (survey) {
			$surveys.download(survey.questionary.id).then(function (downloadRes) {
				$window.open(downloadRes, '_self', '');
			});
		};

		vm.downloadDerby = function (survey) {
			$surveys.downloadDerby(survey.questionary.id).then(function (downloadRes) {
				$window.open(downloadRes, '_self', '');
			});
		};

		load();

		function load() {
			$loading.start('Umfragen werden geladen. Dieser Vorgang kann einige Minuten benötigen...');
			$surveys.getQuestionariesList(vm.currentPage, vm.entryLimit, null, null, true).then(
				function (surveys) {
					$loading.finish();
					vm.surveys = surveys;
					vm.count = surveys.pagination.total;

					vm.totalItems = surveys.pagination.total;
					vm.noOfPages = surveys.pagination.pages;
					$window.scrollTo(0, 0);
				},
				function () {
					$loading.finish();
					vm.surveys = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$window.scrollTo(0, 0);
				}
			);

			loadRoles();
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	SurveysTemplatesOverviewCtrl.$inject = ['Page', '$surveys', 'toaster', '$window', '$user', '$mandant', '$loading', '$stateParams', '$state', '$uibModal'];

	function SurveysTemplatesOverviewCtrl(Page, $surveys, toaster, $window, $user, $mandant, $loading, $stateParams, $state, $uibModal) {
		var vm = this;
		Page.setTitle('Umfragen > Vorlagen');
		vm.surveys = [];
		vm.count = 0;
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.create = function () {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/surveys/newmodal.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'SurveysNewModalController',
				controllerAs: 'vmm',
			});

			modalInstance.result.then(function (template) {
				if (template === '0') {
					$state.go('app.surveys.add');
				} else {
					$state.go('app.surveys.add', { template: template });
				}
			});
		};

		vm.changePage = function () {
			$loading.start();
			load();
			$state.go('app.surveys.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.changeRole = function (qId, new_role) {
			$loading.start();
			$surveys.changeRole(qId, new_role).then(
				function () {
					load();
					$state.go('app.surveys.overview', { page: vm.currentPage, perpage: vm.entryLimit }, { notify: false });
				},
				function () {
					load();
				}
			);
		};

		vm.remove = function (survey) {
			var deleteSurvey = $window.confirm(survey.questionary.name + ' löschen?');

			if (deleteSurvey) {
				$loading.start();
				$surveys.remove(survey.questionary.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Umfrage wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Umfrage konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();

		function load() {
			$loading.start('Umfragen werden geladen. Dieser Vorgang kann einige Minuten benötigen...');
			$surveys.getTemplates().then(
				function (surveys) {
					$loading.finish();
					vm.surveys = surveys;
					vm.count = surveys.pagination.total;

					vm.totalItems = surveys.pagination.total;
					vm.noOfPages = surveys.pagination.pages;
					$window.scrollTo(0, 0);
				},
				function () {
					$loading.finish();
					vm.surveys = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$window.scrollTo(0, 0);
				}
			);

			loadRoles();
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);
		}
	}

	SurveysNewCtrl.$inject = ['Page', '$surveys', 'toaster', '$state', '$user', '$loading', '$stateParams'];

	function SurveysNewCtrl(Page, $surveys, toaster, $state, $user, $loading, $stateParams) {
		var vm = this;
		Page.setTitle('Umfrage > Neu');
		vm.roles = [];
		vm.on_exits = [];
		vm.is_template = false;

		vm.formBuilder = {};
		vm.optionsBuilder = {
			elementTypes: ['question', 'paragraph'],
			questionTypes: ['text', 'textarea', 'range', 'select', 'radio', 'checkbox', 'number', 'date', 'time'],
		};
		vm.formData = {
			is_draft: '1',
			unique: '0',
			right_key: 'everybody',
			on_exit: '{}',
			pages: [
				{
					id: '08734050c76be6d2ce3074347487b54e',
					number: 1,
					name: null,
					description: null,
					pageFlow: {
						nextPage: true,
						label: 'mwForm.pageFlow.goToNextPage',
					},
					elements: [],
					namedPage: false,
				},
			],
		};
		vm.formStatus = {};
		vm.builderReadOnly = false;

		vm.save = function () {
			$loading.start('Umfrage wird erstellt. Dieser Vorgang kann einige Minuten benötigen...');
			$surveys.add(vm.formData).then(
				function () {
					$loading.finish();
					$state.go('app.surveys.overview');
					toaster.pop({
						type: 'success',
						title: 'Umfrage gespeichert!',
						body: 'Die Umfrage wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'Umfrage nicht gespeichert!',
						body: 'Die Umfrage konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		load();

		function load() {
			if ($stateParams.template !== '0') {
				$surveys.loadTemplate($stateParams.template).then(function (formData) {
					vm.is_template = true;

					vm.formData = angular.fromJson(formData);
					vm.formData.name = '';
					vm.formData.is_draft = '1';
					vm.formData.is_template = '0';
					vm.formData.unique = '0';
					vm.formData.right_key = 'everybody';
					vm.formData.on_exit = '{}';
				});
			}

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);

			$surveys.getExits(1, 999999).then(
				function (on_exits) {
					vm.on_exits = on_exits;
				},
				function () {}
			);
		}
	}

	SurveysNewModalCtrl.$inject = ['Page', '$surveys', '$uibModalInstance'];

	function SurveysNewModalCtrl(Page, $surveys, $uibModalInstance) {
		var vm = this;
		Page.setTitle('Umfrage > Neu');
		vm.templates = [];
		vm.showTemplates = false;
		vm.selectedTemplate = '-1';

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		vm.newSurvey = function () {
			$uibModalInstance.close('0');
		};

		vm.templateSurvey = function () {
			$uibModalInstance.close(vm.selectedTemplate);
		};

		load();

		function load() {
			$surveys.getTemplates().then(
				function (templates) {
					vm.templates = templates;
				},
				function () {}
			);
		}
	}

	SurveysDownloadModalCtrl.$inject = ['$uibModalInstance', '$window', 'survey'];

	function SurveysDownloadModalCtrl($uibModalInstance, $window, survey) {
		var vm = this;
		vm.survey = survey;

		vm.downloadWide = function () {
			$uibModalInstance.close('wide');
		};

		vm.downloadLong = function () {
			$uibModalInstance.close('long');
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};
	}

	SurveysEditCtrl.$inject = ['Page', '$surveys', 'toaster', '$state', '$user', '$stateParams'];

	function SurveysEditCtrl(Page, $surveys, toaster, $state, $user, $stateParams) {
		var vm = this;
		Page.setTitle('Umfrage > Neu');
		vm.roles = [];
		vm.on_exits = [];

		vm.formBuilder = {};
		vm.optionsBuilder = {
			elementTypes: ['question', 'paragraph'],
			questionTypes: ['text', 'textarea', 'range', 'select', 'radio', 'checkbox', 'number', 'date', 'time'],
		};

		vm.questionary = {};

		vm.formData = {
			is_draft: '1',
			unique: '0',
			right_key: 'everybody',
			on_exit: '{}',
			pages: [
				{
					id: '08734050c76be6d2ce3074347487b54e',
					number: 1,
					name: null,
					description: null,
					pageFlow: {
						nextPage: true,
						label: 'mwForm.pageFlow.goToNextPage',
					},
					elements: [],
					namedPage: false,
				},
			],
		};
		vm.formStatus = {};
		vm.builderReadOnly = false;

		vm.save = function () {
			$surveys.edit(vm.questionary.id, vm.formData).then(
				function () {
					toaster.pop({
						type: 'success',
						title: 'Umfrage gespeichert!',
						body: 'Die Umfrage wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					if (vm.formData.is_template === '1') {
						$state.go('app.surveys.templates');
					} else {
						$state.go('app.surveys.overview');
					}
				},
				function () {
					toaster.pop({
						type: 'error',
						title: 'Umfrage nicht gespeichert!',
						body: 'Die Umfrage konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		load();

		function load() {
			$surveys.getQuestionariesDetail($stateParams.id).then(function (questionary) {
				vm.questionary = questionary;
				if (questionary.is_template === '1') {
					vm.formData = angular.fromJson(questionary.template.json);
					vm.formData.is_draft = questionary.is_draft;
					vm.formData.unique = questionary.unique;
					vm.formData.right_key = questionary.right_key;
					vm.formData.on_exit = '{}';
				} else {
					vm.formData = angular.fromJson(questionary.draft.json);
					vm.formData.is_draft = questionary.is_draft;
					vm.formData.unique = questionary.unique;
					vm.formData.right_key = questionary.right_key;
					vm.formData.on_exit = '{}';
				}
			});

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);

			$surveys.getExits(1, 999999).then(
				function (on_exits) {
					vm.on_exits = on_exits;
				},
				function () {}
			);
		}
	}

	SurveysDetailCtrl.$inject = ['Page', '$surveys', '$uibModal', '$stateParams'];

	function SurveysDetailCtrl(Page, $surveys, $uibModal, $stateParams) {
		var vm = this;
		Page.setTitle('Umfrage > Detail');

		vm.survey = {};
		vm.question_answers = false;
		vm.showRespondents = false;
		vm.chartLabels = [];
		vm.chartData = [];
		vm.id = $stateParams.id;

		vm.showStatisic = function (question) {
			$surveys.getQuestionAnswers($stateParams.id, question.question_id).then(function (question_answers) {
				vm.question_answers = question_answers;
				vm.showRespondents = false;
				vm.chartLabels = [];
				vm.chartData = [];

				if (question_answers.type === 'radio' || question_answers.type === 'select' || question_answers.type === 'checkbox') {
					angular.forEach(question_answers.answer_options, function (value, key) {
						vm.chartLabels.push(value.toString());

						var res = _.find(question_answers.answers_given, { answer_id: key.toString() });

						if (angular.isDefined(res)) {
							vm.chartData.push(res.count);
						} else {
							vm.chartData.push('0');
						}
					});
				}

				if (question_answers.type === 'range') {
					var loop = question_answers.answer_options.max - question_answers.answer_options.min;

					for (var i = 0; i <= loop; i++) {
						var label = question_answers.answer_options.min + i;
						vm.chartLabels.push(label);

						var res = _.find(question_answers.answers_given, { answer: label.toString() });

						if (angular.isDefined(res)) {
							vm.chartData.push(res.count);
						} else {
							vm.chartData.push(0);
						}
					}
				}

				if (question_answers.type === 'text' || question_answers.type === 'textarea') {
					vm.chartData = question_answers.answers_given;
				}
			});
		};

		load();

		function load() {
			$surveys.getQuestionaryEvaluation($stateParams.id).then(function (survey) {
				vm.survey = survey;
			});

			$surveys.getQuestionarySurveys($stateParams.id).then(function (surveys) {
				vm.surveys = surveys;
			});
		}
	}
})(angular);

/* global moment */

(function (angular) {
	'use strict';

	angular.module('surveys.factory', []).factory('$surveys', SurveysFactory);

	SurveysFactory.$inject = ['$q', '$api', '$log'];

	function SurveysFactory($q, $api, $log) {
		return {
			getQuestionariesList: getQuestionariesList,
			getExits: getExits,
			getTemplates: getTemplates,
			loadTemplate: loadTemplate,
			getQuestionariesDetail: getQuestionariesDetail,
			getQuestionaryEvaluation: getQuestionaryEvaluation,
			getQuestionAnswers: getQuestionAnswers,
			getQuestionarySurveys: getQuestionarySurveys,
			add: add,
			edit: edit,
			deactivate: deactivate,
			remove: remove,
			download: download,
			downloadWide: downloadWide,
			downloadLong: downloadLong,
			downloadDerby: downloadDerby,
			changeRole: changeRole,
		};

		function getQuestionariesList(page, perpage, withoutDrafts, notActive, onlyDrafts, withoutAnswers) {
			var q = $q.defer(),
				customList = { is_template: '0', is_active: '1' };

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if (withoutDrafts) {
				customList.is_draft = '0';
			}

			if (onlyDrafts) {
				customList.is_draft = '1';
			}

			if (notActive) {
				customList.is_active = '0';
			}

			if (withoutAnswers) {
				$api
					.withToken()
					.all('questionaries')
					.one('answers', '0')
					.customGETLIST('', customList)
					.then(
						function (tmpResult) {
							q.resolve(tmpResult);
						},
						function () {
							q.reject();
						}
					);
			} else {
				$api
					.withToken()
					.all('questionaries')
					.customGETLIST('', customList)
					.then(
						function (tmpResult) {
							q.resolve(tmpResult);
						},
						function () {
							q.reject();
						}
					);
			}

			return q.promise;
		}

		function getExits(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all('questionaries')
				.all('onexit')
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getTemplates() {
			var q = $q.defer(),
				customList = { is_template: '1' };

			customList.perpage = 999999999;
			customList.page = 1;

			$api
				.withToken()
				.all('questionaries')
				.customGETLIST('', customList)
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function loadTemplate(id) {
			var q = $q.defer(),
				customList = {};

			$api
				.withToken()
				.one('questionaries', id)
				.customGET('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult.result.template.json);
				});

			return q.promise;
		}

		function getQuestionariesDetail(id, bikes) {
			var q = $q.defer(),
				custom = {};

			if (bikes) {
				custom.with = 'bikes';
			}

			$api
				.withToken()
				.one('questionaries', id)
				.customGET('', custom)
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function getQuestionaryEvaluation(id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', id)
				.all('evaluation')
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function getQuestionarySurveys(id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', id)
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function getQuestionAnswers(questionary_id, question_id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', questionary_id)
				.one('question', question_id)
				.all('evaluation')
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function download(questionary_id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', questionary_id)
				.all('evaluation_download')
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function downloadWide(questionary_id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', questionary_id)
				.all('evaluation_download')
				.all('wide')
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function downloadLong(questionary_id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', questionary_id)
				.all('evaluation_download')
				.all('long')
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function downloadDerby(questionary_id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', questionary_id)
				.all('evaluation_derby')
				.customGET('', {})
				.then(function (tmpResult) {
					q.resolve(tmpResult.result);
				});

			return q.promise;
		}

		function add(survey) {
			var q = $q.defer();

			if (survey.is_draft === '2') {
				survey.is_template = '1';
				survey.is_draft = '0';
			} else {
				if (survey.is_draft === '1') {
					survey.is_template = '0';
					survey.is_draft = '1';
				} else {
					survey.is_template = '0';
					survey.is_draft = '0';
				}
			}

			$api
				.withToken()
				.all('questionaries')
				.post(survey)
				.then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function edit(qId, survey) {
			var q = $q.defer();
			$api
				.withToken()
				.one('questionaries', qId)
				.customPUT(survey)
				.then(function () {
					q.resolve();
				});

			return q.promise;
		}

		function deactivate(id) {
			var q = $q.defer(),
				date = moment().format('YYYY-MM-DD HH:mm:ss');

			$api
				.withToken()
				.one('questionaries', id)
				.customPUT({ is_active: '0', valid_until: date })
				.then(
					function () {
						q.resolve();
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function remove(id) {
			var q = $q.defer();

			$api
				.withToken()
				.one('questionaries', id)
				.remove()
				.then(
					function () {
						q.resolve();
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function changeRole(qId, right_key) {
			var q = $q.defer();
			$api
				.withToken()
				.one('questionaries', qId)
				.customPUT({ right_key: right_key })
				.then(function () {
					q.resolve();
				});

			return q.promise;
		}
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('derbybikes', ['derbybikes.factory', 'derbybikes.controller']);

})(angular);

/* global angular, globalConfig */

(function (angular) {
	'use strict';

	Object.defineProperty(Array.prototype, 'chunk', {
		value: function (chunkSize) {
			var R = [];
			for(var i = 0; i < this.length; i += chunkSize) {
				R.push(this.slice(i, i + chunkSize));
			}
			return R;
		}
	});

	angular.module('derbybikes.controller', [])
		.controller('DerbyOverviewController', OverviewCtrl)
		.controller('DerbyLinkController', LinkCtrl)
		.controller('DerbyNewController', NewCtrl)
		.controller('DerbyImportController', ImportCtrl)
		.controller('DerbyDetailController', DetailCtrl);

	OverviewCtrl.$inject = ['Page', '$derbybikes', '$window', 'toaster', '$state', '$stateParams', '$loading', '$user', '$cookies'];

	function OverviewCtrl(Page, $derbybikes, $window, toaster, $state, $stateParams, $loading, $user, $cookies) {
		var vm = this;
		Page.setTitle('Derby Cycle');
		vm.bikes = [];
		vm.count = 0;
		vm.filters = [];
		vm.showSearch = false;
		vm.roles = [];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			$loading.start();
			loadBikes();
			$state.go('app.derbybikes.overview', {page: vm.currentPage, perpage: vm.entryLimit}, {notify: false});
		};

		vm.remove = function (bike) {
			var deleteImg = $window.confirm(bike.bike_nr + ' wirklich löschen?');

			if(deleteImg) {
				$derbybikes.deleteBike(bike.id).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Datei wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						loadBikes();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Datei konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.addFilter = function () {
			vm.filters.push({
				field: '',
				value: ''
			});
		};

		vm.removeFilter = function ($index) {
			vm.filters.splice($index, 1);
			vm.search();
		};

		vm.search = function () {
			$loading.start();

			var expireDate = new Date();
			expireDate.setDate(expireDate.getDate() + 7);
			$cookies.putObject('search-filter-derby', vm.filters, {'expires': expireDate});

			vm.currentPage = 1;
			loadBikes();
			$state.go('app.derbybikes.overview', {page: vm.currentPage, perpage: vm.entryLimit}, {notify: false});
		};

		load();
		loadBikes();

		function load() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {

				}
			);
		}

		function loadBikes() {
			var filterCookie = $cookies.getObject('search-filter-derby');
			if(angular.isDefined(filterCookie)) {
				vm.filters = filterCookie;
			}

			$derbybikes.getBikes(vm.currentPage, vm.entryLimit, vm.filters).then(
				function (bikes) {
					vm.bikes = bikes;
					vm.count = bikes.pagination.total;

					vm.totalItems = bikes.pagination.total;
					vm.noOfPages = bikes.pagination.pages;
					$loading.finish();
				},
				function () {
					vm.bikes = [];
					$loading.finish();
				}
			);
		}
	}

	LinkCtrl.$inject = ['Page', '$derbybikes', '$surveys', 'toaster', '$loading'];

	function LinkCtrl(Page, $derbybikes, $surveys, toaster, $loading) {
		var vm = this,
			selectAllAdd = false,
			selectAllRemove = false;
		Page.setTitle('Derby Cycle');
		vm.bikes = [];
		vm.surveys = [];
		vm.selectedSurvey = '';
		vm.selectedBikes = [];
		vm.selectedAdd = [];
		vm.selectedRemove = [];

		vm.selectAllAdd = function(){
			if(!selectAllAdd){
				selectAllAdd = true;
				vm.selectedAdd = vm.bikes.map(function(item){ return item.id; });
			} else {
				selectAllAdd = false;
				vm.selectedAdd = [];
			}
		};

		vm.selectAllRemove = function(){
			if(!selectAllRemove){
				selectAllRemove = true;
				vm.selectedRemove = vm.bikes.map(function(item){ return item.id; });
			} else {
				selectAllRemove = false;
				vm.selectedRemove = [];
			}
		};

		vm.changeSurvey = function () {
			$loading.start();
			$surveys.getQuestionariesDetail(vm.selectedSurvey, true).then(
				function (survey) {
					vm.selectedSurveyObject = survey;
					vm.selectedBikes = [];
					angular.forEach(survey.bikes, function (bike) {
						vm.selectedBikes.push(bike);
					});
					$loading.finish();
				}
			);
		};

		vm.add = function(){
			var l = vm.selectedAdd.length,
				i = 0;

			angular.forEach(vm.selectedAdd, function(selected){
				vm.selectedBikes.push({'id': selected});

				i = i+1;
				if(l === i){
					save();
				}
			});
		};

		vm.remove = function(){
			var l = vm.selectedRemove.length,
				i = 0,
				tmpSelected = [];

			if(l > 0){
				angular.forEach(vm.selectedBikes, function(selected){
					var _find = vm.selectedRemove.find(
						function(elm){
							return elm === selected.id;
						}
					);

					if(!_find){
						tmpSelected.push({'id': selected.id});
					}

					i = i+1;
					if(l === i){
						vm.selectedBikes = tmpSelected;
						save();
					}
				});
			} else {
				vm.selectedBikes = [];
				vm.save();
			}
		};

		function save(){
			$loading.start();
			var selectedBikes = vm.selectedBikes.chunk(50),
				length = selectedBikes.length,
				i = 0,
				success = false;

			if(length > 0) {
				angular.forEach(selectedBikes, function (bikes) {
					i++;
					$derbybikes.bikes2questionary(vm.selectedSurvey, bikes).then(
						function () {
							if(i === length && success === false) {
								$loading.finish();
								selectAllAdd = false;
								selectAllRemove = false;
								success = true;
								toaster.pop({
									type: 'success',
									title: 'Erfolgreich gespeichert!',
									body: 'Die Zuordnung wurde erfolgreich gespeichert.',
									timeout: globalConfig.toastTimeout,
									showCloseButton: true
								});
							}
						}
					);
				});
			} else {
				$derbybikes.bikes2questionary(vm.selectedSurvey, []).then(
					function () {
						$loading.finish();
						selectAllAdd = false;
						selectAllRemove = false;
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gespeichert!',
							body: 'Die Zuordnung wurde erfolgreich gespeichert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		}

		vm.inArray = function(id) {
			if(angular.isDefined(vm.selectedBikes) && vm.selectedBikes.length > 0) {
				var _find = _.find(vm.selectedBikes, {'id': id});

				if(angular.isDefined(_find)) {
					return true;
				}
			}

			return false;
		};

		vm.notInArray = function(id) {
			if(angular.isDefined(vm.selectedBikes) && vm.selectedBikes.length > 0) {
				var _find = _.find(vm.selectedBikes, {'id': id});

				if(angular.isDefined(_find)) {
					return false;
				}
			}

			return true;
		};

		load();

		function load() {
			$derbybikes.getBikes(1, 999999).then(
				function (bikes) {
					vm.bikes = bikes;
				},
				function () {
					vm.bikes = [];
				}
			);

			$surveys.getQuestionariesList(1, 999999, true, false, false, true).then(
				function (surveys) {
					vm.surveys = surveys;
				},
				function () {
					vm.surveys = [];
				}
			);
		}
	}

	NewCtrl.$inject = ['Page', '$derbybikes', '$state', 'toaster', '$loading'];

	function NewCtrl(Page, $derbybikes, $state, toaster, $loading) {
		var vm = this;
		vm.bike = {
			right_key: 'testing'
		};
		Page.setTitle('Derby Cycle');

		vm.save = function () {
			$loading.start();
			$derbybikes.addBike(vm.bike).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich erstellt!',
						body: 'Das Fahrrad wurde erfolgreich erstellt.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});

					$state.go('app.derbybikes.overview');
				},
				function (errorcode) {
					$loading.finish();
					if(errorcode === 32023) {
						toaster.pop({
							type: 'error',
							title: 'Konnte nicht erstellt werden!',
							body: 'Ein Fahrrad existiert bereits mit dieser Seriennummer.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				}
			);
		};
	}

	ImportCtrl.$inject = ['Page', '$derbybikes', '$state', 'toaster', '$loading', '$upload'];

	function ImportCtrl(Page, $derbybikes, $state, toaster, $loading, $upload) {
		var vm = this;
		Page.setTitle('Derby Cycle > Importieren');
		vm.fileinfos = {
			file: '',
			overwrite: false
		};
		vm.isImportResult = false;
		vm.importResult = {};

		vm.submitCsv = function () {
			var mode = 'derby';

			if(vm.fileinfos.overwrite === true){
				mode = 'derby-update';
			}

			$loading.start();
			$upload.upload({
				data: {csv: vm.fileinfos.file}
			}, mode).then(
				function (uploadResult) {
					vm.importResult = uploadResult.data.result;
					vm.isImportResult = true;

					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich hochgeladen!',
						body: 'Datei wurde erfolgreich hochgeladen.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				},
				function () {
					vm.isImportResult = false;
					vm.importResult = {};
					$loading.finish();
				}
			);
		};
	}

	DetailCtrl.$inject = ['Page', '$derbybikes', '$stateParams', 'toaster', '$surveys', '$loading'];

	function DetailCtrl(Page, $derbybikes, $stateParams, toaster, $surveys, $loading) {
		var vm = this;
		Page.setTitle('Derby Cycle');
		vm.bike = {};
		vm.editBike = {};
		vm.surveys = [];
		vm.selectedSurveys = [];
		vm.selectedAdd = [];
		vm.selectedRemove = [];
		vm.selectedProperty = '0';
		vm.showEdit = false;

		vm.editProperties = function () {
			vm.editBike = angular.copy(vm.bike.properties[0]);
			vm.showEdit = true;
		};

		vm.saveProperties = function(){
			$loading.start();
			$derbybikes.editProperties($stateParams.id, vm.editBike).then(
				function(bike){
					vm.bike = bike;
					reloadSurveys();

					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich gespeichert!',
						body: 'Daten wurden erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
					vm.cancelProperties();
				}
			);
		};

		vm.cancelProperties = function () {
			vm.editBike = {};
			vm.showEdit = false;
		};

		vm.questionaries2bike = function () {
			$loading.start();
			$derbybikes.questionaries2bike($stateParams.id, vm.selectedSurveys).then(
				function () {
					load();
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Erfolgreich zugeordnet!',
						body: 'Diesem Fahrrad wurde(n) die Umfrage(n) zugeordnet.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true
					});
				}
			);
		};

		vm.updateBike = function (field) {
			$derbybikes.updateBike($stateParams.id, field, vm.bike).then(
				function (bike) {
					vm.bike = bike;
					reloadSurveys();
				},
				function () {
					vm.bike = {};
				}
			);
		};

		vm.inArray = function(id) {
			if(angular.isDefined(vm.selectedSurveys) && vm.selectedSurveys.length > 0) {
				var _find = _.find(vm.selectedSurveys, {'id': id});

				if(angular.isDefined(_find)) {
					return true;
				}
			}

			return false;
		};

		vm.notInArray = function(id) {
			if(angular.isDefined(vm.selectedSurveys) && vm.selectedSurveys.length > 0) {
				var _find = _.find(vm.selectedSurveys, {'id': id});

				if(angular.isDefined(_find)) {
					return false;
				}
			}

			return true;
		};

		vm.add = function(){
			var l = vm.selectedAdd.length,
				i = 0;
			angular.forEach(vm.selectedAdd, function(selected){
				vm.selectedSurveys.push({'id': selected});

				i = i+1;
				if(l === i){
					vm.questionaries2bike();
				}
			});
		};

		vm.remove = function(){
			var l = vm.selectedRemove.length,
				i = 0,
				tmpSelected = [];

			if(l > 0){
				angular.forEach(vm.selectedSurveys, function(selected){
					var _find = vm.selectedRemove.find(
						function(elm){
							return elm === selected.id;
						}
					);

					if(!_find){
						tmpSelected.push({'id': selected.id});
					}

					i = i+1;
					if(l === i){
						vm.selectedSurveys = tmpSelected;
						vm.questionaries2bike();
					}
				});
			} else {
				vm.selectedSurveys = [];
				vm.questionaries2bike();
			}
		};

		load();

		function load() {
			$derbybikes.getBike($stateParams.id).then(
				function (bike) {
					vm.bike = bike;
					reloadSurveys();
				},
				function () {
					vm.bike = {};
					vm.selectedSurveys = [];
				}
			);

			$surveys.getQuestionariesList(1, 99999, true, false, false, true).then(
				function (surveys) {
					vm.surveys = surveys;
				},
				function () {
					vm.surveys = [];
				}
			);
		}

		function reloadSurveys() {
			vm.selectedSurveys = [];
			angular.forEach(vm.bike.questionaries, function (questionary) {
				vm.selectedSurveys.push({'id': questionary.id});
			});
		}
	}

})(angular);

/* global angular */

(function (angular) {
	'use strict';
	var api_endpoint = 'bikes';

	angular.module('derbybikes.factory', [])
		.factory('$derbybikes', DerbyFactory);

	DerbyFactory.$inject = ['$q', '$api', '$log'];

	function DerbyFactory($q, $api, $log) {
		return {
			getBikes: getBikes,
			getBike: getBike,
			addBike: addBike,
			deleteBike: deleteBike,
			updateBike: updateBike,
			editProperties: editProperties,
			questionaries2bike: questionaries2bike,
			bikes2questionary: bikes2questionary
		};

		function getBikes(page, perpage, search) {
			var q = $q.defer(),
				customList = {};

			if(perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if(page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if(angular.isArray(search)) {
				angular.forEach(search, function (tmpSearch) {
					if(tmpSearch.field !== 'right_key') {
						customList[tmpSearch.field] = 'LIKE(%' + tmpSearch.text + '%)';
					} else {
						customList[tmpSearch.field] = tmpSearch.text;
					}
				});
			}

			$api.withToken().all(api_endpoint).customGETLIST('', customList).then(
				function (tmpResult) {
					q.resolve(tmpResult);
				},
				function () {
					q.reject();
				}
			);

			return q.promise;
		}

		function getBike(id) {
			var q = $q.defer(),
				custom = {};

			$api.withToken().one(api_endpoint, id).customGET('', custom).then(
				function (bike) {
					q.resolve(bike.result);
				},
				function () {
					q.reject();
				}
			);

			return q.promise;
		}

		function addBike(bike) {
			var q = $q.defer();

			$api.withToken().all(api_endpoint).post(bike).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject(error.data.error.code);
				}
			);

			return q.promise;
		}

		function deleteBike(id) {
			var q = $q.defer();

			$api.withToken().one(api_endpoint, id).remove().then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject(error.data.error.code);
				}
			);

			return q.promise;
		}

		function updateBike(bikeId, field, data) {
			var q = $q.defer(),
				customData = {};

			customData[field] = data[field];

			$api.withToken().one('bikes', bikeId).customPUT(customData).then(
				function (bike) {
					q.resolve(bike.result);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function editProperties(bikeId, properties) {
			var q = $q.defer(),
				customPostData = {
					'cockpit_hw': properties.cockpit_hw,
					'cockpit_fw': properties.cockpit_fw,
					'cockpit_sn': properties.cockpit_sn,
					'motor_hw': properties.motor_hw,
					'motor_fw': properties.motor_fw,
					'motor_sn': properties.motor_sn,
					'controller_hw': properties.controller_hw,
					'controller_fw': properties.controller_fw,
					'controller_sn': properties.controller_sn,
					'accu_hw': properties.accu_hw,
					'accu_fw': properties.accu_fw,
					'accu_sn': properties.accu_sn,
					'harness_hw': properties.harness_hw,
					'fasteners_hw': properties.fasteners_hw,
					'remote_sn': properties.remote_sn,
					'remote_hw': properties.remote_hw,
					'remote_fw': properties.remote_fw
				};

			$api.withToken().all('bikes').all('properties').all(bikeId).post(customPostData).then(
				function (bike) {
					q.resolve(bike.result);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function questionaries2bike(id, questionaries) {
			var q = $q.defer(),
				tmpPost = {
					bike_id: id,
					questionaries: []
				},
				l = questionaries.length,
				i = 0;

			var send = function(){
				$api.withToken().all(api_endpoint).all('questionaries2bike').post(tmpPost).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);
			};

			if(l > 0){
				angular.forEach(questionaries, function(questionary){
					tmpPost.questionaries.push(questionary.id);
					i = i+1;
					if(l === i){
						send();
					}
				});
			} else {
				send();
			}

			return q.promise;
		}

		function bikes2questionary(id, bikes) {
			var q = $q.defer(),
				tmpPost = {
					questionary_id: id,
					bikes: []
				},
			i = 0;

			function send(){
				$api.withToken().all(api_endpoint).all('bikes2questionary').post(tmpPost).then(
					function () {
						q.resolve();
					},
					function (error) {
						
						q.reject();
					}
				);
			}

			if(bikes.length > 0){
				angular.forEach(bikes, function(bike){
					tmpPost.bikes.push(bike.id);

					i = i+1;
					if(bikes.length === i){
						send();
					}
				});
			} else {
				send();
			}

			return q.promise;
		}

	}

})(angular);

(function (angular) {
	'use strict';

	angular.module('contests', ['contests.factory', 'contests.controller']);
})(angular);

/* global globalConfig */

(function (angular) {
	'use strict';

	angular.module('contests.controller', []).controller('ContestsOverviewController', OverviewCtrl).controller('ContestsNewController', NewCtrl).controller('ContestsEditController', EditCtrl).controller('ContestsDetailController', DetailCtrl);

	OverviewCtrl.$inject = ['Page', '$contests', '$window', '$loading', 'toaster'];

	function OverviewCtrl(Page, $contests, $window, $loading, toaster) {
		var vm = this;
		Page.setTitle('Gewinnspiel');
		vm.contests = [];
		vm.count = 0;

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		vm.changePage = function () {
			load(vm.currentPage);
		};

		vm.remove = function (contest) {
			var deleteContest = $window.confirm(contest.title + ' löschen?');

			if (deleteContest) {
				$loading.start();
				$contests.remove(contest.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Gewinnspiel wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Gewinnspiel konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load(1);

		function load(page) {
			$contests.getContests(page, vm.entryLimit).then(
				function (contests) {
					vm.contests = contests;
					vm.count = contests.pagination.total;

					vm.totalItems = contests.pagination.total;
					vm.noOfPages = contests.pagination.pages;
				},
				function () {
					vm.contests = [];
				}
			);
		}
	}

	NewCtrl.$inject = ['Page', '$contests', '$scope', '$loading', '$state', 'toaster'];
	function NewCtrl(Page, $contests, $scope, $loading, $state, toaster) {
		var vm = this;
		vm.loading = false;

		Page.setTitle('Gewinnspiel > Erstellen');
		vm.contest = {
			title: '',
			terms: '',
			valid_from: new Date(),
			valid_until: '',
			success_title: 'Teilnahme erfolgreich',
			success_text: 'Vielen Dank für die Teilnahme an unserem Gewinnspiel! Wir wünschen Ihnen viel Glück!',
			already_title: 'Bereits teilgenommen',
			already_text: 'Sie haben bereits an diesem Gewinnspiel teilgenommen!',
			date_title: 'Gewinnspiel nicht verfügbar',
			date_text: 'Das Gewinnspiel ist noch nicht verfügbar oder bereits abgelaufen!',
		};

		// Datepicker
		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		$scope.$watch(
			function () {
				return vm.contest.valid_from;
			},
			function (value) {
				vm.enddateOptions.minDate = value;
			}
		);

		// Datepicker Time
		vm.timePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		// Datepicker
		vm.enddatePopup = false;
		vm.enddateOptions = {
			date: new Date(),
			minDate: new Date(),
		};

		// Datepicker Time
		vm.endtimePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();

			$contests.createContest(vm.contest).then(
				function () {
					$state.go('app.contests.overview');
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Gewinnspiel gespeichert!',
						body: 'Das Gewinnspiel wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'Gewinnspiel nicht gespeichert!',
						body: 'Das Gewinnspiel konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};
	}

	EditCtrl.$inject = ['Page', '$contests', '$scope', '$loading', '$state', 'toaster', '$stateParams'];
	function EditCtrl(Page, $contests, $scope, $loading, $state, toaster, $stateParams) {
		var vm = this;
		vm.loading = false;

		Page.setTitle('Gewinnspiel > Bearbeiten');
		vm.contest = {
			title: '',
			terms: '',
			valid_from: new Date(),
			valid_until: '',
			success_title: 'Teilnahme erfolgreich',
			success_text: 'Vielen Dank für die Teilnahme an unserem Gewinnspiel! Wir wünschen Ihnen viel Glück!',
			already_title: 'Bereits teilgenommen',
			already_text: 'Sie haben bereits an diesem Gewinnspiel teilgenommen!',
			date_title: 'Gewinnspiel nicht verfügbar',
			date_text: 'Das Gewinnspiel ist noch nicht verfügbar oder bereits abgelaufen!',
		};

		// Datepicker
		vm.datePopup = false;
		vm.dateOptions = {
			minDate: new Date(),
		};

		$scope.$watch(
			function () {
				return vm.contest.valid_from;
			},
			function (value) {
				vm.enddateOptions.minDate = value;
			}
		);

		// Datepicker Time
		vm.timePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		// Datepicker
		vm.enddatePopup = false;
		vm.enddateOptions = {
			date: new Date(),
			minDate: new Date(),
		};

		// Datepicker Time
		vm.endtimePopup = {
			date: new Date(),
			open: false,
			timepickerOptions: {
				readonlyInput: false,
				showMeridian: false,
			},
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();

			$contests.editContest($stateParams.id, vm.contest).then(
				function () {
					$state.go('app.contests.overview');
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Gewinnspiel gespeichert!',
						body: 'Das Gewinnspiel wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'Gewinnspiel nicht gespeichert!',
						body: 'Das Gewinnspiel konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		load();

		function load() {
			$loading.start();
			$contests.getContest($stateParams.id).then(function (contest) {
				$loading.finish();
				var on_exit = angular.fromJson(contest.on_exit);

				vm.contest = {
					title: contest.title,
					terms: contest.terms,
					valid_from: new Date(contest.valid_from),
					valid_until: new Date(contest.valid_until),
					success_title: on_exit.alert.title,
					success_text: on_exit.alert.text,
					already_title: on_exit.alertJoined.title,
					already_text: on_exit.alertJoined.text,
					date_title: on_exit.alertDate.title,
					date_text: on_exit.alertDate.text,
				};
			});
		}
	}

	DetailCtrl.$inject = ['Page', '$contests', '$stateParams', 'toaster'];

	function DetailCtrl(Page, $contests, $stateParams, toaster) {
		var vm = this;
		Page.setTitle('Gewinnspiel > Detail');
		vm.contest = {};
		vm.contestUsers = [];
		vm.winners = [];

		vm.getWinner = function () {
			$contests.getWinner($stateParams.id).then(function () {
				load();
			});
		};

		vm.exportUsers = function () {
			$contests.exportUsers($stateParams.id).then(function () {
				toaster.pop({
					type: 'success',
					title: 'Erfolgreich gestartet!',
					body: 'Der Teilnehmer-Export wurde zur Warteschlange hinzugefügt.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true,
				});
			});
		};

		load();

		function load() {
			$contests.getContest($stateParams.id).then(
				function (contest) {
					vm.contest = contest;
				},
				function () {
					vm.contest = {};
				}
			);

			$contests.getUsers($stateParams.id).then(
				function (contestUsers) {
					vm.contestUsers = contestUsers;
				},
				function () {
					vm.contestUsers = [];
				}
			);

			$contests.getWinners($stateParams.id).then(
				function (winnersUsers) {
					vm.winners = winnersUsers;
				},
				function () {
					vm.winners = [];
				}
			);
		}
	}
})(angular);

/* global moment */

(function (angular) {
	'use strict';
	var api_endpoint = 'contests';

	angular.module('contests.factory', []).factory('$contests', ContestsFactory);

	ContestsFactory.$inject = ['$q', '$api', '$log'];

	function ContestsFactory($q, $api, $log) {
		return {
			getContests: getContests,
			getList: getContests,
			getContest: getContest,
			createContest: createContest,
			editContest: editContest,
			getWinner: getWinner,
			getWinners: getWinners,
			getUsers: getUsers,
			exportUsers: exportUsers,
			remove: remove,
		};

		function getContests(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all(api_endpoint)
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getContest(id) {
			var q = $q.defer(),
				custom = {};

			$api
				.withToken()
				.one(api_endpoint, id)
				.customGET('', custom)
				.then(
					function (contest) {
						q.resolve(contest.result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function createContest(contest) {
			var q = $q.defer(),
				tmpContest = {
					title: contest.title,
					description: contest.title,
					terms: contest.terms,
					valid_from: moment(new Date(contest.valid_from).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					valid_until: moment(new Date(contest.valid_until).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					success_title: contest.success_title,
					success_text: contest.success_text,
					already_title: contest.already_title,
					already_text: contest.already_text,
					date_title: contest.date_title,
					date_text: contest.date_text,
				};

			$api
				.withToken()
				.all(api_endpoint)
				.post(tmpContest)
				.then(
					function (result) {
						q.resolve(result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function editContest(id, contest) {
			var q = $q.defer(),
				tmpContest = {
					title: contest.title,
					description: contest.title,
					terms: contest.terms,
					valid_from: moment(new Date(contest.valid_from).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					valid_until: moment(new Date(contest.valid_until).toISOString()).format('YYYY-MM-DD HH:mm:ss'),
					success_title: contest.success_title,
					success_text: contest.success_text,
					already_title: contest.already_title,
					already_text: contest.already_text,
					date_title: contest.date_title,
					date_text: contest.date_text,
				};

			$api
				.withToken()
				.one(api_endpoint, id)
				.customPUT(tmpContest)
				.then(
					function (result) {
						q.resolve(result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function getWinner(id) {
			var q = $q.defer(),
				custom = { with: 'user' };

			$api
				.withToken()
				.one(api_endpoint, id)
				.all('winner')
				.customGET('', custom)
				.then(
					function (winner) {
						q.resolve(winner.result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function getWinners(id) {
			var q = $q.defer(),
				custom = { with: 'user' };

			$api
				.withToken()
				.one(api_endpoint, id)
				.all('winners')
				.customGETLIST('', custom)
				.then(
					function (winners) {
						if (winners.length > 0) {
							q.resolve(winners);
						} else {
							q.reject();
						}
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function getUsers(id) {
			var q = $q.defer(),
				customList = { with: 'user' };

			$api
				.withToken()
				.one(api_endpoint, id)
				.all('users')
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					if (tmpResult.length > 0) {
						q.resolve(tmpResult);
					} else {
						q.reject();
					}
				});

			return q.promise;
		}

		function exportUsers(id) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, id)
				.all('export')
				.post({})
				.then(
					function (result) {
						q.resolve(result.result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function remove(id) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, id)
				.remove()
				.then(
					function (result) {
						q.resolve(result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}
	}
})(angular);

(function (angular) {
	'use strict';

	angular.module('qr', ['qr.factory', 'qr.controller']);
})(angular);

/* global _, globalConfig */
(function (angular) {
	'use strict';

	angular.module('qr.controller', []).controller('QrOverviewController', OverviewCtrl).controller('QrNewController', NewCtrl).controller('QrEditController', EditCtrl).controller('QrImageController', ImageCtrl);

	OverviewCtrl.$inject = ['Page', '$qr', '$externallink', '$uibModal', '$loading', 'toaster'];
	function OverviewCtrl(Page, $qr, $externallink, $uibModal, $loading, toaster) {
		var vm = this;
		Page.setTitle('QR-Code');
		vm.qrs = [];
		vm.external_classes = [];
		vm.count = 0;

		vm.currentPage = 1;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = '25';
		vm.noOfPages = 1;

		vm.changePage = function () {
			load(vm.currentPage);
		};

		vm.actionName = function (action) {
			if (angular.isUndefined(action) || action === null) {
				return '';
			}

			if (action === 'contentgroup') {
				action = 'content';
			}

			var externalClass = _.find(vm.external_classes, { class: action });

			if (angular.isUndefined(externalClass)) {
				return '';
			}

			return externalClass.description || '';
		};

		vm.openQr = function (qr) {
			$loading.start();
			$qr.getImage(qr.id).then(function () {
				$loading.finish();
				$uibModal.open({
					templateUrl: 'static/templates/qr/modalQrImage.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
					controller: 'QrImageController',
					controllerAs: 'vmm',
					resolve: {
						qrObject: function () {
							return qr;
						},
					},
				});
			});
		};

		vm.remove = function (qr) {
			$loading.start();
			$qr.removeQr(qr.id).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'QR-Code gelöscht!',
						body: 'Der QR-Code wurde erfolgreich gelöscht.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
					load(vm.currentPage);
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'QR-Code nicht gelöscht!',
						body: 'Der QR-Code konnte nicht gelöscht werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		load(1);
		loadLinkClasses();

		function load(page) {
			$qr.getQrs(page, vm.entryLimit).then(
				function (qrs) {
					vm.qrs = qrs;
					vm.count = qrs.pagination.total;

					vm.totalItems = qrs.pagination.total;
					vm.noOfPages = qrs.pagination.pages;
				},
				function () {
					vm.qrs = [];
				}
			);
		}

		function loadLinkClasses() {
			$externallink.getClasses().then(
				function (external_classes) {
					vm.external_classes = external_classes;
				},
				function () {
					vm.external_classes = [];
				}
			);
		}
	}

	NewCtrl.$inject = ['Page', '$qr', '$state', '$externallink', '$surveys', '$contentgroup', '$media', '$brands', '$events', '$contests', '$stores', '$raffle', '$loading', 'toaster'];
	function NewCtrl(Page, $qr, $state, $externallink, $surveys, $contentgroup, $media, $brands, $events, $contests, $stores, $raffle, $loading, toaster) {
		var vm = this;
		Page.setTitle('QR-Code erstellen');
		vm.loading = false;

		vm.qr = {
			description: '',
			action: '',
			parameter: '',
			mode: '',
		};
		vm.external_classes = [];
		vm.count = 0;

		vm.questionaries = [];
		vm.pagegroups = [];
		vm.files = [];
		vm.brands = [];
		vm.events = [];
		vm.contests = [];
		vm.stores = [];

		vm.changeExternalLinkAction = function () {
			vm.qr.parameter = '';
			vm.qr.mode = '';

			if (vm.qr.action === 'questionary') {
				$surveys.getQuestionariesList(1, 99999999).then(
					function (questionaries) {
						vm.questionaries = questionaries;
					},
					function () {
						vm.questionaries = [];
					}
				);
			}

			if (vm.qr.action === 'content') {
				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if (vm.qr.action === 'pdf') {
				vm.qr.mode = 'link';

				$media.getFileList(1, 999999, false, 'pdf').then(
					function (files) {
						vm.files = files;
					},
					function () {
						vm.files = [];
					}
				);
			}

			if (vm.qr.action === 'brands') {
				$brands.getList(1, 999999).then(
					function (brands) {
						vm.brands = brands;
					},
					function () {
						vm.brands = [];
					}
				);
			}

			if (vm.qr.action === 'events') {
				$events.getList(1, 999999).then(
					function (events) {
						vm.events = events;
					},
					function () {
						vm.events = [];
					}
				);
			}

			if (vm.qr.action === 'contests') {
				$contests.getList(1, 999999).then(
					function (contests) {
						vm.contests = contests;
					},
					function () {
						vm.contests = [];
					}
				);
			}

			if (vm.qr.action === 'stores') {
				$stores.getList(1, 999999).then(
					function (stores) {
						vm.stores = stores;
					},
					function () {
						vm.stores = [];
					}
				);
			}

			if (vm.qr.action === 'raffle') {
				$raffle.getBackendList().then(
					function (raffles) {
						vm.raffles = raffles;
					},
					function () {
						vm.raffles = [];
					}
				);
			}
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();

			$qr.newQr(vm.qr).then(
				function () {
					$state.go('app.qr.overview');
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'QR-Code gespeichert!',
						body: 'Der QR-Code wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'QR-Code nicht gespeichert!',
						body: 'Der QR-Code konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		loadLinkClasses();

		function loadLinkClasses() {
			$externallink.getClasses().then(
				function (external_classes) {
					vm.external_classes = external_classes;
				},
				function () {
					vm.external_classes = [];
				}
			);
		}
	}

	EditCtrl.$inject = ['Page', '$qr', '$state', '$externallink', '$surveys', '$contentgroup', '$media', '$brands', '$events', '$contests', '$stores', '$raffle', '$loading', 'toaster'];
	function EditCtrl(Page, $qr, $state, $externallink, $surveys, $contentgroup, $media, $brands, $events, $contests, $stores, $raffle, $loading, toaster) {
		var vm = this;
		Page.setTitle('QR-Code bearbeiten');
		vm.loading = false;

		vm.qr = {
			description: '',
			action: '',
			parameter: '',
			mode: '',
		};
		vm.external_classes = [];
		vm.count = 0;

		vm.questionaries = [];
		vm.pagegroups = [];
		vm.files = [];
		vm.brands = [];
		vm.events = [];
		vm.contests = [];
		vm.stores = [];

		vm.changeExternalLinkAction = function (noReset) {
			if (!noReset) {
				vm.qr.parameter = '';
				vm.qr.mode = '';
			}

			if (vm.qr.action === 'questionary') {
				$surveys.getQuestionariesList(1, 99999999).then(
					function (questionaries) {
						vm.questionaries = questionaries;
					},
					function () {
						vm.questionaries = [];
					}
				);
			}

			if (vm.qr.action === 'content') {
				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if (vm.qr.action === 'pdf') {
				vm.qr.mode = 'link';

				$media.getFileList(1, 999999, false, 'pdf').then(
					function (files) {
						vm.files = files;
					},
					function () {
						vm.files = [];
					}
				);
			}

			if (vm.qr.action === 'brands') {
				$brands.getList(1, 999999).then(
					function (brands) {
						vm.brands = brands;
					},
					function () {
						vm.brands = [];
					}
				);
			}

			if (vm.qr.action === 'events') {
				$events.getList(1, 999999).then(
					function (events) {
						vm.events = events;
					},
					function () {
						vm.events = [];
					}
				);
			}

			if (vm.qr.action === 'contests') {
				$contests.getList(1, 999999).then(
					function (contests) {
						vm.contests = contests;
					},
					function () {
						vm.contests = [];
					}
				);
			}

			if (vm.qr.action === 'stores') {
				$stores.getList(1, 999999).then(
					function (stores) {
						vm.stores = stores;
					},
					function () {
						vm.stores = [];
					}
				);
			}

			if (vm.qr.action === 'raffle') {
				$raffle.getBackendList().then(
					function (raffles) {
						vm.raffles = raffles;
					},
					function () {
						vm.raffles = [];
					}
				);
			}
		};

		vm.save = function () {
			vm.loading = true;
			$loading.start();

			$qr.editQr(vm.qr).then(
				function () {
					$state.go('app.qr.overview');
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'QR-Code gespeichert!',
						body: 'Der QR-Code wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'QR-Code nicht gespeichert!',
						body: 'Der QR-Code konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		};

		load();

		loadLinkClasses();

		function load() {
			$loading.start();
			$qr.getQr($state.params.id).then(
				function (qr) {
					vm.qr = qr;

					if (vm.qr.action === 'contentgroup') {
						vm.qr.action = 'content';
						vm.qr.parameter = 'pg-' + vm.qr.parameter;
					} else {
						vm.qr.parameter = 'p-' + vm.qr.parameter;
					}

					vm.changeExternalLinkAction(true);
					$loading.finish();
				},
				function () {
					$loading.finish();
					toaster.pop({
						type: 'error',
						title: 'QR-Code nicht gefunden!',
						body: 'Der QR-Code konnte nicht geladen werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		}

		function loadLinkClasses() {
			$externallink.getClasses().then(
				function (external_classes) {
					vm.external_classes = external_classes;
				},
				function () {
					vm.external_classes = [];
				}
			);
		}
	}

	ImageCtrl.$inject = ['$qr', '$uibModalInstance', '$document', 'qrObject'];
	function ImageCtrl($qr, $uibModalInstance, $document, qrObject) {
		var vm = this;

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		vm.imageSrc = function () {
			return globalConfig.api.mediaUrl + '/' + qrObject.mandant_id + '/qr/' + qrObject.id + '.png';
		};

		vm.download = function () {
			var imageSrc = globalConfig.api.mediaUrl + '/' + qrObject.mandant_id + '/qr/' + qrObject.id + '.png';
			var image = fetch(imageSrc);
			var imageBlog = image.blob();
			var imageURL = URL.createObjectURL(imageBlog);

			var link = $document.createElement('a');
			link.href = imageURL;
			link.download = 'qr.png';
			$document.body.appendChild(link);
			link.click();
			$document.body.removeChild(link);
		};
	}
})(angular);

(function (angular) {
	'use strict';
	var api_endpoint = 'qr';

	angular.module('qr.factory', []).factory('$qr', QrsFactory);

	QrsFactory.$inject = ['$q', '$api'];
	function QrsFactory($q, $api) {
		return {
			getQrs: getQrs,
			getQr: getQr,
			newQr: newQr,
			editQr: editQr,
			getImage: getImage,
			removeQr: removeQr,
		};

		function getQrs(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all(api_endpoint)
				.customGETLIST('', customList)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getQr(id) {
			var q = $q.defer(),
				custom = {};

			$api
				.withToken()
				.one(api_endpoint, id)
				.customGET('', custom)
				.then(function (qr) {
					q.resolve(qr.result);
				});

			return q.promise;
		}

		function removeQr(qrId) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, qrId)
				.remove()
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function getImage(qrId) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, qrId)
				.all('image')
				.customGET('', null)
				.then(function (tmpResult) {
					q.resolve(tmpResult);
				});

			return q.promise;
		}

		function newQr(qr) {
			var q = $q.defer(),
				tmpQr = {
					description: qr.description,
					action: qr.action,
					parameter: qr.parameter,
				};

			if (tmpQr.action === 'content') {
				var tmpLink = tmpQr.parameter.split('-');
				tmpQr.parameter = tmpLink[1];
				if (tmpLink[0] === 'pg') {
					tmpQr.action = 'contentgroup';
				}
			}

			$api
				.withToken()
				.all(api_endpoint)
				.post(tmpQr)
				.then(
					function (result) {
						q.resolve(result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function editQr(qr) {
			var q = $q.defer(),
				tmpQr = {
					description: qr.description,
					action: qr.action,
					parameter: qr.parameter,
				};

			if (tmpQr.action === 'content') {
				var tmpLink = tmpQr.parameter.split('-');
				tmpQr.parameter = tmpLink[1];
				if (tmpLink[0] === 'pg') {
					tmpQr.action = 'contentgroup';
				}
			}

			$api
				.withToken()
				.one(api_endpoint, qr.id)
				.customPUT(tmpQr)
				.then(
					function (result) {
						q.resolve(result);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}
	}
})(angular);

(function (angular) {
	'use strict';
	angular.module('raffle', ['raffle.factory']);
})(angular);

(function (angular) {
	'use strict';
	var api_endpoint = 'raffle';

	angular.module('raffle.factory', []).factory('$raffle', RaffleFactory);

	RaffleFactory.$inject = ['$q', '$api'];
	function RaffleFactory($q, $api) {
		return {
			getBackendLogin: getBackendLogin,
			getBackendList: getBackendList,
		};

		function getBackendLogin() {
			var q = $q.defer();
			$api
				.withToken()
				.all(api_endpoint)
				.one('backend', 'login')
				.customGET('')
				.then(
					function (res) {
						q.resolve(res.result);
					},
					function (err) {
						q.reject(err);
					}
				);
			return q.promise;
		}

		function getBackendList() {
			var q = $q.defer();
			$api
				.withToken()
				.all(api_endpoint)
				.one('backend', 'list')
				.customGETLIST('', {})
				.then(
					function (res) {
						q.resolve(res);
					},
					function (err) {
						q.reject(err);
					}
				);
			return q.promise;
		}
	}
})(angular);

/* global angular */

(function(angular) {
	'use strict';

	angular.module('brands', ['brands.factory', 'brands.controller']);

})(angular);

/* global globalConfig, _ */

(function (angular) {
	'use strict';

	angular.module('brands.controller', []).controller('BrandsOverviewController', OverviewCtrl).controller('BrandsNewController', NewCtrl).controller('BrandsCategoriesController', CategoriesCtrl).controller('BrandsAttributesController', AttributesCtrl).controller('BrandsEditController', EditCtrl);

	OverviewCtrl.$inject = ['Page', '$brands', '$loading', '$window', 'toaster', '$state', '$stateParams', '$timeout'];

	function OverviewCtrl(Page, $brands, $loading, $window, toaster, $state, $stateParams, $timeout) {
		var vm = this;
		Page.setTitle('Marken > Übersicht');
		vm.brands = [];
		vm.count = 0;
		vm.activeLetter = false;
		vm.letters = ['#', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'];

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.brandCategories = [];
		vm.brand_category_id = '';

		vm.changePage = function () {
			changeSite();
		};

		vm.changeCategory = function () {
			vm.currentPage = 1;
			vm.activeLetter = false;

			changeSite();
		};

		vm.changeLetter = function (letter) {
			vm.currentPage = 1;
			if (letter === 'all') {
				vm.activeLetter = false;
			} else {
				vm.activeLetter = letter;
			}

			changeSite();
		};

		vm.getCategoryName = function (category_id) {
			if (angular.isDefined(category_id) && category_id !== '' && category_id !== null) {
				if (category_id !== '0') {
					var _find = _.find(vm.brandCategories, { id: category_id });

					if (angular.isDefined(_find)) {
						return _find.name;
					}
				} else {
					return 'keine';
				}
			} else {
				return 'keine';
			}
		};

		vm.changeExternalLinks = function (brandId, externalLinks) {
			$loading.start();
			$brands.saveExternalLinks(brandId, externalLinks).then(
				function () {
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Verlinkung gespeichert!',
						body: 'Die Verlinkung wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.remove = function (brand) {
			var deleteBrand = $window.confirm(brand.title + ' löschen?');

			if (deleteBrand) {
				$loading.start();
				$brands.remove(brand.id).then(
					function () {
						load(vm.currentPage, vm.activeLetter);
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Marke wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Marke konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		loadCategories();
		init();

		function init() {
			if ($stateParams.letter !== '') {
				vm.activeLetter = $stateParams.letter;
			}

			if ($stateParams.category !== '') {
				vm.brand_category_id = $stateParams.category;
			}

			load();
		}

		function load() {
			var letter = 'all';
			if (vm.activeLetter) {
				letter = vm.activeLetter;
			}

			$brands.getList(vm.currentPage, vm.entryLimit, letter, null, vm.brand_category_id).then(
				function (brands) {
					vm.brands = brands;
					vm.count = brands.pagination.total;

					vm.totalItems = brands.pagination.total;
					vm.noOfPages = brands.pagination.pages;

					$window.scrollTo(0, 0);
					$loading.finish();
				},
				function () {
					vm.brands = [];
					vm.count = 0;

					vm.totalItems = 0;
					vm.noOfPages = 0;
					$loading.finish();
				}
			);
		}

		function loadCategories() {
			$brands.getBrandCategories(1, 9999999999).then(function (brandCategories) {
				vm.brandCategories = brandCategories;
			});
		}

		function changeSite() {
			$timeout(function () {
				var tmp = {
					page: vm.currentPage,
					perpage: vm.entryLimit,
				};

				if (vm.activeLetter) {
					tmp.letter = vm.activeLetter;
				} else {
					tmp.letter = '';
				}

				if (vm.brand_category_id !== '') {
					tmp.category = vm.brand_category_id;
				} else {
					tmp.category = '';
				}

				load();
				$state.go('app.brands.overview', tmp, { notify: false });
			}, 500);
		}
	}

	NewCtrl.$inject = ['Page', '$brands', '$window', 'toaster', '$loading', '$state', '$user', '$mandant'];

	function NewCtrl(Page, $brands, $window, toaster, $loading, $state, $user, $mandant) {
		var vm = this;
		Page.setTitle('Marken > Hinzufügen');
		vm.brand = {
			title: '',
			content: '',
			right_key: 'everybody',
			category_id: '',
		};
		vm.external_links = [];
		vm.selectedMedia = {};
		vm.brandCategories = [];
		vm.brandAttributes = [];

		vm.labels = {
			itemsSelected: 'gewählte Merkmale',
			selectAll: 'Alle aktivieren',
			unselectAll: 'Alle deaktivieren',
			search: 'Suchen',
			select: 'Merkmal(e) wählen',
		};

		vm.attributes = {
			enabled: 0,
			attributes: [],
			sendAttributes: [],
		};

		vm.selectMedia = function (media) {
			vm.selectedMedia = media;
		};
		vm.removeMedia = function () {
			vm.selectedMedia = {};
		};
		vm.reloadMedia = function () {
			load();
		};

		vm.addExternalLinks = function () {};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		vm.save = function () {
			vm.loading = true;
			if (angular.isUndefined(vm.selectedMedia.id) || vm.selectedMedia.id == '') {
				if (!$window.confirm('Marke ohne Bild/Video veröffentlichen?')) {
					vm.loading = false;
					return false;
				}
			}

			$loading.start();

			if (vm.moduleActive(23) && vm.attributes.attributes.length > 0) {
				var i = 0,
					l = vm.attributes.attributes.length,
					attributes = [];
				angular.forEach(vm.attributes.attributes, function (attribute) {
					i++;
					attributes.push(parseInt(attribute.id));

					if (l === i) {
						vm.attributes.sendAttributes = attributes;
						next();
					}
				});
			} else {
				next();
			}
		};

		function next() {
			$brands.add(vm.brand, vm.external_links, vm.selectedMedia, vm.attributes.sendAttributes).then(
				function () {
					$state.go('app.brands.overview');
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Marke gespeichert!',
						body: 'Die Marke wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'Marke nicht gespeichert!',
						body: 'Die Marke konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		}

		load();

		function load() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);

			$brands.getBrandCategories(1, 9999999999).then(function (brandCategories) {
				vm.brandCategories = brandCategories;
			});

			$brands.getBrandAttributes(1, 9999999999).then(function (brandAttributes) {
				vm.brandAttributes = brandAttributes;
			});
		}
	}

	CategoriesCtrl.$inject = ['Page', '$brands', 'toaster', '$window', '$loading', '$stateParams', '$state'];

	function CategoriesCtrl(Page, $brands, toaster, $window, $loading, $stateParams, $state) {
		var vm = this;
		Page.setTitle('Marken > Kategorien');
		vm.brandCategories = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			changeSite();
		};

		vm.add = function () {
			var categoryname = $window.prompt('Name der neuen Kategorie:', '');
			if (categoryname !== null) {
				$loading.start();
				$brands.addCategory(categoryname).then(
					function () {
						changeSite();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Kategorie wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Kategorie konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.changeName = function (category) {
			var categoryname = $window.prompt('Geben Sie den neuen Kategorie-Namen an:', category.name);
			if (categoryname !== null) {
				$loading.start();
				$brands.editCategoryName(category.id, categoryname).then(
					function () {
						changeSite();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Name wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Name konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.remove = function (category) {
			var deleteCategory = $window.confirm(category.name + ' löschen?');

			if (deleteCategory) {
				$loading.start();
				$brands.removeCategory(category.id).then(
					function () {
						$loading.finish();
						changeSite();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Kategorie wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Kategorie konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();

		function load() {
			$brands.getBrandCategories(vm.currentPage, vm.entryLimit).then(function (brandCategories) {
				vm.brandCategories = brandCategories;
				vm.count = brandCategories.pagination.total;

				vm.totalItems = brandCategories.pagination.total;
				vm.noOfPages = brandCategories.pagination.pages;
			});
		}

		function changeSite() {
			var tmp = {
				page: vm.currentPage,
				perpage: vm.entryLimit,
			};

			load();
			$state.go('app.brands.categories', tmp, { notify: false });
		}
	}

	AttributesCtrl.$inject = ['Page', '$brands', 'toaster', '$window', '$loading', '$stateParams', '$state'];

	function AttributesCtrl(Page, $brands, toaster, $window, $loading, $stateParams, $state) {
		var vm = this;
		Page.setTitle('Marken > Merkmale');
		vm.brandAttributes = [];
		vm.roles = [];
		vm.count = 0;

		vm.currentPage = $stateParams.page;
		vm.displayItems = [];
		vm.totalItems = 0;
		vm.entryLimit = $stateParams.perpage;
		vm.noOfPages = 1;

		vm.changePage = function () {
			changeSite();
		};

		vm.add = function () {
			var attributename = $window.prompt('Name des neuen Markmals:', '');
			if (attributename !== null) {
				$loading.start();
				$brands.addAttribute(attributename).then(
					function () {
						changeSite();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Merkmal wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Merkmal konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.changeName = function (attribute) {
			var attributename = $window.prompt('Geben Sie den neuen Merkmal-Namen an:', attribute.name);
			if (attributename !== null) {
				$loading.start();
				$brands.editAttributeName(attribute.id, attributename).then(
					function () {
						changeSite();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Merkmal wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Merkmal konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		vm.remove = function (attribute) {
			var deleteAttribute = $window.confirm(attribute.name + ' löschen?');

			if (deleteAttribute) {
				$loading.start();
				$brands.removeAttribute(attribute.id).then(
					function () {
						$loading.finish();
						changeSite();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Merkmal wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Merkmal konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true,
						});
					}
				);
			}
		};

		load();

		function load() {
			$brands.getBrandAttributes(vm.currentPage, vm.entryLimit).then(function (brandAttributes) {
				vm.brandAttributes = brandAttributes;
				vm.count = brandAttributes.pagination.total;

				vm.totalItems = brandAttributes.pagination.total;
				vm.noOfPages = brandAttributes.pagination.pages;
			});
		}

		function changeSite() {
			var tmp = {
				page: vm.currentPage,
				perpage: vm.entryLimit,
			};

			load();
			$state.go('app.brands.attributes', tmp, { notify: false });
		}
	}

	EditCtrl.$inject = ['Page', '$brands', '$window', 'toaster', '$loading', '$state', '$user', '$stateParams', '$mandant'];

	function EditCtrl(Page, $brands, $window, toaster, $loading, $state, $user, $stateParams, $mandant) {
		var vm = this;
		Page.setTitle('Marken > Bearbeiten');
		vm.brandCategories = [];
		vm.brand = {};
		vm.selectedMedia = {};
		vm.media = {};
		vm.showMediaBrowser = false;
		vm.brandAttributes = [];

		vm.labels = {
			itemsSelected: 'gewählte Merkmale',
			selectAll: 'Alle aktivieren',
			unselectAll: 'Alle deaktivieren',
			search: 'Suchen',
			select: 'Merkmal(e) wählen',
		};

		vm.attributes = {
			enabled: 0,
			attributes: [],
			sendAttributes: [],
		};

		vm.addExternalLinks = function () {};

		vm.selectMedia = function (media) {
			var type = '1';
			vm.selectedMedia = media;

			if (angular.isUndefined(media.id)) {
				vm.showMediaBrowser = false;
				vm.brand.title_image_id = 0;
				vm.brand.title_image = {};
			} else {
				vm.brand.title_image_id = media.id;

				if (media.type === '3') {
					type = '3';
					vm.brand.title_image = {
						mandant_id: media.mandant_id,
						content: media.file,
						file: media.file,
						type: type,
					};
				} else {
					vm.brand.title_image = {
						mandant_id: media.mandant_id,
						file: media.file,
						type: type,
					};
				}

				vm.showMediaBrowser = false;
			}
		};
		vm.removeMedia = function () {
			vm.selectedMedia = {};
			vm.brand.title_image_id = '0';
		};
		vm.reloadMedia = function () {
			load();
		};

		vm.save = function () {
			if (vm.moduleActive(23) && vm.attributes.attributes.length > 0) {
				var i = 0,
					l = vm.attributes.attributes.length,
					attributes = [];
				angular.forEach(vm.attributes.attributes, function (attribute) {
					i++;
					attributes.push(attribute.id);

					if (l === i) {
						vm.attributes.sendAttributes = attributes;
						next();
					}
				});
			} else {
				next();
			}
		};

		function next() {
			$brands.edit($stateParams.id, vm.brand, vm.selectedMedia, vm.attributes.sendAttributes).then(
				function () {
					$window.history.back();
					$loading.finish();
					toaster.pop({
						type: 'success',
						title: 'Marke gespeichert!',
						body: 'Die Marke wurde erfolgreich gespeichert.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
					vm.loading = false;
				},
				function () {
					$loading.finish();
					vm.loading = false;
					toaster.pop({
						type: 'error',
						title: 'Marke nicht gespeichert!',
						body: 'Die Marke konnte nicht gespeichert werden! Unbekannter Fehler.',
						timeout: globalConfig.toastTimeout,
						showCloseButton: true,
					});
				}
			);
		}

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		load();

		function load() {
			$brands.getDetail($stateParams.id).then(
				function (brand) {
					vm.brand = brand;
					if (brand.title_image_id !== '0') {
						vm.media = brand.title_image;
						vm.selectedMedia = brand.title_image;
					}

					if (brand.attributes.length > 0) {
						vm.attributes.attributes = brand.attributes;
					}
				},
				function () {
					$state.go('app.brands.overview');
				}
			);

			$brands.getBrandCategories(1, 9999999999).then(function (brandCategories) {
				vm.brandCategories = brandCategories;
			});

			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {}
			);

			$brands.getBrandAttributes(1, 9999999999).then(function (brandAttributes) {
				vm.brandAttributes = brandAttributes;
			});
		}
	}
})(angular);

/* global */

(function (angular) {
	'use strict';
	var api_endpoint = 'brands';

	angular.module('brands.factory', []).factory('$brands', BrandsFactory);

	BrandsFactory.$inject = ['$q', '$api', '$log'];

	function BrandsFactory($q, $api, $log) {
		return {
			getList: getList,
			getDetail: getDetail,
			getBrandCategories: getBrandCategories,
			addCategory: addCategory,
			editCategoryName: editCategoryName,
			removeCategory: removeCategory,

			getBrandAttributes: getBrandAttributes,
			addAttribute: addAttribute,
			editAttributeName: editAttributeName,
			removeAttribute: removeAttribute,

			saveExternalLinks: saveExternalLinks,
			add: add,
			edit: edit,
			remove: remove,
		};

		function getList(page, perpage, letter, fields, category) {
			var q = $q.defer(),
				customList = { with: 'external_links,title_image', sort: '+title' };

			var thenFunction = function (tmpBrands) {
				q.resolve(tmpBrands);
			};

			var rejectFunction = function (error) {
				
				q.reject();
			};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 15;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			if (fields) {
				customList.fields = fields;
			}

			if (category) {
				customList.category_id = category;
			}

			if (angular.isDefined(letter) && letter !== 'all') {
				if (letter === '#') {
					letter = 'other';
				}

				$api.withToken().all(api_endpoint).one('group', letter).customGETLIST('', customList).then(thenFunction, rejectFunction);
			} else {
				$api.withToken().all(api_endpoint).customGETLIST('', customList).then(thenFunction, rejectFunction);
			}

			return q.promise;
		}

		function getDetail(id) {
			var q = $q.defer(),
				customGet = { with: 'external_links,title_image' };

			$api
				.withToken()
				.one(api_endpoint, id)
				.customGET('', customGet)
				.then(
					function (tmpBrand) {
						q.resolve(tmpBrand.result);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getBrandCategories(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all('brands')
				.all('categories')
				.customGETLIST('', customList)
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function addCategory(name) {
			var q = $q.defer();

			$api
				.withToken()
				.all('brands')
				.all('categories')
				.post({ name: name })
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function editCategoryName(categoryId, newName) {
			var q = $q.defer();
			$api
				.withToken()
				.all('brands')
				.one('categories', categoryId)
				.customPUT({ name: newName })
				.then(
					function () {
						q.resolve();
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function removeCategory(categoryId) {
			var q = $q.defer();

			$api
				.withToken()
				.all('brands')
				.one('categories', categoryId)
				.remove()
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function saveExternalLinks(brand_id, external_links) {
			var q = $q.defer(),
				i = 0,
				l = external_links.length,
				linkIds = [];

			if (l > 0) {
				angular.forEach(external_links, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if (l === i) {
						$api
							.withToken()
							.one(api_endpoint, brand_id)
							.customPUT({ external_links: linkIds })
							.then(
								function () {
									q.resolve();
								},
								function (error) {
									
									//q.reject();
								}
							);
					}
				});
			} else {
				$api
					.withToken()
					.one(api_endpoint, brand_id)
					.customPUT({ external_links: [] })
					.then(
						function () {
							q.resolve();
						},
						function (error) {
							
							//q.reject();
						}
					);
			}

			return q.promise;
		}

		function add(brand, externalLinks, media, attributes) {
			var q = $q.defer(),
				tmpBrand = {
					title: brand.title,
					content: brand.content,
					right_key: brand.right_key,
					external_links: [],
				},
				i = 0,
				l = externalLinks.length,
				linkIds = [];

			var save = function () {
				$api
					.withToken()
					.all(api_endpoint)
					.post(tmpBrand)
					.then(
						function () {
							q.resolve();
						},
						function (error) {
							
							q.reject();
						}
					);
			};

			if (angular.isDefined(attributes) && attributes.length > 0) {
				tmpBrand.attributes = attributes;
			} else {
				tmpBrand.attributes = [];
			}

			if (angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpBrand.title_image_id = media.id;
			} else {
				tmpBrand.title_image_id = 0;
			}

			if (brand.category_id !== '') {
				tmpBrand.category_id = brand.category_id;
			}

			if (l > 0) {
				angular.forEach(externalLinks, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if (l === i) {
						tmpBrand.external_links = linkIds;
						save();
					}
				});
			} else {
				save();
			}

			return q.promise;
		}

		function edit(brandId, brand, media, attributes) {
			var q = $q.defer(),
				tmpBrand = {
					title: brand.title,
					content: brand.content,
					right_key: brand.right_key,
				},
				i = 0,
				l = brand.external_links.length,
				linkIds = [];

			var save = function () {
				$api
					.withToken()
					.one(api_endpoint, brandId)
					.customPUT(tmpBrand)
					.then(
						function () {
							q.resolve();
						},
						function (error) {
							
							q.reject();
						}
					);
			};

			if (angular.isDefined(attributes) && attributes.length > 0) {
				tmpBrand.attributes = attributes;
			} else {
				tmpBrand.attributes = [];
			}

			if (angular.isDefined(media) && angular.isDefined(media.id)) {
				tmpBrand.title_image_id = media.id;
			} else {
				tmpBrand.title_image_id = 0;
			}

			if (brand.category_id !== '') {
				tmpBrand.category_id = brand.category_id;
			}

			if (l > 0) {
				angular.forEach(brand.external_links, function (external_link) {
					i++;

					linkIds.push(external_link.id);

					if (l === i) {
						tmpBrand.external_links = linkIds;
						save();
					}
				});
			} else {
				save();
			}

			return q.promise;
		}

		function remove(brandId) {
			var q = $q.defer();

			$api
				.withToken()
				.one(api_endpoint, brandId)
				.remove()
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function (error) {
						
						q.reject();
					}
				);

			return q.promise;
		}

		function getBrandAttributes(page, perpage) {
			var q = $q.defer(),
				customList = {};

			if (perpage) {
				customList.perpage = perpage;
			} else {
				customList.perpage = 5;
			}

			if (page) {
				customList.page = page;
			} else {
				customList.page = 1;
			}

			$api
				.withToken()
				.all('attributes')
				.customGETLIST('', customList)
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function addAttribute(name) {
			var q = $q.defer();

			$api
				.withToken()
				.all('attributes')
				.post({ name: name })
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function editAttributeName(attributeId, newName) {
			var q = $q.defer();
			$api
				.withToken()
				.one('attributes', attributeId)
				.customPUT({ name: newName })
				.then(
					function () {
						q.resolve();
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}

		function removeAttribute(attributeId) {
			var q = $q.defer();

			$api
				.withToken()
				.one('attributes', attributeId)
				.remove()
				.then(
					function (tmpResult) {
						q.resolve(tmpResult);
					},
					function () {
						q.reject();
					}
				);

			return q.promise;
		}
	}
})(angular);

(function (angular) {
	'use strict';

	angular.module('statistics', ['statistics.factory', 'statistics.controller']);
})(angular);

/* global moment */

(function (angular) {
	'use strict';

	angular.module('statistics.controller', []).controller('StatisticsOverviewController', StatisticsOverviewCtrl);

	StatisticsOverviewCtrl.$inject = ['Page', '$window', '$loading', '$statistics', '$filter', '$mandant'];

	function StatisticsOverviewCtrl(Page, $window, $loading, $statistics, $filter, $mandant) {
		var vm = this;
		Page.setTitle('Statistik > Übersicht');

		vm.types = [];
		vm.activeStatistics = [];
		vm.selectedTabObject = {};
		vm.selectedTab = '';
		vm.series = {};
		vm.dataSetOverride = {};

		vm.fromDate = moment().subtract(1, 'days').toDate();
		vm.tillDate = moment().subtract(8, 'days').toDate();

		vm.datePopupFrom = false;
		vm.datePopupTill = false;
		vm.dateOptions = {
			minDate: moment('2019-06-06').toDate(),
			maxDate: moment().subtract(1, 'days').toDate(),
		};

		vm.dateFromOptions = {
			minDate: vm.tillDate,
			maxDate: moment().subtract(1, 'days').toDate(),
		};

		vm.labels = {};

		vm.data = {};

		vm.selectTap = function (tab) {
			vm.selectedTab = tab.id;
			vm.selectedTabObject = tab;
			$statistics.getStats(tab.id, vm.fromDate, vm.tillDate).then(function (stats) {
				buildStats(tab.id, tab.name, tab.chart_type, stats);
			});
		};

		vm.changeDate = function () {
			vm.dateFromOptions.minDate = vm.tillDate;
			vm.selectTap(vm.selectedTabObject);
		};

		vm.moduleActive = function (module_id) {
			return $mandant.checkMandantModule(module_id);
		};

		load();

		function load() {
			$statistics.getTypes().then(function (types) {
				vm.types = types;

				$statistics.getConfigs().then(function (activeStatistics) {
					vm.activeStatistics = activeStatistics;

					vm.selectTap(activeStatistics[0]);
				});
			});
		}

		function buildStats(name, series, chart_type, data) {
			vm.labels[name] = [];
			vm.data[name] = [];
			if (chart_type === 'bar') {
				vm.data[name].push([]);
			}
			vm.series[name] = [series];
			angular.forEach(data, function (stat) {
				vm.labels[name].push($filter('date')($filter('dateToISO')(stat.date), 'dd.MM.yyyy'));
				if (chart_type === 'bar') {
					vm.data[name][0].push(stat.value);
				} else {
					vm.data[name].push(stat.value);
				}
			});

			vm.dataSetOverride = [
				{
					label: '',
					borderWidth: 2,
					type: 'bar',
				},
			];
		}
	}
})(angular);

/* global angular, moment */

(function(angular) {
	'use strict';
	var api_endpoint = 'stats';

	angular.module('statistics.factory', [])
		.factory('$statistics', StatisticsFactory);

	StatisticsFactory.$inject = ['$q', '$api', '$log'];

	function StatisticsFactory($q, $api, $log) {
		return {
			getTypes: getTypes,
			getConfigs: getConfigs,
			getStats: getStats
		};

		function getTypes() {
			var q = $q.defer(),
				customList = {};

			$api.withToken().all(api_endpoint).all('types').customGETLIST('', customList).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}

		function getConfigs() {
			var q = $q.defer(),
				customList = {};

			$api.withToken().all(api_endpoint).all('configurations').customGETLIST('', customList).then(
				function(tmpResult) {
					var result = tmpResult[0];

					result = result['value'].split(',');

					q.resolve(result);
				}
			);

			return q.promise;
		}

		function getStats(type, from, till) {
			var q = $q.defer(),
				customList = {
					'type': type
				};

			customList.date = 'BETWEEN(' + moment(new Date(till).toISOString()).format('YYYY-MM-DD') + ',' + moment(new Date(from).toISOString()).format('YYYY-MM-DD') +')';

			$api.withToken().all(api_endpoint).customGETLIST('', customList).then(
				function(tmpResult) {
					q.resolve(tmpResult);
				}
			);

			return q.promise;
		}
	}

})(angular);

(function(angular) {
	'use strict';

	angular.module('website', ['website.factory', 'website.controller']);

})(angular);

/* global _, globalConfig */

(function (angular) {
	'use strict';

	angular.module('website.controller', [])
		.controller('WebsiteOverviewController', OverviewCtrl)
		.controller('WebsiteModalChangeLinkController', ModalCtrl);

	OverviewCtrl.$inject = ['Page', '$website', '$window', 'toaster', '$user', '$loading', '$location', '$anchorScroll', '$uibModal'];

	function OverviewCtrl(Page, $website, $window, toaster, $user, $loading, $location, $anchorScroll, $uibModal) {
		var vm = this;
		Page.setTitle('Webseite');
		vm.links = [];
		vm.loading = false;

		vm.dragControlListeners = {
			accept: true,
			itemMoved: function () {

			},
			orderChanged: function () {
				savePositions();
			},
			clone: false,
			allowDuplicates: false
		};

		vm.add = function () {
			var linkName = $window.prompt('Geben Sie den Namen des neuen Links an:', '');
			if(linkName !== null && linkName !== '') {
				$loading.start();
				$website.addLink(linkName, vm.links.length).then(
					function () {
						load(true);
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich erstellt!',
							body: 'Link wurde erfolgreich erstellt',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht erstellt!',
							body: 'Link konnte nicht erstellt werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			} else {
				if(linkName === '') {
					vm.add();
				}
			}
		};

		vm.remove = function (link) {
			var deleteLink = $window.confirm(link.name + ' wirklich löschen?');

			if(deleteLink) {
				$loading.start();
				$website.removeLink(link.id).then(
					function () {
						load();
						$loading.finish();
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich gelöscht!',
							body: 'Link wurde erfolgreich gelöscht',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					},
					function () {
						$loading.finish();
						toaster.pop({
							type: 'error',
							title: 'Nicht gelöscht!',
							body: 'Link konnte nicht gelöscht werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			}
		};

		vm.changeRole = function (link_id, new_role) {
			$loading.start();
			$website.saveRole(link_id, new_role).then(
				function () {
					load();
					$loading.finish();
				},
				function(){
					$loading.finish();
				}
			);
		};

		vm.orderLinksByName = function () {
			vm.links = _.orderBy(vm.links, function (input) {
				return input.name.toLowerCase();
			}, ['name'], ['asc']);
			savePositions();
		};

		vm.updateName = function (link) {
			if(link.name !== '') {
				$website.changeName(link.id, link.name).then(
					function () {
						toaster.pop({
							type: 'success',
							title: 'Erfolgreich geändert!',
							body: 'Name wurde erfolgreich geändert.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
						load();
					},
					function () {
						toaster.pop({
							type: 'error',
							title: 'Nicht geändert!',
							body: 'Name konnte nicht geändert werden! Unbekannter Fehler.',
							timeout: globalConfig.toastTimeout,
							showCloseButton: true
						});
					}
				);
			} else {
				toaster.pop({
					type: 'error',
					title: 'Nicht geändert!',
					body: 'Name konnte nicht geändert werden! Der Name darf nicht leer sein.',
					timeout: globalConfig.toastTimeout,
					showCloseButton: true
				});
				load();
			}
		};

		vm.changeIcon = function (link, icon) {
			$loading.start();
			$website.changeIcon(link, icon).then(
				function () {
					load();
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		};

		vm.changeLink = function (link) {
			var modalInstance = $uibModal.open({
				templateUrl: 'static/templates/website/modalChangeLink.html?aves=0e6c1f9d42365ceca0ed0a26cf37ea78',
				controller: 'WebsiteModalChangeLinkController',
				controllerAs: 'vmm',
				resolve: {
					'link': function () {
						return link;
					}
				}
			});

			modalInstance.result.then(
				function (data) {
					$loading.start();
					$website.changeLink(link.id, data.class, data.parameter).then(
						function () {
							load();
							$loading.finish();
							toaster.pop({
								type: 'success',
								title: 'Erfolgreich verschoben!',
								body: 'Link wurde erfolgreich bearbeitet.',
								timeout: globalConfig.toastTimeout,
								showCloseButton: true
							});
						},
						function () {
							$loading.finish();
							toaster.pop({
								type: 'error',
								title: 'Nicht gelöscht!',
								body: 'Link konnte nicht bearbeitet werden! Unbekannter Fehler.',
								timeout: globalConfig.toastTimeout,
								showCloseButton: true
							});
						}
					);
				});
		};

		function savePositions() {
			$loading.start();
			$website.savePositions(vm.links).then(
				function () {
					load();
					$loading.finish();
				},
				function () {
					$loading.finish();
				}
			);
		}

		load();
		loadRoles();

		function load(jumpBottom) {
			$website.getLinks().then(
				function (links) {
					vm.links = links;

					if(jumpBottom) {
						$location.hash('bottom');
						$anchorScroll();
					}
				},
				function () {
					vm.links = [];
				}
			);
		}

		function loadRoles() {
			$user.getRoles(1, 999999).then(
				function (roles) {
					vm.roles = roles;
				},
				function () {

				}
			);
		}
	}

	ModalCtrl.$inject = ['$contentgroup', '$uibModalInstance', '$media', 'link'];

	function ModalCtrl($contentgroup, $uibModalInstance, $media, link) {
		var vm = this;
		vm.classes = [
			{class: 'pdf', description: 'PDF Dokument öffnen'},
			{class: 'content', description: 'Inhaltsseite öffnen'},
			{class: 'news', description: 'News öffnen'}
		];
		vm.pagegroups = [];
		vm.files = [];
		vm.selectedClass = '';
		vm.selectedMode = '';
		vm.parameter = '';

		vm.save = function () {
			$uibModalInstance.close({'class': vm.selectedClass, 'parameter': vm.parameter});
		};

		vm.cancel = function () {
			$uibModalInstance.dismiss('cancel');
		};

		vm.changeClass = function (init) {
			if(!init) {
				vm.selectedMode = '';
				vm.parameter = '';
			}

			if(vm.selectedClass === 'content') {
				if(init) {
					vm.parameter = 'p-' + vm.parameter;
				}

				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if(vm.selectedClass === 'contentgroup') {
				if(init) {
					vm.selectedClass = 'content';
					vm.parameter = 'pg-' + vm.parameter;
				}

				$contentgroup.getGroups(true).then(
					function (groups) {
						vm.pagegroups = groups;
					},
					function () {
						vm.pagegroups = [];
					}
				);
			}

			if(vm.selectedClass === 'pdf') {
				if(validURL(vm.parameter)) {
					vm.selectedMode = 'link';
				} else {
					vm.selectedMode = 'file';
				}

				$media.getFileList(1, 999999, false, 'pdf').then(
					function (files) {
						vm.files = files;
					},
					function () {
						vm.files = [];
					}
				);
			}
			/*
				if(vm.editExternalLink.class === 'brands') {
					$brands.getList(1, 999999).then(
						function (brands) {
							vm.brands = brands;
						},
						function () {
							vm.brands = [];
						}
					);
				}

				if(vm.editExternalLink.class === 'events') {
					$events.getList(1, 999999).then(
						function (events) {
							vm.events = events;
						},
						function () {
							vm.events = [];
						}
					);
				}

				if(vm.editExternalLink.class === 'stores') {
					$stores.getList(1, 999999).then(
						function (stores) {
							vm.stores = stores;
						},
						function () {
							vm.stores = [];
						}
					);
				}

			 */
		};

		function validURL(str) {
			var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
				'((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
				'((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
				'(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
				'(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
				'(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
			return !!pattern.test(str);
		}

		load();

		function load() {
			vm.selectedClass = link.link;
			if(link.parameter !== 'NULL'){
				vm.parameter = link.parameter;
			}

			vm.changeClass(true);
		}
	}

})(angular);

(function (angular) {
	'use strict';

	angular.module('website.factory', [])
		.factory('$website', WebsiteFactory);

	WebsiteFactory.$inject = ['$q', '$api', '$log'];

	function WebsiteFactory($q, $api, $log) {
		return {
			getLinks: getLinks,
			addLink: addLink,
			removeLink: removeLink,
			saveRole: saveRole,
			changeName: changeName,
			changeIcon: changeIcon,
			changeLink: changeLink,
			savePositions: savePositions
		};

		function getLinks() {
			var q = $q.defer(),
				pagesList = {'sort': '+position'};


			$api.withToken().all('websitelinks').customGETLIST('', pagesList).then(
				function (pages) {
					q.resolve(pages);
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function addLink(name, position) {
			var q = $q.defer(),
				tmpPage = {
					name: name,
					icon: 'link',
					link: 'nothing',
					right_key: 'everybody',
					position: (position + 1).toString()
				};

			$api.withToken().all('websitelinks').post(tmpPage).then(
				function () {
					q.resolve();
				},
				function (error) {
					
					q.reject();
				}
			);

			return q.promise;
		}

		function removeLink(link_id) {
			var q = $q.defer();

			$api.withToken().one('websitelinks', link_id).remove().then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function saveRole(link_id, right_key) {
			var q = $q.defer();
			$api.withToken().one('websitelinks', link_id).customPUT({right_key: right_key}).then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function changeName(link_id, newName) {
			var q = $q.defer();
			$api.withToken().one('websitelinks', link_id).customPUT({name: newName}).then(
				function () {
					q.resolve();
				}
			);

			return q.promise;
		}

		function changeIcon(link_id, newIcon) {
			var q = $q.defer();
			$api.withToken().one('websitelinks', link_id).customPUT({icon: newIcon}).then(
				function () {
					q.resolve();
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}

		function changeLink(link_id, link, parameter) {
			var q = $q.defer(),
				customPut = {
					link: link,
					parameter: parameter
				};

			if(customPut.link === 'content'){
				var tmpLink = customPut.parameter.split('-');
				customPut.parameter = tmpLink[1];
				if(tmpLink[0] === 'pg'){
					customPut.link = 'contentgroup';
				}
			}

			$api.withToken().one('websitelinks', link_id).customPUT(customPut).then(
				function () {
					q.resolve();
				},
				function(){
					q.reject();
				}
			);

			return q.promise;
		}

		function savePositions(links) {
			var q = $q.defer(),
				i = 0,
				l = links.length;

			function resolve() {
				if(l === i) {
					q.resolve();
				}
			}

			angular.forEach(links, function (link) {
				i++;

				$api.withToken().one('websitelinks', link.id).customPUT({position: i.toString()}).then(
					function () {
						resolve();
					}
				);

			});

			return q.promise;
		}

	}

})(angular);
